// GENERATED by scripts/build-transactions.mjs from research/raw/history-*.json.
// Control-sale history per team from formation. price: nominal USD, null when unknown.
export const saleHistory = {
  "new-york-yankees": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Baltimore Orioles (AL) ownership; John McGraw manager/part-owner",
      "notes": "AL charter franchise in Baltimore (1901-02); franchise moved to New York 1903. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1903,
        "price": 18000,
        "buyer": "Frank Farrell & William Devery",
        "seller": "American League (defunct Baltimore franchise)",
        "stakePct": 100,
        "notes": "Bought the defunct Baltimore AL franchise and moved it to Manhattan (Highlanders).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_New_York_Yankees_owners_and_executives"
        ]
      },
      {
        "year": 1915,
        "price": 460000,
        "buyer": "Jacob Ruppert & Tillinghast L. Huston",
        "seller": "Frank Farrell & William Devery",
        "stakePct": 100,
        "notes": "Widely cited $460,000; SABR notes Huston papers give $463,000.",
        "isEstimated": false,
        "sources": [
          "https://thisdayinbaseball.com/1915-jacob-ruppert-and-tillinghast-lhommedieu-huston-buy-the-new-york-yankees-from-frank-farrell-and-bill-devery-for-460000-ruppert-who-ow/",
          "https://sabr.org/bioproj/topic/new-york-yankees-team-ownership-history/"
        ]
      },
      {
        "year": 1923,
        "price": 1250000,
        "buyer": "Jacob Ruppert (sole owner)",
        "seller": "Tillinghast L. Huston (50%)",
        "stakePct": 50,
        "notes": "Buyout of Huston's half, finalized May 1923. Press reported $1.25M; SABR puts negotiated price at $1.175M ($450K cash + notes).",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-yankees-team-ownership-history/",
          "https://en.wikipedia.org/wiki/List_of_New_York_Yankees_owners_and_executives"
        ]
      },
      {
        "year": 1939,
        "price": null,
        "buyer": "Jacob Ruppert estate",
        "seller": "Jacob Ruppert (died Jan 1939)",
        "stakePct": 100,
        "notes": "inheritance; estate controlled club until 1945 sale",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-yankees-team-ownership-history/"
        ]
      },
      {
        "year": 1945,
        "price": 2800000,
        "buyer": "Dan Topping, Del Webb & Larry MacPhail",
        "seller": "Jacob Ruppert estate",
        "stakePct": 96.88,
        "notes": "Bought 96.88% for ~$2.8M in Jan 1945 (remaining 3.12% in March); estate needed cash for taxes. Some accounts cite $2.89M total.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/person/dan-topping/",
          "https://bronxpinstripes.com/yankees/history/topping-webb-macphail-buy-yankees-1945"
        ]
      },
      {
        "year": 1964,
        "price": 11200000,
        "buyer": "CBS (Columbia Broadcasting System)",
        "seller": "Dan Topping & Del Webb",
        "stakePct": 80,
        "notes": "CBS bought 80% for $11.2M (agreed Aug 14, 1964); Topping and Webb kept 10% each and sold later (Webb 1965 for $1.4M, Topping 1966).",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/person/dan-topping/",
          "https://sabr.org/bioproj/topic/new-york-yankees-team-ownership-history/"
        ]
      },
      {
        "year": 1973,
        "price": 10000000,
        "buyer": "George Steinbrenner-led group (12 investors)",
        "seller": "CBS",
        "stakePct": 100,
        "notes": "Announced Jan 3, 1973. $10M included two parking garages CBS bought back for $1.2M, so net ~$8.8M. Steinbrenner initially held under 2% and increased his stake over time.",
        "isEstimated": false,
        "sources": [
          "https://www.history.com/this-day-in-history/january-3/yankees-george-steinbrenner-mlb-owners",
          "https://sabr.org/bioproj/topic/new-york-yankees-team-ownership-history/"
        ]
      },
      {
        "year": 2010,
        "price": null,
        "buyer": "Hal Steinbrenner (Steinbrenner family / Yankee Global Enterprises)",
        "seller": "George Steinbrenner (died July 2010)",
        "stakePct": 100,
        "notes": "inheritance; Hal became managing general partner/control person in 2008; no outside sale",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_New_York_Yankees_owners_and_executives"
        ]
      }
    ]
  },
  "boston-red-sox": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Charles Somers (with Joseph C. Pelletier as early front)",
      "notes": "AL charter franchise (Boston Americans). Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1903,
        "price": null,
        "buyer": "Henry Killilea",
        "seller": "Charles Somers",
        "stakePct": 100,
        "notes": "Price not stated in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Boston_Red_Sox_owners_and_executives",
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/"
        ]
      },
      {
        "year": 1904,
        "price": 145000,
        "buyer": "Gen. Charles H. Taylor (Boston Globe publisher; son John I. Taylor ran club)",
        "seller": "Henry Killilea",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/"
        ]
      },
      {
        "year": 1911,
        "price": 150000,
        "buyer": "Jimmy McAleer & Robert McRoy (with Ban Johnson-arranged investors)",
        "seller": "Taylor family (half interest)",
        "stakePct": 50,
        "notes": "Half-interest sale; Taylors kept 50%, so control was shared.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/"
        ]
      },
      {
        "year": 1913,
        "price": 200000,
        "buyer": "Joseph Lannin",
        "seller": "Jimmy McAleer / Robert McRoy (half interest)",
        "stakePct": 50,
        "notes": "Lannin then bought the Taylors' half in 1914 to become sole owner (price for that half not captured).",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/"
        ]
      },
      {
        "year": 1916,
        "price": 662000,
        "buyer": "Harry Frazee & Hugh Ward",
        "seller": "Joseph Lannin",
        "stakePct": 100,
        "notes": "Nov 1916. $662K for the club ($400K cash + $262K note); total capital obligation incl. Fenway Park about $1M.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/",
          "https://sabr.org/bioproj/person/harry-frazee/"
        ]
      },
      {
        "year": 1923,
        "price": 1150000,
        "buyer": "Bob Quinn-led group (Columbus investors incl. Palmer Winslow)",
        "seller": "Harry Frazee",
        "stakePct": 100,
        "notes": "Aug 1923.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/person/bob-quinn/",
          "https://en.wikipedia.org/wiki/Bob_Quinn_(baseball,_born_1870)"
        ]
      },
      {
        "year": 1933,
        "price": 1250000,
        "buyer": "Tom Yawkey",
        "seller": "Bob Quinn group",
        "stakePct": 100,
        "notes": "Feb 25, 1933; price included Fenway Park.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/",
          "https://thisdayinbaseball.com/tom-yawkey-buys-the-boston-red-sox-from-robert-quinn/"
        ]
      },
      {
        "year": 1976,
        "price": null,
        "buyer": "Jean R. Yawkey / Yawkey estate",
        "seller": "Tom Yawkey (died July 1976)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Boston_Red_Sox_owners_and_executives"
        ]
      },
      {
        "year": 1978,
        "price": 20500000,
        "buyer": "Buddy LeRoux, Haywood Sullivan & Jean Yawkey (general partners)",
        "seller": "Tom Yawkey estate",
        "stakePct": 100,
        "notes": "Sale announced Sept 1977 (reported $15M), approved May 23, 1978. SABR: $15M from 30 limited-partner shares plus ballpark valued at $5.5M = $20.5M; The Sporting News headline said $20.2M.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-red-sox-team-ownership-history/",
          "https://www.bostonglobe.com/sports/1978/05/24/red-sox-sold-group-led-jean-yawkey/5GIRVPlX2uH4Tuupt9cCKJ/story.html"
        ]
      },
      {
        "year": 1992,
        "price": null,
        "buyer": "JRY Trust (John Harrington, CEO)",
        "seller": "Jean R. Yawkey (died Feb 1992)",
        "stakePct": 100,
        "notes": "inheritance; Trust bought out Haywood Sullivan in Nov 1993",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Boston_Red_Sox_owners_and_executives",
          "https://en.wikipedia.org/wiki/JRY_Trust"
        ]
      },
      {
        "year": 2002,
        "price": 660000000,
        "buyer": "John Henry, Tom Werner & Larry Lucchino (New England Sports Ventures, now Fenway Sports Group)",
        "seller": "JRY Trust (Yawkey Trust, ~54%) and limited partners",
        "stakePct": 100,
        "notes": "Agreed Dec 2001, approved Jan 16, 2002, closed Feb 27, 2002. $660M plus ~$40M assumed debt (~$700M total); included Fenway Park and 80% of NESN.",
        "isEstimated": false,
        "sources": [
          "http://www.espn.com/mlb/news/2002/0227/1341320.html",
          "https://pbn.com/red-sox-sold-to-henrys-group-for-record-700m8088/"
        ]
      }
    ]
  },
  "toronto-blue-jays": {
    "formation": {
      "year": 1976,
      "price": 7000000,
      "founder": "Labatt Breweries (45%), Howard Webster / Imperial Trust (45%), CIBC (10%)",
      "notes": "AL expansion franchise awarded 1976 (began play 1977); SABR says Labatt was awarded the franchise for US$7 million.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": 67500000,
        "buyer": "Labatt Breweries (to 90%)",
        "seller": "Howard Webster (45%)",
        "stakePct": 45,
        "notes": "Nov 1, 1991. SABR reports $67.5M without naming the currency (likely CAD; not converted). This was a 45% stake that gave Labatt sole control.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/toronto-blue-jays-team-ownership-history/"
        ]
      },
      {
        "year": 1995,
        "price": null,
        "buyer": "Interbrew (Belgium)",
        "seller": "Labatt shareholders (indirect)",
        "stakePct": 90,
        "notes": "Interbrew took over Labatt, the club's 90% owner, so control of the Blue Jays moved through a corporate takeover. Not a direct sale of the team.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/toronto-blue-jays-team-ownership-history/"
        ]
      },
      {
        "year": 2000,
        "price": null,
        "buyer": "Rogers Communications",
        "seller": "Interbrew (70%) and CIBC (10%)",
        "stakePct": 80,
        "notes": "Sept 2000: 80% bought. SABR states $165 million without naming the currency (widely reported in CAD), so price left null. Rogers bought the remaining 20% in 2004 after Interbrew became InBev.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/toronto-blue-jays-team-ownership-history/"
        ]
      }
    ]
  },
  "tampa-bay-rays": {
    "formation": {
      "year": 1995,
      "price": 130000000,
      "founder": "Vince Naimoli-led group",
      "notes": "Expansion franchise awarded March 1995 (began play 1998). MLB raised the fee from $110M to $130M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2004,
        "price": 65000000,
        "buyer": "Stuart Sternberg (general partnership)",
        "seller": "Naimoli-era partnership",
        "stakePct": 48,
        "notes": "May 2004: Sternberg bought a 48% stake for $65M. He took control in Oct 2005 after reportedly paying Naimoli ~$5M to become controlling general partner.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/tampa-bay-rays-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Tampa_Bay_Rays"
        ]
      },
      {
        "year": 2025,
        "price": 1700000000,
        "buyer": "Patrick Zalupski-led group (Dream Finders Homes founder)",
        "seller": "Stuart Sternberg group",
        "stakePct": 100,
        "notes": "Reported deal July 2025; MLB owners approved unanimously in Sept 2025; closed Sept 30, 2025. Widely reported price ~$1.7B, not officially disclosed.",
        "isEstimated": true,
        "sources": [
          "https://www.mlb.com/news/rays-sale-finalized-to-ownership-group-led-by-patrick-zalupski",
          "https://www.sportico.com/leagues/baseball/2025/tampa-bay-rays-sale-mlb-patrick-zalupski-1234871544/",
          "https://www.espn.com/mlb/story/_/id/46349044/mlb-owners-ok-sale-rays-group-headed-patrick-zalupski",
          "https://www.cbssports.com/mlb/news/tampa-bay-rays-sale-mlb-owners-unanimously-approve-patrick-zalupski-deal-reportedly-worth-1-7-billion"
        ]
      }
    ]
  },
  "baltimore-orioles": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Henry & Matthew Killilea (Milwaukee Brewers, AL)",
      "notes": "AL charter franchise in Milwaukee (1901); moved to St. Louis as the Browns in 1902 and to Baltimore in 1954.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1902,
        "price": 50000,
        "buyer": "Robert Lee Hedges (majority) with minority partners",
        "seller": "Matthew Killilea & Fred Gross",
        "stakePct": 100,
        "notes": "Moved to St. Louis. St. Louis Republic (Jan 28, 1902) put the price \"in the range of $50,000\".",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/"
        ]
      },
      {
        "year": 1916,
        "price": 525000,
        "buyer": "Phil Ball (with Otto Stifel)",
        "seller": "Robert Hedges",
        "stakePct": 100,
        "notes": "Jan 1916. Reports ranged from $425,000 to $525,000.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/"
        ]
      },
      {
        "year": 1933,
        "price": null,
        "buyer": "Phil Ball estate",
        "seller": "Phil Ball (died Oct 1933)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/"
        ]
      },
      {
        "year": 1936,
        "price": 325000,
        "buyer": "Donald Lee Barnes syndicate (with Bill DeWitt)",
        "seller": "Phil Ball estate",
        "stakePct": 100,
        "notes": "Nov 1936. Part of the money came from a public stock offering.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Donald_Lee_Barnes"
        ]
      },
      {
        "year": 1944,
        "price": null,
        "buyer": "Richard Muckerman",
        "seller": "Donald Barnes",
        "stakePct": 100,
        "notes": "Muckerman got majority control in 1944-45. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Baltimore_Orioles",
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/"
        ]
      },
      {
        "year": 1949,
        "price": 1000000,
        "buyer": "Bill & Charles DeWitt",
        "seller": "Richard Muckerman",
        "stakePct": 100,
        "notes": "Bought with ~$1M in notes; \"approximately $1 million\" per SABR.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Bill_DeWitt"
        ]
      },
      {
        "year": 1951,
        "price": 1750000,
        "buyer": "Bill Veeck syndicate (~80%)",
        "seller": "Bill & Charles DeWitt",
        "stakePct": 80,
        "notes": "July 1951. Contemporary accounts put the purchase at $1.75M.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/"
        ]
      },
      {
        "year": 1953,
        "price": 2400000,
        "buyer": "Baltimore group led by Clarence Miles (incl. Jerold Hoffberger)",
        "seller": "Bill Veeck syndicate",
        "stakePct": 100,
        "notes": "Moved to Baltimore for 1954. Baltimore investors met Veeck's $2.4M asking price for his interest. Some accounts give ~$2.5M.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-browns-team-ownership-history/",
          "https://en.wikipedia.org/wiki/History_of_the_Baltimore_Orioles"
        ]
      },
      {
        "year": 1979,
        "price": 12000000,
        "buyer": "Edward Bennett Williams",
        "seller": "Jerold Hoffberger",
        "stakePct": 100,
        "notes": "Agreement signed Aug 2, 1979.",
        "isEstimated": false,
        "sources": [
          "https://www.washingtonpost.com/archive/politics/1979/08/03/hoffberger-sells-orioles-to-williams/b8b2e662-ef0a-478b-9243-7c799e9e1caf/",
          "https://en.wikipedia.org/wiki/Edward_Bennett_Williams"
        ]
      },
      {
        "year": 1988,
        "price": 70000000,
        "buyer": "Eli Jacobs (with Larry Lucchino, Sargent Shriver)",
        "seller": "Edward Bennett Williams estate",
        "stakePct": 100,
        "notes": "Announced Dec 5, 1988; AL approved Apr 18, 1989.",
        "isEstimated": false,
        "sources": [
          "https://www.upi.com/Archives/1988/12/08/New-York-investor-Eli-Jacobs-the-new-majority-owner/5417597560400/",
          "https://en.wikipedia.org/wiki/Eli_Jacobs"
        ]
      },
      {
        "year": 1993,
        "price": 173000000,
        "buyer": "Peter Angelos-led group",
        "seller": "Eli Jacobs (bankruptcy auction)",
        "stakePct": 100,
        "notes": "Oct 4, 1993, via bankruptcy-court auction; highest price paid for a sports franchise at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Peter_Angelos",
          "https://en.wikipedia.org/wiki/History_of_the_Baltimore_Orioles"
        ]
      },
      {
        "year": 2024,
        "price": 1725000000,
        "buyer": "David Rubenstein-led group",
        "seller": "Angelos family (John & Louis Angelos)",
        "stakePct": 100,
        "notes": "Agreement Jan 2024. MLB approved unanimously Mar 27, 2024 (initial ~40% stake plus control). The group bought the remainder and took full ownership Aug 1, 2024. Valuation $1.725B.",
        "isEstimated": false,
        "sources": [
          "https://www.nbcwashington.com/mlb/baltimore-orioles-sale-david-rubenstein-new-owner/3577489/",
          "https://www.mlb.com/news/orioles-ownership-deal-closes",
          "https://www.sportico.com/leagues/baseball/2024/orioles-rubenstein-mlb-team-sale-1234772774/"
        ]
      }
    ]
  },
  "chicago-white-sox": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Charles Comiskey",
      "notes": "Comiskey moved his Western/American League St. Paul club to Chicago in 1900; AL became major in 1901. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1931,
        "price": null,
        "buyer": "J. Louis Comiskey",
        "seller": "Charles Comiskey (died Oct 1931)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Chicago_White_Sox_owners_and_executives"
        ]
      },
      {
        "year": 1940,
        "price": null,
        "buyer": "Grace Comiskey",
        "seller": "J. Louis Comiskey (died 1939)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Chicago_White_Sox_owners_and_executives"
        ]
      },
      {
        "year": 1956,
        "price": null,
        "buyer": "Dorothy Comiskey Rigney & Chuck Comiskey",
        "seller": "Grace Comiskey (died 1956)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Chicago_White_Sox_owners_and_executives"
        ]
      },
      {
        "year": 1959,
        "price": null,
        "buyer": "Bill Veeck-led group",
        "seller": "Dorothy Comiskey Rigney (controlling interest)",
        "stakePct": 100,
        "notes": "Veeck's group bought controlling interest in 1959. Price not confirmed in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Veeck"
        ]
      },
      {
        "year": 1961,
        "price": 2500000,
        "buyer": "Arthur Allyn Jr. & John Allyn",
        "seller": "Bill Veeck",
        "stakePct": 100,
        "notes": "Veeck sold his share for health reasons.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Veeck"
        ]
      },
      {
        "year": 1969,
        "price": null,
        "buyer": "John Allyn (sole owner)",
        "seller": "Arthur Allyn Jr.",
        "stakePct": 100,
        "notes": "Brother buyout; price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Chicago_White_Sox_owners_and_executives",
          "https://en.wikipedia.org/wiki/Bill_Veeck"
        ]
      },
      {
        "year": 1975,
        "price": null,
        "buyer": "Bill Veeck-led group",
        "seller": "John Allyn",
        "stakePct": 100,
        "notes": "Veeck bought the team back in Dec 1975, heading off a proposed move to Seattle. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Veeck"
        ]
      },
      {
        "year": 1981,
        "price": 20000000,
        "buyer": "Jerry Reinsdorf & Eddie Einhorn group",
        "seller": "Bill Veeck group",
        "stakePct": 100,
        "notes": "Reinsdorf remains control person (sole principal from 2017 listing). June 2025: Justin Ishbia agreed a framework to take control after 2029. That is not a completed control change as of Sept 2026, so it is not listed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Veeck",
          "https://en.wikipedia.org/wiki/Justin_Ishbia"
        ]
      }
    ]
  },
  "cleveland-guardians": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Charles W. Somers & Jack Kilfoyl",
      "notes": "AL charter franchise (Blues/Naps/Indians/Guardians). Founding price unknown; the owners bought League Park for $10,000.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1916,
        "price": 500000,
        "buyer": "Jim Dunn-led Chicago syndicate",
        "seller": "Charles Somers",
        "stakePct": 100,
        "notes": "Price tag was $500,000; Dunn relied on loans from Ban Johnson and Charles Comiskey.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1922,
        "price": null,
        "buyer": "Dunn estate (Edith Dunn)",
        "seller": "Jim Dunn (died 1922)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives"
        ]
      },
      {
        "year": 1927,
        "price": 1000000,
        "buyer": "Alva Bradley syndicate",
        "seller": "Dunn estate",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1946,
        "price": 1539000,
        "buyer": "Bill Veeck syndicate",
        "seller": "Alva Bradley group",
        "stakePct": 100,
        "notes": "Closed June 22, 1946.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1949,
        "price": 2200000,
        "buyer": "Ellis W. Ryan syndicate",
        "seller": "Bill Veeck syndicate",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1953,
        "price": null,
        "buyer": "Myron H. Wilson (control within shareholder group)",
        "seller": "Ellis Ryan",
        "stakePct": 100,
        "notes": "Change of control within the local shareholder group; no outside sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives"
        ]
      },
      {
        "year": 1956,
        "price": null,
        "buyer": "William R. Daley (control within group)",
        "seller": "Myron H. Wilson",
        "stakePct": 100,
        "notes": "Daley and other directors bought out Greenberg and the Baxters at $400/share. No full-franchise price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1963,
        "price": null,
        "buyer": "Gabe Paul-led group",
        "seller": "William R. Daley",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives"
        ]
      },
      {
        "year": 1966,
        "price": 8000000,
        "buyer": "Vernon Stouffer (80%)",
        "seller": "William R. Daley group",
        "stakePct": 80,
        "notes": "Aug 1966: $5.5M cash for 80% plus a $2.5M assumed bank loan.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1972,
        "price": 9750000,
        "buyer": "Nick Mileti syndicate",
        "seller": "Vernon Stouffer",
        "stakePct": 100,
        "notes": "March 1972 offer of $9.75M to buy the club and keep it in Cleveland.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "Ted Bonda (control within Mileti group)",
        "seller": "Nick Mileti",
        "stakePct": 100,
        "notes": "Interim control shift; no outside sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "Steve O'Neill-led group",
        "seller": "Ted Bonda / Mileti group",
        "stakePct": 100,
        "notes": "Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives",
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Steve O'Neill estate",
        "seller": "Steve O'Neill (died 1983)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 1986,
        "price": 35500000,
        "buyer": "Richard & David Jacobs",
        "seller": "Steve O'Neill estate and other owners",
        "stakePct": 100,
        "notes": "The Jacobs brothers bought out all owners and assumed debts (SABR: $35.5M; Wikipedia: $35M).",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Larry_Dolan"
        ]
      },
      {
        "year": 2000,
        "price": 323000000,
        "buyer": "Larry Dolan (family trust)",
        "seller": "Richard E. Jacobs (public company since 1998)",
        "stakePct": 100,
        "notes": "Included buying back publicly traded stock. Wikipedia says $323M; SABR says $320M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Larry_Dolan",
          "https://sabr.org/bioproj/topic/cleveland-guardians-team-ownership-history/"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Paul Dolan (Dolan family)",
        "seller": "Larry Dolan (died Feb 23, 2025)",
        "stakePct": 100,
        "notes": "inheritance; Paul Dolan had been chairman/CEO since 2013 and is now controlling owner. Minority sale to David Blitzer (2022) was not a control change",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Larry_Dolan",
          "https://en.wikipedia.org/wiki/List_of_Cleveland_Guardians_owners_and_executives"
        ]
      }
    ]
  },
  "detroit-tigers": {
    "formation": {
      "year": 1894,
      "price": null,
      "founder": "George Vanderbeck",
      "notes": "Western League club from 1894; AL charter member when the league went major in 1901. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1901,
        "price": null,
        "buyer": "James D. Burns",
        "seller": "George Vanderbeck",
        "stakePct": 100,
        "notes": "Price not stated.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives"
        ]
      },
      {
        "year": 1902,
        "price": null,
        "buyer": "Samuel F. Angus",
        "seller": "James D. Burns",
        "stakePct": 100,
        "notes": "Price not stated.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives"
        ]
      },
      {
        "year": 1904,
        "price": null,
        "buyer": "William H. Yawkey",
        "seller": "Samuel F. Angus",
        "stakePct": 100,
        "notes": "Frank Navin brokered the deal and became a partner in 1908. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives",
          "https://en.wikipedia.org/wiki/William_H._Yawkey"
        ]
      },
      {
        "year": 1919,
        "price": null,
        "buyer": "Frank Navin (with Walter Briggs & John Kelsey)",
        "seller": "William Yawkey estate",
        "stakePct": 50,
        "notes": "After Yawkey died, Navin bought more stock from the estate and reached 50%.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/William_H._Yawkey",
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives"
        ]
      },
      {
        "year": 1935,
        "price": null,
        "buyer": "Walter Briggs Sr. (sole control)",
        "seller": "Frank Navin estate",
        "stakePct": 100,
        "notes": "Navin died in 1935; Briggs bought his interest. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives",
          "https://en.wikipedia.org/wiki/Walter_Briggs_Sr."
        ]
      },
      {
        "year": 1952,
        "price": null,
        "buyer": "Walter \"Spike\" Briggs Jr.",
        "seller": "Walter Briggs Sr. (died Jan 1952)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives"
        ]
      },
      {
        "year": 1956,
        "price": null,
        "buyer": "Fred Knorr & John Fetzer syndicate",
        "seller": "Briggs family",
        "stakePct": 100,
        "notes": "Price not confirmed in sources consulted. Fetzer became sole principal owner around 1960-61.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives",
          "https://en.wikipedia.org/wiki/John_Fetzer"
        ]
      },
      {
        "year": 1983,
        "price": 53000000,
        "buyer": "Tom Monaghan (Domino's founder)",
        "seller": "John Fetzer",
        "stakePct": 100,
        "notes": "Late 1983.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Detroit_Tigers"
        ]
      },
      {
        "year": 1992,
        "price": null,
        "buyer": "Mike Ilitch (Little Caesars founder)",
        "seller": "Tom Monaghan",
        "stakePct": 100,
        "notes": "Price commonly reported as ~$82-85M but not confirmed in sources consulted, so left null.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mike_Ilitch",
          "https://en.wikipedia.org/wiki/Tom_Monaghan"
        ]
      },
      {
        "year": 2017,
        "price": null,
        "buyer": "Christopher Ilitch / Ilitch Holdings",
        "seller": "Mike Ilitch (died Feb 2017)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/List_of_Detroit_Tigers_owners_and_executives"
        ]
      }
    ]
  },
  "kansas-city-royals": {
    "formation": {
      "year": 1968,
      "price": 6000000,
      "founder": "Ewing Kauffman",
      "notes": "AL expansion franchise awarded Jan 1968 (began play 1969). SABR: initial cost roughly $6M, made up of $5.25M for expansion-draft players, $50,000 for franchise rights and ~$600K to the pension fund.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1993,
        "price": null,
        "buyer": "Kauffman succession plan (board / Greater Kansas City Community Foundation)",
        "seller": "Ewing Kauffman (died Aug 1993)",
        "stakePct": 100,
        "notes": "inheritance-like transfer: Kauffman's succession plan put the team under a board and foundation until it was sold to local ownership. Not a sale.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/kansas-city-royals-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Ewing_Kauffman"
        ]
      },
      {
        "year": 2000,
        "price": 96000000,
        "buyer": "David Glass",
        "seller": "Kauffman estate / Greater Kansas City Community Foundation",
        "stakePct": 100,
        "notes": "Apr 18, 2000. Board picked Glass over a higher Miles Prentice bid ($115-120M) that MLB rejected.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/David_Glass_(businessman)",
          "https://en.wikipedia.org/wiki/Kansas_City_Royals",
          "https://sabr.org/bioproj/topic/kansas-city-royals-team-ownership-history/"
        ]
      },
      {
        "year": 2019,
        "price": 1000000000,
        "buyer": "John Sherman-led group",
        "seller": "David Glass family",
        "stakePct": 100,
        "notes": "Announced Aug 30, 2019; approved Nov 21, 2019. Reported at about or over $1B.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/John_Sherman_(businessman)",
          "https://en.wikipedia.org/wiki/Kansas_City_Royals"
        ]
      }
    ]
  },
  "minnesota-twins": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Ban Johnson & Fred Postal (Washington Senators)",
      "notes": "AL charter franchise in Washington; moved to Minnesota in 1961. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1904,
        "price": null,
        "buyer": "Thomas C. Noyes group",
        "seller": "Postal / AL interests",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Carl_Pohlad"
        ]
      },
      {
        "year": 1919,
        "price": null,
        "buyer": "Clark Griffith (with William Richardson)",
        "seller": "Noyes/Minor-era stockholders",
        "stakePct": 100,
        "notes": "Griffith bought a 10% stake in 1912 for $27,000 and got controlling interest around 1919-20. Price for control not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Calvin_Griffith",
          "https://sabr.org/bioproj/topic/washington-senators-i-team-ownership-history/"
        ]
      },
      {
        "year": 1955,
        "price": null,
        "buyer": "Calvin Griffith (with Thelma Griffith Haynes)",
        "seller": "Clark Griffith (died Oct 1955)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Calvin_Griffith"
        ]
      },
      {
        "year": 1984,
        "price": 43500000,
        "buyer": "Carl Pohlad",
        "seller": "Calvin Griffith & Thelma Haynes (52%); H. Gabriel Murphy (40.4%)",
        "stakePct": 100,
        "notes": "Aug 1984: $32M for the Griffiths' controlling 52% plus $11.5M for Murphy's 40.4%. SABR says the Griffith shares were bought over time for $24M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Carl_Pohlad",
          "https://en.wikipedia.org/wiki/Calvin_Griffith",
          "https://sabr.org/bioproj/topic/minnesota-twins-team-ownership-history/"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Jim Pohlad (Pohlad family)",
        "seller": "Carl Pohlad (died Jan 2009)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Carl_Pohlad"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Tom Pohlad (control person, Pohlad family)",
        "seller": "Joe Pohlad (previous control person)",
        "stakePct": null,
        "notes": "Not a sale. The family explored a sale (announced Oct 2024) and ended it in Aug 2025. It instead sold non-controlling stakes to Glick Family Investments, a George Hicks-led Minnesota group and Craig Leipold, and moved control within the family from Joe to Tom Pohlad. I found no 2026 control sale.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/mlb/story/_/id/47336092/twins-finalize-sales-name-tom-pohlad-new-controlling-owner",
          "https://www.mlb.com/news/pohlad-family-to-remain-principal-owner-of-twins",
          "https://www.startribune.com/minnesota-twins-owners-tom-joe-pohlad-limited-partners-glick-leipold-hicks/601548390"
        ]
      }
    ]
  },
  "houston-astros": {
    "formation": {
      "year": 1960,
      "price": null,
      "founder": "Houston Sports Association (Roy Hofheinz, R.E. \"Bob\" Smith, Craig Cullinan)",
      "notes": "NL expansion franchise awarded Oct 1960; began play 1962 as the Colt .45s. Fee not confirmed in sources consulted.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1965,
        "price": null,
        "buyer": "Roy Hofheinz (sole control)",
        "seller": "Houston Sports Association partners",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Astros"
        ]
      },
      {
        "year": 1975,
        "price": null,
        "buyer": "GE Credit & Ford Motor Credit (creditors)",
        "seller": "Roy Hofheinz",
        "stakePct": 100,
        "notes": "Creditors took control over ~$38M of Astrodome-related debt. Not a sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Astros"
        ]
      },
      {
        "year": 1979,
        "price": 19000000,
        "buyer": "John McMullen-led partnership (McMullen ~33%, managing partner)",
        "seller": "Ford Motor Credit / GE Credit",
        "stakePct": 100,
        "notes": "July 1979; Wikipedia says \"an estimated total of $19 million\".",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/John_McMullen_(engineer)",
          "https://en.wikipedia.org/wiki/Houston_Astros"
        ]
      },
      {
        "year": 1992,
        "price": 117000000,
        "buyer": "Drayton McLane Jr.",
        "seller": "John McMullen",
        "stakePct": 100,
        "notes": "Announced July 24, 1992 (included the Astrodome lease); owners approved in the fall.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/John_McMullen_(engineer)",
          "https://en.wikipedia.org/wiki/Drayton_McLane_Jr.",
          "https://sabr.org/bioproj/topic/kansas-city-royals-team-ownership-history/"
        ]
      },
      {
        "year": 2011,
        "price": 680000000,
        "buyer": "Jim Crane-led group",
        "seller": "Drayton McLane Jr.",
        "stakePct": 100,
        "notes": "Agreed May 2011; closed Nov 17, 2011. Crane got $35M concessions each from McLane and MLB for the move to the AL, so the net price was ~$610-615M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jim_Crane",
          "https://en.wikipedia.org/wiki/Drayton_McLane_Jr."
        ]
      }
    ]
  },
  "los-angeles-angels": {
    "formation": {
      "year": 1960,
      "price": null,
      "founder": "Gene Autry (with Bob Reynolds)",
      "notes": "AL expansion franchise awarded Dec 1960 (began play 1961). Wikipedia says Autry paid Walter O'Malley $350,000 for rights to the name/territory. Expansion fee not confirmed.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1996,
        "price": null,
        "buyer": "The Walt Disney Company",
        "seller": "Gene Autry",
        "stakePct": 100,
        "notes": "Disney took operating control around 1996-97 (Wikipedia dates it to 1997) and bought the rest after Autry died in 1998. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Angels"
        ]
      },
      {
        "year": 2003,
        "price": 180000000,
        "buyer": "Arte Moreno",
        "seller": "The Walt Disney Company",
        "stakePct": 100,
        "notes": "Announced Apr 2003; approved May 15, 2003. Some outlets cite $183.5M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arte_Moreno"
        ]
      },
      {
        "year": 2026,
        "price": 4000000000,
        "buyer": "Stan Kroenke / Kroenke Sports & Entertainment (controlling interest)",
        "seller": "Moreno family",
        "stakePct": null,
        "notes": "Definitive agreement announced Sept 1-2, 2026. Price ~$4B reported by The Athletic (not officially disclosed). Pending MLB approval; closing expected Q1 2027. Moreno keeps an undisclosed minority stake. Status: agreed, not closed.",
        "isEstimated": true,
        "sources": [
          "https://www.mlb.com/news/stan-kroenke-purchases-angels-from-arte-moreno",
          "https://sports.yahoo.com/mlb/breaking-news/article/rams-owner-stan-kroenke-enters-agreement-to-buy-angels-from-arte-moreno-for-reported-mlb-record-4-billion-182211800.html",
          "https://www.espn.com/mlb/story/_/id/49795749/mlb-2026-los-angeles-angels-sale-arte-moreno-stan-kroenke-kse-future-faq",
          "https://www.mlbtraderumors.com/2026/09/arte-moreno-sells-angels-rams-owner-stan-kroenke.html"
        ]
      }
    ]
  },
  "oakland-athletics": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Ben Shibe (50%), Connie Mack (25%), Sam Jones & Frank Hough (25%)",
      "notes": "AL charter franchise in Philadelphia; moved to Kansas City (1955), Oakland (1968), and Sacramento (2025, temporary, as the Athletics). Shibe bought 50% from Charles Somers in 1901. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1912,
        "price": null,
        "buyer": "Connie Mack (to 50%, equal partner with Shibe)",
        "seller": "Sam Jones & Frank Hough (25%)",
        "stakePct": 25,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Athletics"
        ]
      },
      {
        "year": 1922,
        "price": null,
        "buyer": "Tom & John Shibe (with Connie Mack)",
        "seller": "Ben Shibe (died 1922)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Athletics"
        ]
      },
      {
        "year": 1937,
        "price": null,
        "buyer": "Connie Mack (majority)",
        "seller": "John Shibe estate",
        "stakePct": 100,
        "notes": "Mack bought enough shares from the Shibe estate to become majority owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Athletics"
        ]
      },
      {
        "year": 1950,
        "price": null,
        "buyer": "Roy & Earle Mack (with Connie Mack)",
        "seller": "Connie Mack Jr. / Shibe-heir faction",
        "stakePct": 100,
        "notes": "Intra-family buyout. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Athletics"
        ]
      },
      {
        "year": 1954,
        "price": 3500000,
        "buyer": "Arnold Johnson",
        "seller": "Mack family",
        "stakePct": 100,
        "notes": "Nov 1954: $1.5M for the Macks' shares plus $2M of debt. Moved to Kansas City for 1955.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Athletics",
          "https://en.wikipedia.org/wiki/Connie_Mack"
        ]
      },
      {
        "year": 1960,
        "price": null,
        "buyer": "Arnold Johnson estate",
        "seller": "Arnold Johnson (died Mar 1960)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Kansas_City_Athletics"
        ]
      },
      {
        "year": 1960,
        "price": null,
        "buyer": "Charles O. Finley (controlling interest)",
        "seller": "Arnold Johnson estate",
        "stakePct": 100,
        "notes": "Dec 19, 1960. Price not confirmed; Finley bought out the minority later.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Charles_O._Finley"
        ]
      },
      {
        "year": 1980,
        "price": 12700000,
        "buyer": "Walter A. Haas Jr. family",
        "seller": "Charles O. Finley",
        "stakePct": 100,
        "notes": "Aug 1980; the local sale kept the team from moving to Denver.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Charles_O._Finley",
          "https://en.wikipedia.org/wiki/Walter_A._Haas_Jr."
        ]
      },
      {
        "year": 1995,
        "price": null,
        "buyer": "Steve Schott & Ken Hofmann",
        "seller": "Walter A. Haas Jr. estate",
        "stakePct": 100,
        "notes": "Price not confirmed in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Steve_Schott"
        ]
      },
      {
        "year": 2005,
        "price": 180000000,
        "buyer": "John J. Fisher & Lewis Wolff",
        "seller": "Steve Schott & Ken Hofmann",
        "stakePct": 100,
        "notes": "Mar 30, 2005: $100M equity plus $80M assumed debt. Fisher held the majority economic stake; Wolff was managing partner until 2016.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Lewis_Wolff",
          "https://en.wikipedia.org/wiki/Oakland_Athletics"
        ]
      },
      {
        "year": 2016,
        "price": null,
        "buyer": "John J. Fisher (sole control person)",
        "seller": "Lewis Wolff (~10%)",
        "stakePct": 10,
        "notes": "Control-person change: Fisher bought Wolff's stake. Price undisclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Lewis_Wolff",
          "https://en.wikipedia.org/wiki/John_J._Fisher"
        ]
      }
    ]
  },
  "seattle-mariners": {
    "formation": {
      "year": 1976,
      "price": null,
      "founder": "Lester Smith, Danny Kaye and local investors (Stanley Golub, Walter Schoenfeld, James Walsh, James Stillwell)",
      "notes": "AL expansion franchise awarded 1976 (began play 1977). SABR says investors financed the team with $6.5M, which covered more than the franchise fee; the fee itself was not isolated.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1981,
        "price": 10200000,
        "buyer": "George Argyros (90%)",
        "seller": "Original ownership group",
        "stakePct": 90,
        "notes": "Jan 14, 1981: $10.2M for 90%; he later bought the other 10% for $2.9M (total $13.1M).",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/seattle-mariners-team-ownership-history/"
        ]
      },
      {
        "year": 1989,
        "price": 76000000,
        "buyer": "Jeff Smulyan & Michael Browning",
        "seller": "George Argyros",
        "stakePct": 100,
        "notes": "Announced Aug 22, 1989.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/seattle-mariners-team-ownership-history/"
        ]
      },
      {
        "year": 1992,
        "price": 125000000,
        "buyer": "Baseball Club of Seattle (Hiroshi Yamauchi/Nintendo-backed group with local investors)",
        "seller": "Jeff Smulyan",
        "stakePct": 100,
        "notes": "Yamauchi contributed $75M; local investors covered the rest of the $125M price. The team stayed in Seattle.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/seattle-mariners-team-ownership-history/"
        ]
      },
      {
        "year": 2016,
        "price": 1400000000,
        "buyer": "John Stanton-led local group (17 members)",
        "seller": "Nintendo of America (majority)",
        "stakePct": null,
        "notes": "Apr 27, 2016. The majority interest was sold at a $1.4B valuation for the whole team; Nintendo kept 10%.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/seattle-mariners-team-ownership-history/"
        ]
      }
    ]
  },
  "texas-rangers": {
    "formation": {
      "year": 1960,
      "price": null,
      "founder": "Elwood R. \"Pete\" Quesada group (Washington Senators expansion)",
      "notes": "AL expansion franchise awarded 1960 (began play 1961 as the second Washington Senators); moved to Texas in 1972. Fee not confirmed in sources consulted.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1963,
        "price": null,
        "buyer": "James M. Johnston & James Lemon",
        "seller": "Elwood Quesada",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/washington-senators-ii-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Elwood_Richard_Quesada"
        ]
      },
      {
        "year": 1968,
        "price": 9400000,
        "buyer": "Bob Short",
        "seller": "Johnston estate / James Lemon",
        "stakePct": 100,
        "notes": "Late 1968; Short outbid Bob Hope.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bob_Short",
          "https://sabr.org/bioproj/topic/washington-senators-ii-team-ownership-history/"
        ]
      },
      {
        "year": 1974,
        "price": 9500000,
        "buyer": "Brad Corbett-led group",
        "seller": "Bob Short",
        "stakePct": 100,
        "notes": "May 29, 1974.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brad_Corbett",
          "https://en.wikipedia.org/wiki/Bob_Short"
        ]
      },
      {
        "year": 1980,
        "price": null,
        "buyer": "Eddie Chiles",
        "seller": "Brad Corbett",
        "stakePct": 100,
        "notes": "Price not confirmed in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Eddie_Chiles"
        ]
      },
      {
        "year": 1989,
        "price": 89000000,
        "buyer": "George W. Bush / Rusty Rose investor group",
        "seller": "Eddie Chiles",
        "stakePct": 100,
        "notes": "Wikipedia (Texas Rangers article) gives $89M total.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Texas_Rangers_(baseball)"
        ]
      },
      {
        "year": 1998,
        "price": 250000000,
        "buyer": "Tom Hicks (Hicks Sports Group)",
        "seller": "Bush/Rose investor group",
        "stakePct": 100,
        "notes": "Announced Jan 1998.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tom_Hicks",
          "https://en.wikipedia.org/wiki/Texas_Rangers_(baseball)"
        ]
      },
      {
        "year": 2010,
        "price": 570000000,
        "buyer": "Rangers Baseball Express (Chuck Greenberg, Nolan Ryan; Ray Davis & Bob Simpson primary funders)",
        "seller": "Hicks Sports Group (bankruptcy auction)",
        "stakePct": 100,
        "notes": "Aug 2010 bankruptcy auction. Wikipedia says \"about $570 million\"; other reports cite ~$593M including assumed obligations. Greenberg left in 2011 and Ryan in 2013; Davis and Simpson became co-chairmen.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Texas_Rangers_(baseball)",
          "https://en.wikipedia.org/wiki/Ray_Davis_(businessman)"
        ]
      }
    ]
  },
  "atlanta-braves": {
    "formation": {
      "year": 1871,
      "price": null,
      "founder": "Ivers Whitney Adams (Boston Red Stockings, National Association)",
      "notes": "Founded 1871 in the National Association; NL charter member 1876; moved to Milwaukee in 1953 and Atlanta in 1966. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1877,
        "price": null,
        "buyer": "Arthur Soden (with William Conant & James Billings, \"the Triumvirs\")",
        "seller": "Boston Base Ball Association stockholders",
        "stakePct": 100,
        "notes": "Control consolidated gradually; no single sale price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1906,
        "price": 75000,
        "buyer": "George B. & John S.C. Dovey",
        "seller": "Soden, Conant & Billings",
        "stakePct": 100,
        "notes": "Oct 1906: $75,000 plus an assumed $200,000 mortgage on the South End Grounds.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1909,
        "price": null,
        "buyer": "John S.C. Dovey",
        "seller": "George B. Dovey (died 1909)",
        "stakePct": 100,
        "notes": "inheritance; John P. Harris then became principal holder",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1911,
        "price": 100000,
        "buyer": "William Hepburn Russell (with Frederick Murphy)",
        "seller": "John P. Harris (765 of 1,000 shares)",
        "stakePct": 76.5,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1912,
        "price": 187000,
        "buyer": "James Gaffney (with John Montgomery Ward)",
        "seller": "William H. Russell estate",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1916,
        "price": 400000,
        "buyer": "Percy Haughton / Arthur Wise group",
        "seller": "James Gaffney",
        "stakePct": 100,
        "notes": "Reported $400,000; did not include Braves Field, which Gaffney kept.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1919,
        "price": 400000,
        "buyer": "George Washington Grant",
        "seller": "Percy Haughton group",
        "stakePct": 100,
        "notes": "Reported $400,000 in cash, team only.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1923,
        "price": null,
        "buyer": "Christy Mathewson & Emil Fuchs group",
        "seller": "George Washington Grant",
        "stakePct": 100,
        "notes": "Feb 20, 1923. Fuchs later said he paid $450,000 cash; press reports differ, so price left null. Fuchs took control after Mathewson died in 1925.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Atlanta_Braves"
        ]
      },
      {
        "year": 1935,
        "price": null,
        "buyer": "Charles F. Adams (control)",
        "seller": "Emil Fuchs (defaulted on loans)",
        "stakePct": 100,
        "notes": "Fuchs resigned Aug 1, 1935 and control passed to creditor/shareholder Adams.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1936,
        "price": null,
        "buyer": "Bob Quinn-led reorganized company",
        "seller": "Charles F. Adams group",
        "stakePct": 100,
        "notes": "Assets moved to a new company; Adams kept a majority stock position until 1941.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1941,
        "price": null,
        "buyer": "Bob Quinn-led syndicate (incl. Lou Perini, Casey Stengel)",
        "seller": "Charles F. Adams (73%)",
        "stakePct": 73,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1944,
        "price": null,
        "buyer": "Lou Perini, Guido Rugo & C. Joseph Maney",
        "seller": "Other stockholders",
        "stakePct": 100,
        "notes": "The trio bought out other stockholders to get majority control. Perini later bought out the minority, and the team moved to Milwaukee in 1953.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/boston-braves-team-ownership-history/"
        ]
      },
      {
        "year": 1962,
        "price": 5500000,
        "buyer": "William Bartholomay / LaSalle Corp. group",
        "seller": "Lou Perini",
        "stakePct": 90,
        "notes": "Nov 1962; Perini kept 10%. Team moved to Atlanta in 1966.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Lou_Perini",
          "https://en.wikipedia.org/wiki/William_Bartholomay"
        ]
      },
      {
        "year": 1976,
        "price": null,
        "buyer": "Ted Turner (Turner Broadcasting)",
        "seller": "Bartholomay group",
        "stakePct": 100,
        "notes": "Price not confirmed in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ted_Turner"
        ]
      },
      {
        "year": 1996,
        "price": null,
        "buyer": "Time Warner",
        "seller": "Turner Broadcasting shareholders (corporate merger)",
        "stakePct": 100,
        "notes": "Control passed when Time Warner acquired TBS. No separate team price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Braves"
        ]
      },
      {
        "year": 2007,
        "price": null,
        "buyer": "Liberty Media",
        "seller": "Time Warner",
        "stakePct": 100,
        "notes": "Asset swap agreed Feb 2007. The whole package (Braves, ~$980M cash and other assets for Liberty's Time Warner shares) was valued at about $1.48B; the Braves' own value is not separated in the source.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Braves"
        ]
      },
      {
        "year": 2023,
        "price": null,
        "buyer": "Atlanta Braves Holdings (public company, BATRA/BATRK)",
        "seller": "Liberty Media (split-off)",
        "stakePct": 100,
        "notes": "July 2023 split-off to Liberty shareholders; no cash sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Braves"
        ]
      }
    ]
  },
  "miami-marlins": {
    "formation": {
      "year": 1991,
      "price": 95000000,
      "founder": "H. Wayne Huizenga",
      "notes": "NL expansion franchise awarded 1991 (began play 1993); Huizenga paid the $95M franchise fee himself.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1998,
        "price": 150000000,
        "buyer": "John W. Henry",
        "seller": "H. Wayne Huizenga",
        "stakePct": 100,
        "notes": "Nov 1998; Henry also paid $8M for stadium renovations.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/miami-marlins-team-ownership-history/"
        ]
      },
      {
        "year": 2002,
        "price": 158500000,
        "buyer": "Jeffrey Loria",
        "seller": "John W. Henry",
        "stakePct": 100,
        "notes": "Part of a three-way swap: Loria sold the Expos to MLB for $120M and received a $38.5M interest-free MLB loan; Henry bought the Red Sox.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/montreal-expos-team-ownership-history/",
          "https://sabr.org/bioproj/topic/miami-marlins-team-ownership-history/"
        ]
      },
      {
        "year": 2017,
        "price": 1200000000,
        "buyer": "Bruce Sherman-led group (incl. Derek Jeter)",
        "seller": "Jeffrey Loria",
        "stakePct": 100,
        "notes": "Owners approved Sept 2017; closed Oct 2017.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/miami-marlins-team-ownership-history/"
        ]
      }
    ]
  },
  "new-york-mets": {
    "formation": {
      "year": 1960,
      "price": null,
      "founder": "Joan Whitney Payson (~85%) with M. Donald Grant",
      "notes": "NL expansion franchise awarded Oct 1960 (began play 1962). SABR says Payson paid $1M for her primary investment; the expansion fee itself was not confirmed.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1975,
        "price": null,
        "buyer": "Charles Payson / Lorinda de Roulet (Payson family)",
        "seller": "Joan Whitney Payson (died Oct 1975)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-mets-team-ownership-history/"
        ]
      },
      {
        "year": 1980,
        "price": 21100000,
        "buyer": "Doubleday & Co. (Nelson Doubleday Jr., 80%) and Fred Wilpon",
        "seller": "Payson family",
        "stakePct": 100,
        "notes": "Jan 24, 1980.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-mets-team-ownership-history/"
        ]
      },
      {
        "year": 1986,
        "price": null,
        "buyer": "Nelson Doubleday & Fred Wilpon (personally, 50/50)",
        "seller": "Doubleday & Co. (sold to Bertelsmann)",
        "stakePct": 100,
        "notes": "Team moved from the publishing company to its two principals. SABR says the Mets were valued at ~$100M in 1986; exact price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-mets-team-ownership-history/"
        ]
      },
      {
        "year": 2002,
        "price": 135000000,
        "buyer": "Fred Wilpon / Sterling Equities (sole principal owner)",
        "seller": "Nelson Doubleday (50%)",
        "stakePct": 50,
        "notes": "The buyout implied a franchise value of ~$391M.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-mets-team-ownership-history/"
        ]
      },
      {
        "year": 2020,
        "price": 2420000000,
        "buyer": "Steve & Alex Cohen",
        "seller": "Wilpon & Katz families",
        "stakePct": 100,
        "notes": "Closed Nov 2020; record MLB price at the time (Wikipedia rounds to $2.4B). Cohen already held a ~4% minority stake from 2012.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Mets",
          "https://www.cbssports.com/mlb/news/padres-sale-mlb-record-3-9-billion-jose-e-feliciano/"
        ]
      }
    ]
  },
  "philadelphia-phillies": {
    "formation": {
      "year": 1883,
      "price": null,
      "founder": "Al Reach & John Rogers",
      "notes": "NL franchise founded 1883. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1903,
        "price": 180000,
        "buyer": "James Potter syndicate",
        "seller": "Al Reach & John Rogers",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/"
        ]
      },
      {
        "year": 1905,
        "price": null,
        "buyer": "Israel W. Durham group",
        "seller": "James Potter syndicate",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1909,
        "price": null,
        "buyer": "Horace Fogel (backed by Charles P. Taft)",
        "seller": "Durham group",
        "stakePct": 100,
        "notes": "The club was said to be worth $350,000; exact price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/"
        ]
      },
      {
        "year": 1913,
        "price": null,
        "buyer": "William Baker (after William H. Locke)",
        "seller": "Fogel/Taft interests",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1930,
        "price": null,
        "buyer": "Baker estate (Charlie Ruch, then Gerald Nugent from 1932)",
        "seller": "William Baker (died 1930)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1943,
        "price": 240000,
        "buyer": "William D. Cox syndicate",
        "seller": "Gerald Nugent / National League",
        "stakePct": 99,
        "notes": "Mar 15, 1943: $190,000 cash plus a $50,000 note for 4,950 of 5,000 shares.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1943,
        "price": 400000,
        "buyer": "Robert R.M. Carpenter Sr. (duPont family)",
        "seller": "William D. Cox (banned by Landis)",
        "stakePct": 100,
        "notes": "Nov 23, 1943; estimated $400,000.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1972,
        "price": null,
        "buyer": "Ruly Carpenter",
        "seller": "Bob Carpenter Jr. (family transfer)",
        "stakePct": 100,
        "notes": "Family transfer, not a sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 1981,
        "price": 30000000,
        "buyer": "Bill Giles-led group (with Taft Broadcasting, Dixon family, Buck family)",
        "seller": "Ruly Carpenter / Carpenter family",
        "stakePct": 100,
        "notes": "Finalized Oct 29, 1981. SABR reports $30M; Wikipedia gives $32.5M.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/",
          "https://en.wikipedia.org/wiki/Philadelphia_Phillies"
        ]
      },
      {
        "year": 2016,
        "price": null,
        "buyer": "John Middleton (control person)",
        "seller": "Bill Giles-era partnership",
        "stakePct": null,
        "notes": "MLB owners named Middleton control person in 2016. He first bought ~15% for $18M in 1994 and increased his stake later. No full-franchise sale price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/philadelphia-phillies-team-ownership-history/",
          "https://en.wikipedia.org/wiki/John_Middleton_(businessman)"
        ]
      }
    ]
  },
  "washington-nationals": {
    "formation": {
      "year": 1968,
      "price": 10000000,
      "founder": "Charles Bronfman-led group (Montreal Expos)",
      "notes": "NL expansion franchise awarded May 1968 (began play 1969); the NL set the expansion fee at $10M. Moved to Washington in 2005.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": null,
        "buyer": "Claude Brochu-led consortium (with City of Montreal, Quebec province and 11 corporate partners)",
        "seller": "Charles Bronfman",
        "stakePct": 100,
        "notes": "Price not confirmed in sources consulted.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/montreal-expos-team-ownership-history/"
        ]
      },
      {
        "year": 1999,
        "price": 12000000,
        "buyer": "Jeffrey Loria (managing general partner)",
        "seller": "Claude Brochu (24%)",
        "stakePct": 24,
        "notes": "Dec 9, 1999: $12M for Brochu's 24%. Loria later diluted partners through cash calls to ~94%.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/montreal-expos-team-ownership-history/"
        ]
      },
      {
        "year": 2002,
        "price": 120000000,
        "buyer": "Major League Baseball (Expos Baseball LP)",
        "seller": "Jeffrey Loria",
        "stakePct": 100,
        "notes": "Part of the Marlins/Red Sox three-way swap; MLB also lent Loria $38.5M interest-free.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/montreal-expos-team-ownership-history/"
        ]
      },
      {
        "year": 2006,
        "price": 450000000,
        "buyer": "Lerner Enterprises group (Ted Lerner)",
        "seller": "Major League Baseball",
        "stakePct": 100,
        "notes": "Announced July 2006; official July 24, 2006.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/montreal-expos-team-ownership-history/"
        ]
      },
      {
        "year": 2023,
        "price": null,
        "buyer": "Mark Lerner (Lerner family)",
        "seller": "Ted Lerner (died Feb 2023)",
        "stakePct": 100,
        "notes": "inheritance; Mark Lerner had been public-facing principal owner since 2018. No 2025-26 sale found",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Washington_Nationals"
        ]
      }
    ]
  },
  "chicago-cubs": {
    "formation": {
      "year": 1870,
      "price": null,
      "founder": "Chicago White Stockings stock association (Chicago businessmen; George Gage president)",
      "notes": "Founded 1870, National Association from 1871; NL charter member 1876. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1876,
        "price": null,
        "buyer": "William A. Hulbert",
        "seller": "Chicago association stockholders",
        "stakePct": 100,
        "notes": "Hulbert collected shares in 1875-76 and reorganized the club. No single price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1882,
        "price": null,
        "buyer": "Albert G. Spalding",
        "seller": "William Hulbert (died Apr 1882)",
        "stakePct": 100,
        "notes": "Succession to control, not a priced sale.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1902,
        "price": null,
        "buyer": "James A. Hart",
        "seller": "Albert Spalding & John Walsh",
        "stakePct": 100,
        "notes": "Hart bought out Spalding and Walsh. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1905,
        "price": 105500,
        "buyer": "Charles W. Murphy (financed by Charles P. Taft)",
        "seller": "James A. Hart",
        "stakePct": 100,
        "notes": "Reported as $105,000 at the time; a 1916 lawsuit showed $105,500.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1914,
        "price": 500000,
        "buyer": "Charles P. Taft",
        "seller": "Charles W. Murphy (53%)",
        "stakePct": 53,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1916,
        "price": 500000,
        "buyer": "Charles Weeghman & William Walker group (incl. William Wrigley Jr., Albert Lasker)",
        "seller": "Charles P. Taft",
        "stakePct": 100,
        "notes": "Announced Jan 6, 1916 as part of the Federal League settlement.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/chicago-cubs-team-ownership-history-part1/"
        ]
      },
      {
        "year": 1921,
        "price": null,
        "buyer": "William Wrigley Jr.",
        "seller": "Charles Weeghman (by 1918) and Albert Lasker (1921)",
        "stakePct": 100,
        "notes": "Wrigley gradually bought out Weeghman and then Lasker's controlling block. Prices not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Chicago_Cubs"
        ]
      },
      {
        "year": 1932,
        "price": null,
        "buyer": "Philip K. Wrigley",
        "seller": "William Wrigley Jr. (died Jan 1932)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Chicago_Cubs"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "William Wrigley III",
        "seller": "Philip K. Wrigley (died Apr 1977)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Cubs"
        ]
      },
      {
        "year": 1981,
        "price": 20500000,
        "buyer": "Tribune Company",
        "seller": "Wrigley family",
        "stakePct": 100,
        "notes": "June 1981.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Cubs",
          "https://en.wikipedia.org/wiki/History_of_the_Chicago_Cubs"
        ]
      },
      {
        "year": 2009,
        "price": 845000000,
        "buyer": "Ricketts family (Tom Ricketts)",
        "seller": "Tribune Company",
        "stakePct": 95,
        "notes": "Closed Oct 2009. Covered ~95% of the Cubs, Wrigley Field and 25% of Comcast SportsNet Chicago; record MLB price at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Dodgers",
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      }
    ]
  },
  "cincinnati-reds": {
    "formation": {
      "year": 1881,
      "price": null,
      "founder": "Justus Thorner (president)",
      "notes": "Current franchise formed 1881; American Association charter member 1882; moved to the NL in 1890. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1884,
        "price": null,
        "buyer": "Aaron S. Stern",
        "seller": "Justus Thorner",
        "stakePct": 100,
        "notes": "A string of 1880s owners followed (Stern, Herancourt, Hauck, Stern, Al Johnson). Prices not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds"
        ]
      },
      {
        "year": 1891,
        "price": null,
        "buyer": "John T. Brush",
        "seller": "Al Johnson / Stern interests",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds"
        ]
      },
      {
        "year": 1902,
        "price": null,
        "buyer": "Julius & Max Fleischmann, George B. Cox & August \"Garry\" Herrmann",
        "seller": "John T. Brush",
        "stakePct": 100,
        "notes": "Brush sold to fund his purchase of the NY Giants. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1927,
        "price": null,
        "buyer": "Sidney Weil",
        "seller": "Herrmann / C.J. McDiarmid-era group",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds"
        ]
      },
      {
        "year": 1933,
        "price": null,
        "buyer": "Powel Crosley Jr.",
        "seller": "Sidney Weil / Central Trust Co. (bankruptcy)",
        "stakePct": 100,
        "notes": "Crosley bought the Reds out of bankruptcy (Wikipedia says 1933; often dated Feb 1934). Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds",
          "https://en.wikipedia.org/wiki/History_of_the_Cincinnati_Reds"
        ]
      },
      {
        "year": 1961,
        "price": null,
        "buyer": "Crosley estate / foundation",
        "seller": "Powel Crosley Jr. (died Mar 1961)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_DeWitt"
        ]
      },
      {
        "year": 1962,
        "price": 4270000,
        "buyer": "Bill DeWitt Sr. (100%)",
        "seller": "Crosley estate",
        "stakePct": 100,
        "notes": "Mar 23, 1962.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_DeWitt"
        ]
      },
      {
        "year": 1966,
        "price": 8000000,
        "buyer": "Francis L. Dale-led 13-person syndicate",
        "seller": "Bill DeWitt Sr.",
        "stakePct": 100,
        "notes": "Dec 5, 1966.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_DeWitt"
        ]
      },
      {
        "year": 1973,
        "price": null,
        "buyer": "Louis Nippert (control)",
        "seller": "Dale syndicate partners",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds"
        ]
      },
      {
        "year": 1981,
        "price": null,
        "buyer": "William & James Williams",
        "seller": "Louis Nippert",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Cincinnati_Reds"
        ]
      },
      {
        "year": 1984,
        "price": 11000000,
        "buyer": "Marge Schott (controlling interest)",
        "seller": "Williams brothers group",
        "stakePct": 100,
        "notes": "Dec 21, 1984; \"reported $11M\".",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Marge_Schott"
        ]
      },
      {
        "year": 1999,
        "price": 67000000,
        "buyer": "Carl Lindner Jr.-led group",
        "seller": "Marge Schott (controlling interest)",
        "stakePct": 100,
        "notes": "Agreed Apr 20, 1999.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Marge_Schott"
        ]
      },
      {
        "year": 2006,
        "price": 270000000,
        "buyer": "Bob Castellini-led group",
        "seller": "Carl Lindner Jr. group",
        "stakePct": 100,
        "notes": "Castellini became CEO Jan 2006.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bob_Castellini"
        ]
      }
    ]
  },
  "milwaukee-brewers": {
    "formation": {
      "year": 1968,
      "price": 5350000,
      "founder": "Dewey & Max Soriano with William R. Daley (Seattle Pilots)",
      "notes": "AL expansion franchise awarded 1968 (Seattle Pilots, one season in 1969); $5.35M franchise fee per SABR. Moved to Milwaukee in 1970.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1970,
        "price": 10800000,
        "buyer": "Bud Selig-led group",
        "seller": "Pilots owners (Soriano/Daley; in bankruptcy)",
        "stakePct": 100,
        "notes": "Deal agreed Oct 1969 and completed via bankruptcy court in spring 1970; moved to Milwaukee.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Seattle_Pilots",
          "https://sabr.org/bioproj/topic/seattle-pilots-ownership-history/"
        ]
      },
      {
        "year": 1998,
        "price": null,
        "buyer": "Wendy Selig-Prieb (Selig family trust)",
        "seller": "Bud Selig (became commissioner)",
        "stakePct": 100,
        "notes": "Family transfer, not a sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bud_Selig"
        ]
      },
      {
        "year": 2005,
        "price": 223000000,
        "buyer": "Mark Attanasio-led group",
        "seller": "Selig family trust",
        "stakePct": 100,
        "notes": "Approved Jan 2005.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mark_Attanasio"
        ]
      }
    ]
  },
  "pittsburgh-pirates": {
    "formation": {
      "year": 1882,
      "price": null,
      "founder": "H. Denny McKnight (Allegheny club, American Association)",
      "notes": "AA charter member 1882; joined the NL in 1887. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1887,
        "price": null,
        "buyer": "William Nimick",
        "seller": "Denny McKnight-era ownership",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barney_Dreyfuss"
        ]
      },
      {
        "year": 1892,
        "price": null,
        "buyer": "William Kerr & Phil Auten",
        "seller": "William Nimick",
        "stakePct": 100,
        "notes": "Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barney_Dreyfuss"
        ]
      },
      {
        "year": 1900,
        "price": null,
        "buyer": "Barney Dreyfuss",
        "seller": "Kerr & Auten",
        "stakePct": 100,
        "notes": "Dreyfuss merged his Louisville club into Pittsburgh and used that leverage to buy out his partners. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barney_Dreyfuss",
          "https://en.wikipedia.org/wiki/History_of_the_Pittsburgh_Pirates"
        ]
      },
      {
        "year": 1932,
        "price": null,
        "buyer": "Florence Dreyfuss (Bill Benswanger president)",
        "seller": "Barney Dreyfuss (died Feb 1932)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barney_Dreyfuss"
        ]
      },
      {
        "year": 1946,
        "price": 2250000,
        "buyer": "Frank E. McKinney, John W. Galbreath, Bing Crosby & Thomas P. Johnson",
        "seller": "Florence Dreyfuss",
        "stakePct": 100,
        "notes": "Aug 8, 1946 (NYT: \"Sold It in 1946 for $2,250,000\").",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barney_Dreyfuss",
          "https://en.wikipedia.org/wiki/John_W._Galbreath"
        ]
      },
      {
        "year": 1950,
        "price": null,
        "buyer": "John W. Galbreath (majority)",
        "seller": "Frank E. McKinney (50%)",
        "stakePct": 50,
        "notes": "Galbreath, Crosby and Johnson bought out McKinney. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Pittsburgh_Pirates",
          "https://en.wikipedia.org/wiki/John_W._Galbreath"
        ]
      },
      {
        "year": 1985,
        "price": null,
        "buyer": "Pittsburgh Associates (public-private consortium)",
        "seller": "Galbreath family",
        "stakePct": 100,
        "notes": "Late 1985 sale to keep the team in Pittsburgh. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Pittsburgh_Pirates"
        ]
      },
      {
        "year": 1996,
        "price": 95000000,
        "buyer": "Kevin McClatchy-led group (Nutting family as minority investors)",
        "seller": "Pittsburgh Associates",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Pittsburgh_Pirates",
          "https://en.wikipedia.org/wiki/Kevin_McClatchy"
        ]
      },
      {
        "year": 2007,
        "price": null,
        "buyer": "Bob Nutting / Nutting family (Ogden Newspapers)",
        "seller": "Kevin McClatchy",
        "stakePct": 100,
        "notes": "Nuttings became plurality and then majority owners by ~2005; Bob Nutting replaced McClatchy as controlling owner in 2007. No disclosed price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Pittsburgh_Pirates",
          "https://en.wikipedia.org/wiki/Kevin_McClatchy",
          "https://en.wikipedia.org/wiki/Bob_Nutting"
        ]
      }
    ]
  },
  "st-louis-cardinals": {
    "formation": {
      "year": 1882,
      "price": null,
      "founder": "Chris von der Ahe (St. Louis Brown Stockings, American Association)",
      "notes": "AA charter member 1882; joined the NL in 1892. SABR says von der Ahe bought out his original partners for $1,800; the franchise founding price is not separately known.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1899,
        "price": null,
        "buyer": "Frank & Stanley Robison",
        "seller": "Chris von der Ahe (forced sale)",
        "stakePct": 100,
        "notes": "Von der Ahe lost the club through a forced sale. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1911,
        "price": null,
        "buyer": "Helene Hathaway Robison Britton",
        "seller": "Stanley Robison (died 1911)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1917,
        "price": 350000,
        "buyer": "\"Cardinal Idea\" fan-stock group led by James C. Jones (Sam Breadon an early investor)",
        "seller": "Helene Britton",
        "stakePct": 100,
        "notes": "The group held a $350,000 purchase option; SABR also cites a $390,000 total paid in a related transaction.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1920,
        "price": null,
        "buyer": "Sam Breadon (majority)",
        "seller": "Cardinal Idea shareholders",
        "stakePct": 100,
        "notes": "Breadon built up majority control. No single price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1947,
        "price": null,
        "buyer": "Fred Saigh & Robert Hannegan",
        "seller": "Sam Breadon (81%) and other shareholders",
        "stakePct": 100,
        "notes": "Nov 1947. SABR: Breadon (81%) received $3,289,248; the deal also included cash and property. Total not stated cleanly, so price is null.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1949,
        "price": null,
        "buyer": "Fred Saigh (sole)",
        "seller": "Robert Hannegan",
        "stakePct": 100,
        "notes": "Hannegan received at least $1M for his shares.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1953,
        "price": 3750000,
        "buyer": "Anheuser-Busch (August A. \"Gussie\" Busch Jr.)",
        "seller": "Fred Saigh",
        "stakePct": 100,
        "notes": "Feb 1953; Saigh was under a tax-evasion conviction. Included assumption of $1.25M of team debt.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      },
      {
        "year": 1996,
        "price": 150000000,
        "buyer": "William DeWitt Jr.-led group (incl. Fred Hanser, Andrew Baur)",
        "seller": "Anheuser-Busch",
        "stakePct": 100,
        "notes": "Agreement Dec 22, 1995; closed Mar 1996. Price covered team, Busch Stadium and parking garages.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/st-louis-cardinals-team-ownership-history/"
        ]
      }
    ]
  },
  "los-angeles-dodgers": {
    "formation": {
      "year": 1883,
      "price": null,
      "founder": "Charles Byrne, Joseph Doyle & Ferdinand Abell",
      "notes": "Brooklyn club founded 1883; AA 1884, NL 1890; moved to Los Angeles in 1958. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1902,
        "price": null,
        "buyer": "Charles Ebbets (majority)",
        "seller": "Ferdinand Abell / Harry von der Horst interests",
        "stakePct": 100,
        "notes": "Ebbets built control after Byrne died in 1898 by buying shares and options (one block reported at $25,000). No single control price.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1912,
        "price": null,
        "buyer": "Ed & Steve McKeever (50%)",
        "seller": "Charles Ebbets",
        "stakePct": 50,
        "notes": "Ebbets sold half to the McKeevers to finance Ebbets Field, so control was shared. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1925,
        "price": null,
        "buyer": "Ebbets and McKeever estates (Brooklyn Trust Co. as trustee)",
        "seller": "Charles Ebbets & Ed McKeever (both died 1925)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1945,
        "price": null,
        "buyer": "Branch Rickey, Walter O'Malley & John L. Smith (75%)",
        "seller": "Ed McKeever estate and Ebbets estate",
        "stakePct": 75,
        "notes": "1944-45. Each partner paid ~$346,667 per SABR; the McKeever block cost $240,000 inside a $1,046,000 financing package.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1950,
        "price": 1050000,
        "buyer": "Walter O'Malley (control)",
        "seller": "Branch Rickey (25%)",
        "stakePct": 25,
        "notes": "Sept-Oct 1950. O'Malley matched the Zeckendorf offer for Rickey's 25% and took control.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1979,
        "price": null,
        "buyer": "Peter O'Malley & Terry O'Malley Seidler",
        "seller": "Walter O'Malley (died Aug 1979)",
        "stakePct": 100,
        "notes": "inheritance; Peter had been president since 1970",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 1998,
        "price": 311000000,
        "buyer": "Fox Group / News Corporation (Rupert Murdoch)",
        "seller": "O'Malley family",
        "stakePct": 100,
        "notes": "Approved Mar 19, 1998. $311M (LA Times) covered team, Dodger Stadium and ~300 acres; AP reported $350M and NYT $320M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Dodgers",
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 2004,
        "price": 430000000,
        "buyer": "Frank & Jamie McCourt",
        "seller": "News Corporation / Fox",
        "stakePct": 100,
        "notes": "Approved Jan 29, 2004. Almost entirely debt-financed (Fox loans reportedly $330M). Price reported variously as $421-431M; net $371M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Dodgers",
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      },
      {
        "year": 2012,
        "price": 2150000000,
        "buyer": "Guggenheim Baseball Management (Mark Walter; Stan Kasten, Magic Johnson, Todd Boehly, Peter Guber)",
        "seller": "Frank McCourt (Chapter 11)",
        "stakePct": 100,
        "notes": "Bankruptcy court approved in April; closed May 1, 2012. Record at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Dodgers",
          "https://sabr.org/bioproj/topic/los-angeles-brooklyn-dodgers-team-ownership-history/"
        ]
      }
    ]
  },
  "san-francisco-giants": {
    "formation": {
      "year": 1883,
      "price": null,
      "founder": "John B. Day (New York Gothams)",
      "notes": "NL franchise founded 1883 in New York; moved to San Francisco in 1958. Founding price unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1895,
        "price": 48000,
        "buyer": "Andrew Freedman (majority)",
        "seller": "Edward Talcott / Day-era stockholders",
        "stakePct": 100,
        "notes": "SABR: bargain price estimated at $48,000-54,000.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1902,
        "price": 200000,
        "buyer": "John T. Brush",
        "seller": "Andrew Freedman (majority interest)",
        "stakePct": 100,
        "notes": "Reported $200,000; some sources say $150,000. Brush raised the money by selling the Reds.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1912,
        "price": null,
        "buyer": "Harry Hempstead (Brush estate / Eleanor Brush Hempstead)",
        "seller": "John T. Brush (died Nov 1912)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1919,
        "price": 1000000,
        "buyer": "Charles Stoneham (with John McGraw & Francis McQuade)",
        "seller": "Hempstead / Brush estate",
        "stakePct": 100,
        "notes": "Generally reported as $1M; later histories say $1.3M.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/new-york-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1936,
        "price": null,
        "buyer": "Horace Stoneham",
        "seller": "Charles Stoneham (died Jan 1936)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-francisco-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1976,
        "price": 8000000,
        "buyer": "Bob Lurie & Arthur \"Bud\" Herseth",
        "seller": "Horace Stoneham",
        "stakePct": 100,
        "notes": "Lurie and Herseth each put up half of the $8M, keeping the team from moving to Toronto.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-francisco-giants-team-ownership-history/"
        ]
      },
      {
        "year": 1993,
        "price": 100000000,
        "buyer": "Peter Magowan-led group (Larry Baer, Walter Shorenstein, Charles Schwab, others)",
        "seller": "Bob Lurie",
        "stakePct": 100,
        "notes": "NL owners blocked a sale to a Tampa-St. Petersburg group. Later managing-partner changes (Bill Neukom 2008, Larry Baer 2012 with the Charles Johnson family as largest holder) and the 2025 Sixth Street minority stake were not sales of control.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-francisco-giants-team-ownership-history/"
        ]
      }
    ]
  },
  "san-diego-padres": {
    "formation": {
      "year": 1968,
      "price": 10000000,
      "founder": "C. Arnholt Smith",
      "notes": "NL expansion franchise awarded May 1968 (began play 1969); the NL set the fee at $10M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1974,
        "price": 12000000,
        "buyer": "Ray Kroc",
        "seller": "C. Arnholt Smith",
        "stakePct": 100,
        "notes": "Agreement Jan 23, 1974, all cash; kept the team from moving to Washington.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-diego-padres-team-ownership-history/"
        ]
      },
      {
        "year": 1984,
        "price": null,
        "buyer": "Joan Kroc",
        "seller": "Ray Kroc (died Jan 1984)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-diego-padres-team-ownership-history/"
        ]
      },
      {
        "year": 1990,
        "price": 90000000,
        "buyer": "Tom Werner-led group",
        "seller": "Joan Kroc",
        "stakePct": 100,
        "notes": "Agreed Apr 2, 1990.",
        "isEstimated": false,
        "sources": [
          "https://sabr.org/bioproj/topic/san-diego-padres-team-ownership-history/"
        ]
      },
      {
        "year": 1994,
        "price": 80000000,
        "buyer": "John Moores (with Larry Lucchino)",
        "seller": "Tom Werner group",
        "stakePct": 100,
        "notes": "\"Approximately $80 million\" per SABR.",
        "isEstimated": true,
        "sources": [
          "https://sabr.org/bioproj/topic/san-diego-padres-team-ownership-history/"
        ]
      },
      {
        "year": 2012,
        "price": 800000000,
        "buyer": "Ron Fowler with Peter Seidler / O'Malley-family heirs group",
        "seller": "John Moores (and Jeff Moorad faction)",
        "stakePct": 100,
        "notes": "Aug 2012. Wikipedia (John Moores) gives $800M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/John_Moores_(baseball)",
          "https://sabr.org/bioproj/topic/san-diego-padres-team-ownership-history/"
        ]
      },
      {
        "year": 2023,
        "price": null,
        "buyer": "Seidler family / Peter Seidler trust (John Seidler approved as control person Feb 6, 2025)",
        "seller": "Peter Seidler (died Nov 14, 2023)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/San_Diego_Padres"
        ]
      },
      {
        "year": 2026,
        "price": 3900000000,
        "buyer": "José E. Feliciano & Kwanza Jones (control person; ~40% reported)",
        "seller": "Seidler family (Peter Seidler trust kept a minority stake)",
        "stakePct": 40,
        "notes": "Definitive agreement announced May 2, 2026 at a reported $3.9B valuation (WSJ), an MLB record. Owners approved unanimously Aug 17, 2026, contingent on closing \"in the weeks ahead\". I did not find an explicit closing confirmation.",
        "isEstimated": true,
        "sources": [
          "https://www.cbssports.com/mlb/news/padres-sale-mlb-record-3-9-billion-jose-e-feliciano/",
          "https://www.mlb.com/news/padres-sale-to-jose-e-feliciano-and-kwanza-jones-approved-by-mlb",
          "https://www.sportico.com/business/team-sales/2026/san-diego-padres-sale-feliciano-jones-1234942104/",
          "https://www.mlbtraderumors.com/2026/08/mlb-owners-approve-sale-of-padres-to-jose-e-feliciano-kwanza-jones.html"
        ]
      }
    ]
  },
  "colorado-rockies": {
    "formation": {
      "year": 1991,
      "price": 95000000,
      "founder": "Colorado Baseball Partnership (Mickey Monus & John Antonucci; Coors Brewing as investor)",
      "notes": "NL expansion franchise awarded 1991 (began play 1993); $95M expansion fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1992,
        "price": null,
        "buyer": "Jerry McMorris (with Charlie Monfort & Oren Benton)",
        "seller": "Mickey Monus & John Antonucci",
        "stakePct": 100,
        "notes": "Sept 2, 1992: McMorris group bought controlling interest after Monus's Phar-Mor accounting scandal. Price not captured.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Charlie_Monfort",
          "https://en.wikipedia.org/wiki/Colorado_Rockies",
          "https://en.wikipedia.org/wiki/Jerry_McMorris"
        ]
      },
      {
        "year": 2005,
        "price": null,
        "buyer": "Dick & Charlie Monfort",
        "seller": "Jerry McMorris",
        "stakePct": 100,
        "notes": "Monforts bought out McMorris and became principal owners. Price not captured. A reported 2025 Walton-Penner minority stake was not verified and would not be a control change.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Charlie_Monfort"
        ]
      }
    ]
  },
  "arizona-diamondbacks": {
    "formation": {
      "year": 1995,
      "price": 130000000,
      "founder": "Jerry Colangelo-led group",
      "notes": "NL expansion franchise awarded Mar 9, 1995 (began play 1998); $130M franchise fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2004,
        "price": null,
        "buyer": "Ken Kendrick (managing general partner) with Jeff Royer & Mike Chipman",
        "seller": "Jerry Colangelo",
        "stakePct": 100,
        "notes": "Summer 2004: Colangelo was forced out as managing general partner and sold his interest; Kendrick succeeded him. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jerry_Colangelo",
          "https://en.wikipedia.org/wiki/Ken_Kendrick"
        ]
      }
    ]
  },
  "atlanta-united-fc": {
    "formation": {
      "year": 2014,
      "price": 70000000,
      "founder": "Arthur Blank (AMB Group)",
      "notes": "MLS expansion awarded April 2014; began play 2017. Fee as listed in MLS expansion history.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "charlotte-fc": {
    "formation": {
      "year": 2019,
      "price": 325000000,
      "founder": "David Tepper (Tepper Sports & Entertainment)",
      "notes": "MLS expansion awarded December 2019; record fee at the time; began play 2022.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "chicago-fire-fc": {
    "formation": {
      "year": 1997,
      "price": 5000000,
      "founder": "Anschutz Entertainment Group (Philip Anschutz), league investor-operator",
      "notes": "Founded 8 Oct 1997 as MLS expansion club, began play 1998; $5M fee per MLS expansion history. AEG listed as the investor-operator.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2007,
        "price": 35000000,
        "buyer": "Andell Holdings (Andrew Hauptman)",
        "seller": "Anschutz Entertainment Group",
        "stakePct": 100,
        "notes": "Announced 6 Sep 2007; price reported as 'upwards of $35 million'.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Fire_FC"
        ]
      },
      {
        "year": 2019,
        "price": null,
        "buyer": "Joe Mansueto",
        "seller": "Andrew Hauptman / Andell Holdings",
        "stakePct": 51,
        "notes": "Mansueto bought 49% in July 2018 (minority), then Hauptman's remaining 51% on 13 Sep 2019 to become sole owner. Price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Fire_FC"
        ]
      }
    ]
  },
  "fc-cincinnati": {
    "formation": {
      "year": 2018,
      "price": 150000000,
      "founder": "Carl H. Lindner III and ownership group",
      "notes": "MLS expansion awarded May 2018; began MLS play 2019.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "columbus-crew-sc": {
    "formation": {
      "year": 1994,
      "price": null,
      "founder": "Lamar Hunt (Hunt Sports Group)",
      "notes": "MLS charter club (franchise established 1994, began play 1996); Hunt was the founding investor-operator. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": null,
        "buyer": "Hunt family / Hunt Sports Group (Clark Hunt)",
        "seller": "Lamar Hunt (died 14 Dec 2006)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Columbus_Crew"
        ]
      },
      {
        "year": 2013,
        "price": null,
        "buyer": "Precourt Sports Ventures (Anthony Precourt)",
        "seller": "Hunt Sports Group",
        "stakePct": 100,
        "notes": "30 Jul 2013; Precourt became the club's second investor-operator. Price not given in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Columbus_Crew"
        ]
      },
      {
        "year": 2019,
        "price": null,
        "buyer": "Haslam Sports Group (Jimmy & Dee Haslam) and Dr. Pete Edwards",
        "seller": "Precourt Sports Ventures",
        "stakePct": 100,
        "notes": "Sale announced 28 Dec 2018, control transferred 1 Jan 2019 ('Save the Crew'); Precourt received Austin expansion rights. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Columbus_Crew"
        ]
      }
    ]
  },
  "d-c-united": {
    "formation": {
      "year": 1995,
      "price": null,
      "founder": "Washington Soccer L.P. (primary financial backer George Soros)",
      "notes": "MLS charter club, began play 1996. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2001,
        "price": null,
        "buyer": "Anschutz Entertainment Group",
        "seller": "Washington Soccer L.P.",
        "stakePct": 100,
        "notes": "AEG acquired the team 15 Feb 2001, sole operator by 8 Jan 2002. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/D.C._United"
        ]
      },
      {
        "year": 2007,
        "price": 33000000,
        "buyer": "D.C. United Holdings (Victor MacFarlane, William Chang et al.)",
        "seller": "Anschutz Entertainment Group",
        "stakePct": 100,
        "notes": "Operating rights transferred 8 Jan 2007; record fee for MLS operating rights at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/D.C._United_Holdings"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "William Chang",
        "seller": "Victor MacFarlane (and minority holders Brian Davis, Christian Laettner)",
        "stakePct": 100,
        "notes": "May 2009 Chang bought MacFarlane's stake (to 98%), then the remaining 2% by Oct 2009.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/D.C._United_Holdings"
        ]
      },
      {
        "year": 2012,
        "price": null,
        "buyer": "Erick Thohir and Jason Levien",
        "seller": "William Chang (retained minority)",
        "stakePct": null,
        "notes": "July 2012; Thohir/Levien acquired control with Chang remaining a minority partner. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/D.C._United_Holdings",
          "https://en.wikipedia.org/wiki/D.C._United"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Jason Levien (with Steven Kaplan)",
        "seller": "Erick Thohir",
        "stakePct": null,
        "notes": "August 2018 Levien bought Thohir's majority stake (Thohir had bought Chang's 35% in Oct 2016). Price/valuation not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/D.C._United",
          "https://www.dcunited.com/news/dc-united-announce-consolidation-ownership"
        ]
      }
    ]
  },
  "inter-miami-cf": {
    "formation": {
      "year": 2018,
      "price": 25000000,
      "founder": "Miami Beckham United (David Beckham, Simon Fuller, Marcelo Claure, Masayoshi Son, Jorge & José Mas)",
      "notes": "$25M option price was written into Beckham's 2007 LA Galaxy contract; option exercised 5 Feb 2014; MLS formally awarded the club 29 Jan 2018; began play 2020.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2021,
        "price": null,
        "buyer": "Jorge Mas and José Mas",
        "seller": "Marcelo Claure and Masayoshi Son",
        "stakePct": null,
        "notes": "Mas brothers bought out Claure and Son to take majority ownership (Beckham had bought out Fuller in May 2019). Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Inter_Miami_CF"
        ]
      }
    ]
  },
  "cf-montreal": {
    "formation": {
      "year": 2010,
      "price": 40000000,
      "founder": "Joey Saputo",
      "notes": "MLS expansion awarded 2010 (as Montreal Impact); began MLS play 2012.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "nashville-sc": {
    "formation": {
      "year": 2017,
      "price": 150000000,
      "founder": "John R. Ingram-led ownership group",
      "notes": "MLS expansion awarded December 2017; began play 2020.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "new-england-revolution": {
    "formation": {
      "year": 1995,
      "price": null,
      "founder": "Robert Kraft (Kraft Group)",
      "notes": "Kraft became founding investor-operator 6 Jun 1995; MLS charter club, began play 1996. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "new-york-city-fc": {
    "formation": {
      "year": 2013,
      "price": 100000000,
      "founder": "City Football Group (Manchester City owners) and New York Yankees",
      "notes": "MLS expansion awarded May 2013; began play 2015.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "new-york-red-bulls": {
    "formation": {
      "year": 1994,
      "price": null,
      "founder": "John Kluge and Stuart Subotnick (Metromedia) - NY/NJ MetroStars",
      "notes": "Established October 1994 as MLS charter club, began play 1996. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": null,
        "buyer": "Red Bull GmbH",
        "seller": "Anschutz Entertainment Group (investor-operator at the time)",
        "stakePct": 100,
        "notes": "Announced 9 Mar 2006; club rebranded New York Red Bulls. Intermediate transfer from Metromedia to AEG (early 2000s) not dated in sources reviewed. Price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Red_Bulls",
          "https://en.wikipedia.org/wiki/Anschutz_Entertainment_Group"
        ]
      }
    ]
  },
  "orlando-city-sc": {
    "formation": {
      "year": 2013,
      "price": 70000000,
      "founder": "Flávio Augusto da Silva (majority) with Phil Rawlins",
      "notes": "MLS expansion awarded November 2013; began play 2015.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2021,
        "price": null,
        "buyer": "Wilf family (Zygi, Mark and Leonard Wilf)",
        "seller": "Flávio Augusto da Silva",
        "stakePct": null,
        "notes": "Announced 12 May 2021, completed 21 Jul 2021; included Orlando Pride (NWSL), stadium and related assets. Combined value estimated at $400-450M (range only; no single figure).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Orlando_City_SC"
        ]
      }
    ]
  },
  "philadelphia-union": {
    "formation": {
      "year": 2008,
      "price": 30000000,
      "founder": "Keystone Sports & Entertainment (Jay Sugarman, managing partner)",
      "notes": "Awarded 28 Feb 2008; began play 2010.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "toronto-fc": {
    "formation": {
      "year": 2005,
      "price": 10000000,
      "founder": "Maple Leaf Sports & Entertainment (MLSE)",
      "notes": "US$10M expansion fee; began play 2007. Ownership changes below are at the MLSE parent level (Leafs, Raptors, Argonauts etc.), so no club-level price exists.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2012,
        "price": null,
        "buyer": "Rogers Communications and BCE (Bell) joint venture",
        "seller": "Ontario Teachers' Pension Plan",
        "stakePct": null,
        "notes": "Parent-level: OTPP sold its majority of MLSE to Rogers/BCE. Parent price not captured here; no Toronto FC-specific price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Rogers Communications (to 75% of MLSE)",
        "seller": "BCE (Bell)",
        "stakePct": 37.5,
        "notes": "Parent-level: Rogers bought BCE's 37.5% for C$4.7B, valuing MLSE at C$12.5B and giving Rogers majority control; Kilmer Sports (Tanenbaum) holds the other 25%. No Toronto FC-specific price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "austin-fc": {
    "formation": {
      "year": 2019,
      "price": 150000000,
      "founder": "Anthony Precourt (Precourt Sports Ventures, renamed Two Oak Ventures)",
      "notes": "Officially announced 15 Jan 2019; began play 2021. The $150M fee is listed in MLS expansion histories. The club's own Wikipedia article gives no fee, so treat it as approximate.",
      "isEstimated": true
    },
    "saleHistory": []
  },
  "colorado-rapids": {
    "formation": {
      "year": 1995,
      "price": null,
      "founder": "Anschutz Corporation (Philip Anschutz)",
      "notes": "MLS charter club, began play 1996; Anschutz was investor-operator. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2003,
        "price": null,
        "buyer": "Kroenke Sports & Entertainment (Stan Kroenke)",
        "seller": "Philip Anschutz",
        "stakePct": 100,
        "notes": "Price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Kroenke_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "fc-dallas": {
    "formation": {
      "year": 1995,
      "price": null,
      "founder": "Major League Soccer (league-financed Dallas Burn; no outside investor-operator)",
      "notes": "MLS charter club, began play 1996. The Burn initially attracted no investors and was financed by the league.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2003,
        "price": null,
        "buyer": "Hunt Sports Group (Lamar Hunt)",
        "seller": "Major League Soccer",
        "stakePct": 100,
        "notes": "Operating rights acquired by Hunt Sports Group; renamed FC Dallas in 2005. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/FC_Dallas"
        ]
      },
      {
        "year": 2006,
        "price": null,
        "buyer": "Hunt family (Clark Hunt, Dan Hunt)",
        "seller": "Lamar Hunt (died 14 Dec 2006)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/FC_Dallas"
        ]
      }
    ]
  },
  "houston-dynamo-fc": {
    "formation": {
      "year": 2005,
      "price": null,
      "founder": "Anschutz Entertainment Group",
      "notes": "Established 15 Dec 2005 when AEG moved the San Jose Earthquakes operation to Houston; began play 2006. No expansion fee (relocation).",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2015,
        "price": null,
        "buyer": "Gabriel Brener (Brener International Group)",
        "seller": "Anschutz Entertainment Group",
        "stakePct": 50,
        "notes": "Brener and Oscar De La Hoya each bought 25% in Feb 2008 while AEG kept 50%. After the 2015 season Brener bought out AEG's remaining stake and became majority owner. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Dynamo_FC"
        ]
      },
      {
        "year": 2021,
        "price": null,
        "impliedValuation": 400000000,
        "buyer": "Ted Segal",
        "seller": "Gabriel Brener and partners",
        "stakePct": null,
        "notes": "Completed 22 Jun 2021. Majority stake in the Dynamo and NWSL Houston Dash; transaction reportedly valued at $400M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Dynamo_FC",
          "https://www.mlssoccer.com/news/houston-dynamo-fc-announce-ted-segal-as-new-majority-owner"
        ]
      }
    ]
  },
  "la-galaxy": {
    "formation": {
      "year": 1994,
      "price": null,
      "founder": "MLS charter club; current owner Anschutz Entertainment Group",
      "notes": "Founded 1994, began play 1996. The original 1995-96 investor-operator, and the date and price of AEG's takeover, could not be verified in this pass, so no sale entries are recorded.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "los-angeles-fc": {
    "formation": {
      "year": 2014,
      "price": 110000000,
      "founder": "Consortium led by Henry Nguyen and Peter Guber (with Magic Johnson, Mia Hamm and others); later managed by Bennett Rosenthal, Larry Berg and Brandon Beck",
      "notes": "Awarded Oct 2014; began play 2018.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "minnesota-united-fc": {
    "formation": {
      "year": 2015,
      "price": 100000000,
      "founder": "Bill McGuire (with Pohlad family, Glen Taylor, Wendy Carlson Nelson)",
      "notes": "MLS expansion awarded 2015; began play 2017.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "portland-timbers": {
    "formation": {
      "year": 2009,
      "price": 35000000,
      "founder": "Merritt Paulson (Peregrine Sports)",
      "notes": "Announced 20 Mar 2009; began MLS play 2011.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "real-salt-lake": {
    "formation": {
      "year": 2004,
      "price": 7500000,
      "founder": "Dave Checketts (SCP Worldwide)",
      "notes": "Founded 14 Jul 2004; began play 2005.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2013,
        "price": null,
        "buyer": "Dell Loy Hansen",
        "seller": "Dave Checketts",
        "stakePct": null,
        "notes": "Minority owner Hansen took controlling interest. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Real_Salt_Lake"
        ]
      },
      {
        "year": 2022,
        "price": null,
        "buyer": "Ryan Smith (Smith Entertainment Group) and David Blitzer",
        "seller": "Dell Loy Hansen",
        "stakePct": null,
        "notes": "Acquired before the 2022 season after Hansen agreed in 2020 to sell. Price not given in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Real_Salt_Lake"
        ]
      },
      {
        "year": 2025,
        "price": 600000000,
        "buyer": "Miller Sports + Entertainment (Gail Miller family)",
        "seller": "Ryan Smith and David Blitzer (Blitzer retained minority)",
        "stakePct": null,
        "notes": "Announced 18 Apr 2025. Controlling interest in RSL, Utah Royals (NWSL) and America First Field for $600M, so the price covers more than the MLS club.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Real_Salt_Lake",
          "https://en.wikipedia.org/wiki/Miller_Sports_%2B_Entertainment"
        ]
      }
    ]
  },
  "san-diego-fc": {
    "formation": {
      "year": 2023,
      "price": 500000000,
      "founder": "Mohamed Mansour and Sycuan Band of the Kumeyaay Nation",
      "notes": "Awarded 18 May 2023; record fee; began play 2025.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "san-jose-earthquakes": {
    "formation": {
      "year": 2007,
      "price": 20000000,
      "founder": "Lewis Wolff and John Fisher",
      "notes": "Formally awarded 18 Jul 2007; began play 2008. The club keeps the history of the 1996 San Jose Clash/Earthquakes charter club, which was league-owned and later operated by AEG before relocating to Houston in 2005. John Fisher put the club up for sale on 18 Jun 2025 (Moelis), but as of Sep 2026 no sale had been completed.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "seattle-sounders-fc": {
    "formation": {
      "year": 2007,
      "price": 30000000,
      "founder": "Joe Roth (majority), Adrian Hanauer, Paul Allen, Drew Carey",
      "notes": "Awarded 13 Nov 2007; began play 2009.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2015,
        "price": null,
        "buyer": "Adrian Hanauer",
        "seller": "Joe Roth",
        "stakePct": null,
        "notes": "November 2015 Hanauer became majority owner, succeeding Roth. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Seattle_Sounders_FC"
        ]
      }
    ]
  },
  "sporting-kansas-city": {
    "formation": {
      "year": 1995,
      "price": null,
      "founder": "Lamar Hunt",
      "notes": "MLS charter club (Kansas City Wiz/Wizards), began play 1996. Charter fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": null,
        "buyer": "OnGoal LLC (Cliff Illig, Neal Patterson and partners)",
        "seller": "Lamar Hunt / Hunt Sports Group",
        "stakePct": 100,
        "notes": "August 2006. Price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Sporting_Kansas_City"
        ]
      },
      {
        "year": 2026,
        "price": null,
        "impliedValuation": 700000000,
        "buyer": "Peter Mallouk",
        "seller": "Illig family",
        "stakePct": 71,
        "notes": "Deal finalized December 2025 and reported January 2026. Mallouk bought 71%, taking him to 80% at a reported $700M valuation, an MLS record for a majority stake. The Illig family keeps day-to-day control and the Board of Governors seat. The price paid for the 71% was not reported.",
        "isEstimated": true,
        "sources": [
          "https://www.espn.com/soccer/story/_/id/47663817/sporting-kc-majority-stake-sold-700m-valuation",
          "https://www.forbes.com/sites/justinbirnbaum/2026/01/16/sporting-kansas-city-is-being-sold-for-roughly-700-million-an-mls-record/",
          "https://www.kshb.com/sports/sporting-kc/local-ceo-kansas-city-native-peter-mallouk-becomes-new-sporting-kc-majority-owner"
        ]
      }
    ]
  },
  "st-louis-city-sc": {
    "formation": {
      "year": 2019,
      "price": 200000000,
      "founder": "Carolyn Kindle Betz and the Taylor family (with Jim Kavanaugh)",
      "notes": "Awarded August 2019; began play 2023.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "vancouver-whitecaps-fc": {
    "formation": {
      "year": 2009,
      "price": 35000000,
      "founder": "Greg Kerfoot, Steve Luczo, Jeff Mallett, Steve Nash",
      "notes": "Awarded March 2009; began MLS play 2011. The owners began a sale process in Dec 2024 but later said they were seeking a partner instead. As of Sep 2026 the CEO said nothing had changed, so no control sale is recorded.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "manchester-united": {
    "formation": {
      "year": 1878,
      "price": null,
      "founder": "Newton Heath LYR F.C. (Lancashire & Yorkshire Railway workers)",
      "notes": "Renamed Manchester United in 1902.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1902,
        "price": null,
        "buyer": "John Henry Davies and three other local businessmen",
        "seller": "Newton Heath (facing a winding-up order)",
        "stakePct": null,
        "notes": "Rescue in which each of four businessmen invested GBP 500; club reborn as Manchester United on 24 Apr 1902. This was an investment, not a purchase price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Manchester_United_F.C."
        ]
      },
      {
        "year": 1931,
        "price": null,
        "buyer": "James W. Gibson",
        "seller": "n/a (rescue investment)",
        "stakePct": null,
        "notes": "December 1931 Gibson invested GBP 2,000 and took control to avert bankruptcy. This was an investment, not a purchase price. Later Edwards family control (Louis, then Martin Edwards) is not dated in sources reviewed. Floated on LSE 1991.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Manchester_United_F.C."
        ]
      },
      {
        "year": 2005,
        "price": 1460000000,
        "buyer": "Malcolm Glazer (Red Football)",
        "seller": "Manchester United plc public shareholders",
        "stakePct": 98,
        "notes": "Takeover at 300p/share: 75.7% on 16 May 2005 and 98% by 28 Jun 2005. Total almost GBP 790M, converted at ~1.85 USD/GBP (source says about $1.5B at the time). Largely debt-financed. INEOS's 2024 ~28-29% stake with football operations control is a minority stake and is not recorded as a control sale.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Glazer_ownership_of_Manchester_United"
        ]
      }
    ]
  },
  "manchester-city": {
    "formation": {
      "year": 1880,
      "price": null,
      "founder": "St. Mark's (West Gorton) church team",
      "notes": "Became Ardwick AFC in 1887 and Manchester City in 1894.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2007,
        "price": 164000000,
        "buyer": "Thaksin Shinawatra (UK Sports Investments)",
        "seller": "Manchester City plc shareholders",
        "stakePct": 75,
        "notes": "Board accepted offer 21 Jun 2007; 75% (enough for full control) reached 6 Jul 2007. Deal GBP 81.6M, converted at ~2.01 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_Manchester_City_F.C._(2001%E2%80%93present)"
        ]
      },
      {
        "year": 2008,
        "price": 356000000,
        "buyer": "Abu Dhabi United Group (Sheikh Mansour bin Zayed Al Nahyan)",
        "seller": "Thaksin Shinawatra",
        "stakePct": 100,
        "notes": "Agreed 1 Sep 2008 and completed by 23 Sep 2008. Reported GBP 200M (GBP 210M is also widely cited), converted at ~1.78 USD/GBP. Later City Football Group minority sales (CMC 2015, Silver Lake 2019) are not control changes.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/2008%E2%80%9309_Manchester_City_F.C._season",
          "https://en.wikipedia.org/wiki/Abu_Dhabi_United_Group"
        ]
      }
    ]
  },
  "liverpool": {
    "formation": {
      "year": 1892,
      "price": null,
      "founder": "John Houlding",
      "notes": "Founded after Everton left Anfield.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2007,
        "price": 429000000,
        "buyer": "George Gillett Jr. and Tom Hicks",
        "seller": "David Moores and other shareholders",
        "stakePct": 100,
        "notes": "February 2007 deal valuing the club and its outstanding debts at GBP 218.9M, converted at ~1.96 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_Liverpool_F.C._(1985%E2%80%93present)"
        ]
      },
      {
        "year": 2010,
        "price": 477000000,
        "buyer": "Fenway Sports Group (John W. Henry, Tom Werner)",
        "seller": "George Gillett Jr. and Tom Hicks (court-backed sale forced by creditors RBS)",
        "stakePct": 100,
        "notes": "Agreed 6 Oct 2010 and completed 15 Oct 2010 for GBP 300M, converted at ~1.59 USD/GBP. RedBird (2021) and Dynasty (2023) investments are minority. FSG's agreed sale of 38% to 1892 Holdings (14 Aug 2026) leaves FSG with 62% and control, so it is not recorded as a control sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Fenway_Sports_Group",
          "https://en.wikipedia.org/wiki/History_of_Liverpool_F.C._(1985%E2%80%93present)"
        ]
      }
    ]
  },
  "arsenal": {
    "formation": {
      "year": 1886,
      "price": null,
      "founder": "Dial Square (Woolwich munitions workers led by David Danskin)",
      "notes": "Later Royal Arsenal and Woolwich Arsenal.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1910,
        "price": null,
        "buyer": "Henry Norris (with William Hall)",
        "seller": "n/a (financially troubled Woolwich Arsenal)",
        "stakePct": null,
        "notes": "Norris took over the club around 1910. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arsenal_F.C."
        ]
      },
      {
        "year": 2011,
        "price": null,
        "impliedValuation": 1192000000,
        "buyer": "Stan Kroenke (Kroenke Sports & Entertainment)",
        "seller": "Danny Fiszman estate and Lady Nina Bracewell-Smith",
        "stakePct": null,
        "notes": "11 Apr 2011; KSE raised its holding to 62.89% (majority control) at GBP 11,750/share, valuing the club at GBP 731M, converted at ~1.63 USD/GBP. Total paid for the purchased stakes not stated in the source.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Kroenke_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2018,
        "price": 710000000,
        "buyer": "Kroenke Sports & Entertainment",
        "seller": "Alisher Usmanov (Red & White Holdings)",
        "stakePct": 30,
        "notes": "August 2018. Usmanov accepted GBP 550M for his ~30%, converted at ~1.29 USD/GBP; KSE moved above 90% and then to full ownership. This consolidated control Kroenke already held.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Alisher_Usmanov",
          "https://en.wikipedia.org/wiki/Kroenke_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "chelsea": {
    "formation": {
      "year": 1905,
      "price": null,
      "founder": "Gus Mears",
      "notes": "Founded 10 Mar 1905; Mears family controlled the club until 1982.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1982,
        "price": 2,
        "buyer": "Ken Bates",
        "seller": "Brian Mears / Mears family",
        "stakePct": null,
        "notes": "Nominal GBP 1 (about US$2 at ~1.78 USD/GBP); Bates took on the club's debts.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chelsea_F.C."
        ]
      },
      {
        "year": 2003,
        "price": 227000000,
        "buyer": "Roman Abramovich",
        "seller": "Ken Bates and Chelsea Village plc shareholders",
        "stakePct": 100,
        "notes": "July 2003. GBP 60M for the shares plus responsibility for GBP 80M of debt, GBP 140M in total, converted at ~1.62 USD/GBP. The equity alone was ~$97M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chelsea_F.C."
        ]
      },
      {
        "year": 2022,
        "price": 5310000000,
        "buyer": "BlueCo 22 Ltd (Clearlake Capital majority; Todd Boehly, Mark Walter, Hansjörg Wyss)",
        "seller": "Roman Abramovich (UK-sanctions-mandated sale)",
        "stakePct": 100,
        "notes": "Completed 30 May 2022. Headline GBP 4.25B, converted at ~1.25 USD/GBP. The headline includes committed future investment on top of the share purchase price. Abramovich wrote off GBP 1.5B of loans before the sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/BlueCo",
          "https://en.wikipedia.org/wiki/Chelsea_F.C."
        ]
      },
      {
        "year": 2026,
        "price": null,
        "buyer": "Clearlake Capital",
        "seller": "Todd Boehly and Mark Walter",
        "stakePct": null,
        "notes": "Announced 16 Sep 2026: Clearlake acquired Boehly's and Walter's interests and 'full control' (Wyss remains a stakeholder). Clearlake was already BlueCo's majority shareholder, so this consolidates control rather than changing it. Price not disclosed. Single-source (Wikipedia citing the club announcement); verify.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/BlueCo"
        ]
      }
    ]
  },
  "tottenham-hotspur": {
    "formation": {
      "year": 1882,
      "price": null,
      "founder": "Hotspur F.C. (schoolboys of the Hotspur Cricket Club)",
      "notes": "Became a limited company in 1898.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1982,
        "price": null,
        "buyer": "Irving Scholar (with Paul Bobroff)",
        "seller": "Previous board/shareholders",
        "stakePct": null,
        "notes": "Scholar took over in the early 1980s. The year is not stated in the source reviewed, so treat it as approximate. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tottenham_Hotspur_F.C."
        ]
      },
      {
        "year": 1991,
        "price": null,
        "buyer": "Alan Sugar and Terry Venables",
        "seller": "Tottenham Hotspur plc (Scholar era)",
        "stakePct": null,
        "notes": "June 1991, after a takeover battle with Robert Maxwell. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tottenham_Hotspur_F.C.",
          "https://en.wikipedia.org/wiki/Alan_Sugar"
        ]
      },
      {
        "year": 2001,
        "price": 32000000,
        "buyer": "ENIC Sports plc (Joe Lewis, Daniel Levy)",
        "seller": "Alan Sugar",
        "stakePct": 27,
        "notes": "February 2001: controlling 27% for GBP 22M, converted at ~1.46 USD/GBP. ENIC bought Sugar's remaining 12% in Jun 2007 for GBP 25M and reached ~85-87%. Later Lewis Family Trust restructuring and 2025-26 cash injections are not sales of control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Alan_Sugar",
          "https://en.wikipedia.org/wiki/ENIC_Group"
        ]
      }
    ]
  },
  "newcastle-united": {
    "formation": {
      "year": 1892,
      "price": null,
      "founder": "Merger of Newcastle East End and Newcastle West End",
      "notes": "Incorporated as a limited company 6 Sep 1895.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": 5300000,
        "buyer": "John Hall",
        "seller": "Previous shareholders",
        "stakePct": 79.2,
        "notes": "GBP 3M for 79.2% per Wikipedia, converted at ~1.77 USD/GBP. The takeover battle ran 1990-92, so the year is approximate.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Newcastle_United_F.C."
        ]
      },
      {
        "year": 2007,
        "price": 110000000,
        "buyer": "Mike Ashley (St James Holdings)",
        "seller": "Sir John Hall and Douglas Hall (plus Freddy Shepherd and public shareholders via the offer)",
        "stakePct": 41.6,
        "notes": "7 Jun 2007: Hall family's 41.6% for GBP 55.34M, converted at ~1.99 USD/GBP. Ashley went to 95%+ by 11 Jul 2007 and then 100%. Total paid for 100% is widely reported at about GBP 134M, but sources are inconsistent.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mike_Ashley_(businessman)",
          "https://en.wikipedia.org/wiki/Newcastle_United_F.C."
        ]
      },
      {
        "year": 2021,
        "price": 415000000,
        "buyer": "Public Investment Fund (80-85%), RB Sports & Media, PCP Capital Partners",
        "seller": "Mike Ashley",
        "stakePct": 100,
        "notes": "Completed 7 Oct 2021. Reported GBP 305M (GBP 300M in some sources), converted at ~1.36 USD/GBP. PCP (Staveley) exited in 2024, leaving PIF 85% and RB 15%.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Newcastle_United_F.C.",
          "https://en.wikipedia.org/wiki/Mike_Ashley_(businessman)"
        ]
      }
    ]
  },
  "aston-villa": {
    "formation": {
      "year": 1874,
      "price": null,
      "founder": "Members of the Villa Cross Wesleyan Chapel, Handsworth",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1968,
        "price": null,
        "buyer": "Doug Ellis",
        "seller": "Previous board/shareholders",
        "stakePct": null,
        "notes": "December 1968. Ellis was later chairman and majority shareholder (~38%). Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Aston_Villa_F.C."
        ]
      },
      {
        "year": 2006,
        "price": 117000000,
        "buyer": "Randy Lerner",
        "seller": "Doug Ellis and other shareholders",
        "stakePct": 100,
        "notes": "August-September 2006 for GBP 62.6M, converted at ~1.87 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Randy_Lerner",
          "https://en.wikipedia.org/wiki/Aston_Villa_F.C."
        ]
      },
      {
        "year": 2016,
        "price": 109000000,
        "buyer": "Tony Xia (Recon Group)",
        "seller": "Randy Lerner",
        "stakePct": 100,
        "notes": "June 2016 for GBP 76M, converted at ~1.44 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Aston_Villa_F.C."
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "NSWE (Nassef Sawiris, Wes Edens), later V Sports",
        "seller": "Tony Xia (Recon Group)",
        "stakePct": 55,
        "notes": "20 Jul 2018: controlling 55% investment, and Xia was later bought out. Price not disclosed. Atairos's 2024 stake is minority.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Aston_Villa_F.C."
        ]
      }
    ]
  },
  "brighton-and-hove-albion": {
    "formation": {
      "year": 1901,
      "price": null,
      "founder": "Brighton & Hove Albion F.C. (founded 1901)",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1997,
        "price": null,
        "buyer": "Dick Knight",
        "seller": "Bill Archer and board",
        "stakePct": null,
        "notes": "Knight took control after fan pressure removed the Archer/Bellotti board. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brighton_%26_Hove_Albion_F.C."
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Tony Bloom",
        "seller": "Dick Knight and shareholders",
        "stakePct": 75,
        "notes": "May 2009: Bloom became chairman with a 75% shareholding and secured GBP 93M funding for the Falmer stadium. This was an investment, not a share purchase price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brighton_%26_Hove_Albion_F.C."
        ]
      }
    ]
  },
  "west-ham-united": {
    "formation": {
      "year": 1895,
      "price": null,
      "founder": "Thames Ironworks F.C. (Arnold Hills and Dave Taylor)",
      "notes": "Re-formed as West Ham United in 1900.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": 163000000,
        "buyer": "Icelandic consortium (Eggert Magnússon; Björgólfur Guðmundsson majority)",
        "seller": "Terence Brown and West Ham United plc shareholders",
        "stakePct": 100,
        "notes": "November 2006 for GBP 85M, converted at ~1.92 USD/GBP. The source does not say whether debt is included.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Eggert_Magn%C3%BAsson"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "CB Holding (creditor-led vehicle)",
        "seller": "Björgólfur Guðmundsson (Hansa)",
        "stakePct": null,
        "notes": "Creditors took control after the Icelandic banking collapse. No purchase price. Date approximate.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/David_Sullivan_(businessman)"
        ]
      },
      {
        "year": 2010,
        "price": null,
        "impliedValuation": 170000000,
        "buyer": "David Sullivan and David Gold",
        "seller": "CB Holding",
        "stakePct": 50,
        "notes": "January 2010: 50% with operational and commercial control, valuing the club at GBP 105M, converted at ~1.62 USD/GBP. Combined stake rose to 60% in May 2010. Kretinsky bought ~27% in 2021 (minority).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/David_Sullivan_(businessman)"
        ]
      },
      {
        "year": 2026,
        "price": null,
        "buyer": "Daniel Kretinsky (1890s Holdings) - becomes largest shareholder",
        "seller": "Gold family (Vanessa Gold's ~25.1%, shared among existing holders under pre-emption rights)",
        "stakePct": 19,
        "notes": "Reported 4 Sep 2026: Kretinsky 27% to 46%, Sullivan ~40%, Tripp Smith ~11%. This changes the largest shareholder but no one holds a majority, so it may not count as a sale of a controlling interest. Price not disclosed. Amanda Staveley's ~GBP 150M bid for the Gold stake was blocked.",
        "isEstimated": false,
        "sources": [
          "https://www.insideworldfootball.com/2026/09/04/daniel-kretinsky-ups-west-ham-united-shareholding-to-46",
          "https://www.bloomberg.com/news/articles/2026-09-04/west-ham-takeover-saga-sees-sullivan-and-kretinsky-raise-stakes"
        ]
      }
    ]
  },
  "crystal-palace": {
    "formation": {
      "year": 1905,
      "price": null,
      "founder": "The Crystal Palace Company",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1949,
        "price": null,
        "buyer": "Consortium incl. Arthur Wait",
        "seller": "The Crystal Palace Company",
        "stakePct": null,
        "notes": "Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Crystal_Palace_F.C."
        ]
      },
      {
        "year": 1981,
        "price": null,
        "buyer": "Ron Noades",
        "seller": "Previous owners",
        "stakePct": null,
        "notes": "26 Jan 1981. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Crystal_Palace_F.C."
        ]
      },
      {
        "year": 1998,
        "price": null,
        "buyer": "Mark Goldberg",
        "seller": "Ron Noades",
        "stakePct": null,
        "notes": "5 Jun 1998; Noades kept Selhurst Park. The club entered administration in March 1999. Price not documented in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Crystal_Palace_F.C."
        ]
      },
      {
        "year": 2000,
        "price": null,
        "buyer": "Simon Jordan (CPFC 2000)",
        "seller": "Administrators",
        "stakePct": null,
        "notes": "Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Crystal_Palace_F.C."
        ]
      },
      {
        "year": 2010,
        "price": null,
        "buyer": "CPFC 2010 (Steve Parish, Martin Long, Stephen Browett, Jeremy Hosking; 25% each)",
        "seller": "Administrators",
        "stakePct": 100,
        "notes": "June 2010. Selhurst Park bought back from Lloyds. Later deals are not control sales: Harris/Blitzer 2015 (GBP 50M), Textor 40% 2021 (GBP 87.5M) and Woody Johnson's ~43% from Textor (Jul 2025, ~GBP 190M) are all non-majority, and Parish retains day-to-day control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Crystal_Palace_F.C.",
          "https://www.espn.com/soccer/story/_/id/45813769/jets-owner-johnson-completes-purchase-stake-crystal-palace"
        ]
      }
    ]
  },
  "everton": {
    "formation": {
      "year": 1878,
      "price": null,
      "founder": "St Domingo's F.C. (St Domingo Methodist New Connexion Chapel)",
      "notes": "Renamed Everton in 1879.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1994,
        "price": null,
        "buyer": "Peter Johnson",
        "seller": "Moores family",
        "stakePct": null,
        "notes": "Bid accepted over Kenwright's rival consortium. Price not documented in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Kenwright"
        ]
      },
      {
        "year": 1999,
        "price": 32000000,
        "buyer": "Bill Kenwright consortium (True Blue Holdings, formed Jan 2000)",
        "seller": "Peter Johnson",
        "stakePct": 68,
        "notes": "GBP 20M for 68%, converted at ~1.61 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Kenwright"
        ]
      },
      {
        "year": 2016,
        "price": null,
        "buyer": "Farhad Moshiri",
        "seller": "Kenwright group / existing shareholders",
        "stakePct": 49.9,
        "notes": "Confirmed 27 Feb 2016 as largest shareholder (de facto control); raised to 68.6% (Jan 2022) and then ~94.1%. Price not stated in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Farhad_Moshiri",
          "https://en.wikipedia.org/wiki/Everton_F.C."
        ]
      },
      {
        "year": 2024,
        "price": null,
        "buyer": "The Friedkin Group (Dan Friedkin)",
        "seller": "Farhad Moshiri",
        "stakePct": 94.1,
        "notes": "Agreed September 2024 and completed 19 Dec 2024 (holding ~99.5%). Followed 777 Partners' collapsed bid. Headline price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/The_Friedkin_Group",
          "https://www.premierleague.com/en/news/4199784",
          "https://www.skysports.com/football/news/11095/13275439/everton-takeover-the-friedkin-group-complete-deal-to-become-clubs-new-owners"
        ]
      }
    ]
  },
  "fulham": {
    "formation": {
      "year": 1879,
      "price": null,
      "founder": "Fulham St Andrew's Church Sunday School F.C.",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1997,
        "price": 11000000,
        "buyer": "Mohamed Al-Fayed",
        "seller": "Muddyman Group (Bill Muddyman) and shareholders",
        "stakePct": 100,
        "notes": "Summer 1997 for GBP 6.75M per Wikipedia (GBP 6.25M also cited), converted at ~1.63 USD/GBP.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Fulham_F.C."
        ]
      },
      {
        "year": 2013,
        "price": null,
        "buyer": "Shahid Khan",
        "seller": "Mohamed Al-Fayed",
        "stakePct": 100,
        "notes": "Finalized 12 Jul 2013. Price undisclosed; estimates range from GBP 150-200M (~$228-304M at ~1.52 USD/GBP), so no single figure is recorded.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Shahid_Khan"
        ]
      }
    ]
  },
  "wolverhampton-wanderers": {
    "formation": {
      "year": 1877,
      "price": null,
      "founder": "St Luke's F.C. (Blakenhall school team)",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1990,
        "price": null,
        "buyer": "Sir Jack Hayward",
        "seller": "Previous owners",
        "stakePct": 100,
        "notes": "Price not stated in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Wolverhampton_Wanderers_F.C."
        ]
      },
      {
        "year": 2007,
        "price": null,
        "buyer": "Steve Morgan (Bridgemere)",
        "seller": "Sir Jack Hayward",
        "stakePct": 100,
        "notes": "Widely reported as a nominal GBP 10 plus a commitment to invest GBP 30M, but that figure was not confirmed in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Wolverhampton_Wanderers_F.C."
        ]
      },
      {
        "year": 2016,
        "price": 59000000,
        "buyer": "Fosun International",
        "seller": "Steve Morgan / Bridgemere Group",
        "stakePct": 100,
        "notes": "21 Jul 2016. Parent W.W. (1990) Ltd for a reported GBP 45M, converted at ~1.31 USD/GBP. As of Sep 2026 Fosun still owns the club after the 2026 relegation, with no completed sale.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Wolverhampton_Wanderers_F.C.",
          "https://www.skysports.com/football/news/11699/10508468/wolves-confirm-takeover-by-chinese-group-fosun-international"
        ]
      }
    ]
  },
  "afc-bournemouth": {
    "formation": {
      "year": 1899,
      "price": null,
      "founder": "Boscombe F.C. (first president J. C. Nutt)",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2009,
        "price": null,
        "buyer": "Consortium incl. Eddie Mitchell, Adam Murray, Jeff Mostyn, Steve Sly, Neill Blake",
        "seller": "Previous owners",
        "stakePct": null,
        "notes": "June 2009. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/AFC_Bournemouth"
        ]
      },
      {
        "year": 2011,
        "price": null,
        "buyer": "Maxim Demin",
        "seller": "Eddie Mitchell consortium",
        "stakePct": null,
        "notes": "Demin's ownership began in 2011 and he later became sole owner. The staging and price are not documented in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/AFC_Bournemouth"
        ]
      },
      {
        "year": 2022,
        "price": 122000000,
        "buyer": "Black Knight Football Club (Bill Foley, Cannae Holdings; minority incl. Michael B. Jordan)",
        "seller": "Maxim Demin",
        "stakePct": 100,
        "notes": "Completed 13 Dec 2022 for 'over GBP 100M', converted at ~1.22 USD/GBP.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Black_Knight_Football_Club",
          "https://en.wikipedia.org/wiki/AFC_Bournemouth"
        ]
      }
    ]
  },
  "brentford": {
    "formation": {
      "year": 1889,
      "price": null,
      "founder": "Members of Brentford Rowing Club",
      "notes": "Founded 10 Oct 1889.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": null,
        "buyer": "Bees United (supporters' trust)",
        "seller": "Ron Noades era owners",
        "stakePct": null,
        "notes": "The fan trust took control after Noades left. Timing approximate (2002-2006) and price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brentford_F.C."
        ]
      },
      {
        "year": 2012,
        "price": null,
        "buyer": "Matthew Benham",
        "seller": "Bees United",
        "stakePct": 100,
        "notes": "June 2012 under the 2009 'Gecko' option deal (GBP 1M/year for 35% plus an option to full ownership). Minority investments, such as Matthew Vaughn's additional GBP 40M in Feb 2026, are not control changes.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brentford_F.C."
        ]
      }
    ]
  },
  "nottingham-forest": {
    "formation": {
      "year": 1865,
      "price": null,
      "founder": "Shinty players meeting at the Clinton Arms, Nottingham",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2012,
        "price": null,
        "buyer": "Al-Hasawi family (Fawaz Al-Hasawi 75%)",
        "seller": "Estate of Nigel Doughty",
        "stakePct": 100,
        "notes": "July 2012 following Doughty's death in Feb 2012. Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Nottingham_Forest_F.C."
        ]
      },
      {
        "year": 2017,
        "price": null,
        "buyer": "Evangelos Marinakis (NF Football Investments)",
        "seller": "Fawaz Al-Hasawi",
        "stakePct": null,
        "notes": "Completed 18 May 2017. Price not disclosed in sources reviewed. Placing Marinakis's shares in a blind trust in April 2025 (UEFA multi-club rules) was not a sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Nottingham_Forest_F.C.",
          "https://www.skysports.com/football/news/11727/13358618/nottingham-forest-evangelos-marinakis-withdraws-control-of-club-but-will-remain-as-owner"
        ]
      }
    ]
  },
  "ipswich-town": {
    "formation": {
      "year": 1878,
      "price": null,
      "founder": "Ipswich Association F.C.",
      "notes": "Cobbold family were long-time owners.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2007,
        "price": 88000000,
        "buyer": "Marcus Evans",
        "seller": "Previous shareholders",
        "stakePct": 87.5,
        "notes": "December 2007: ~GBP 44M including purchase of GBP 32M existing debt, converted at ~2.01 USD/GBP.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Ipswich_Town_F.C."
        ]
      },
      {
        "year": 2021,
        "price": null,
        "buyer": "Gamechanger 20 Ltd (ORG Portfolio Management and Three Lions Fund)",
        "seller": "Marcus Evans (retained minority)",
        "stakePct": null,
        "notes": "7 Apr 2021 majority stake. Price not disclosed in sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ipswich_Town_F.C."
        ]
      }
    ]
  },
  "leicester-city": {
    "formation": {
      "year": 1884,
      "price": null,
      "founder": "Leicester Fosse F.C. (former Wyggeston School pupils)",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2002,
        "price": null,
        "buyer": "Gary Lineker-led consortium",
        "seller": "Administrators",
        "stakePct": null,
        "notes": "Rescue from administration (GBP 30M debts). Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Leicester_City_F.C."
        ]
      },
      {
        "year": 2007,
        "price": 12000000,
        "buyer": "Milan Mandarić",
        "seller": "Lineker consortium shareholders",
        "stakePct": 100,
        "notes": "About GBP 6M, converted at ~1.96 USD/GBP.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Leicester_City_F.C."
        ]
      },
      {
        "year": 2010,
        "price": null,
        "buyer": "Asian Football Investments (Vichai Srivaddhanaprabha / King Power)",
        "seller": "Milan Mandarić (retained stake in AFI)",
        "stakePct": null,
        "notes": "Price not disclosed in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Leicester_City_F.C."
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Aiyawatt Srivaddhanaprabha / Srivaddhanaprabha family",
        "seller": "Vichai Srivaddhanaprabha (died 27 Oct 2018)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Leicester_City_F.C."
        ]
      }
    ]
  },
  "southampton": {
    "formation": {
      "year": 1885,
      "price": null,
      "founder": "St. Mary's Young Men's Association",
      "notes": "",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2009,
        "price": null,
        "buyer": "Markus Liebherr",
        "seller": "Administrators",
        "stakePct": 100,
        "notes": "June 2009. Price not stated in the source reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Southampton_F.C."
        ]
      },
      {
        "year": 2010,
        "price": null,
        "buyer": "Katharina Liebherr",
        "seller": "Markus Liebherr (died Aug 2010)",
        "stakePct": 100,
        "notes": "inheritance",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Southampton_F.C."
        ]
      },
      {
        "year": 2017,
        "price": 271000000,
        "buyer": "Gao Jisheng (Lander Sports)",
        "seller": "Katharina Liebherr",
        "stakePct": 80,
        "notes": "August 2017: 80% for ~GBP 210M, converted at ~1.29 USD/GBP.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Southampton_F.C."
        ]
      },
      {
        "year": 2022,
        "price": 135000000,
        "buyer": "Sport Republic (Dragan Šolak, Henrik Kraft, Rasmus Ankersen)",
        "seller": "Gao Jisheng",
        "stakePct": 80,
        "notes": "4 Jan 2022: 80% for GBP 100M, converted at ~1.35 USD/GBP.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Southampton_F.C.",
          "https://www.skysports.com/football/news/11700/12509028/southampton-takeover-club-confirm-serbian-born-businessman-dragan-solak-has-completed-lb100m-deal"
        ]
      }
    ]
  },
  "atlanta-hawks": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Ben Kerner and Leo Ferris",
      "notes": "Founded as the Buffalo Bisons (NBL) in 1946; moved to Moline as the Tri-Cities Blackhawks after 38 days, then Milwaukee (1951), St. Louis (1955), Atlanta (1968). Entry fee not found.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1968,
        "price": 3500000,
        "buyer": "Tom Cousins and Carl Sanders",
        "seller": "Ben Kerner",
        "stakePct": 100,
        "notes": "Sold May 3, 1968 and moved from St. Louis to Atlanta.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ben_Kerner",
          "https://retrosimba.com/2018/05/01/the-story-of-why-hawks-took-flight-from-st-louis/"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "Ted Turner",
        "seller": "Tom Cousins group",
        "stakePct": 100,
        "notes": "Turner, who already owned the Braves, bought the team in January 1977. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/1977/01/04/archives/turner-buys-the-hawks-day-after-baseball-ban.html",
          "https://en.wikipedia.org/wiki/Atlanta_Hawks"
        ]
      },
      {
        "year": 1996,
        "price": null,
        "buyer": "Time Warner",
        "seller": "Turner Broadcasting System",
        "stakePct": 100,
        "notes": "Corporate transfer, not a team sale: Time Warner took over the Hawks when it merged with Turner Broadcasting on October 10, 1996.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Hawks"
        ]
      },
      {
        "year": 2004,
        "price": null,
        "buyer": "Atlanta Spirit LLC (Bruce Levenson, Michael Gearon Jr. and partners)",
        "seller": "Time Warner / Turner Broadcasting",
        "stakePct": 100,
        "notes": "Sold March 31, 2004 together with the Atlanta Thrashers (NHL) and the operating rights to Philips Arena. No verified price for the Hawks alone.",
        "isEstimated": false,
        "sources": [
          "http://www.nba.com/hawks/news/atlanta_spirit_sale_040331.html",
          "https://en.wikipedia.org/wiki/Atlanta_Spirit"
        ]
      },
      {
        "year": 2015,
        "price": 850000000,
        "buyer": "Tony Ressler group",
        "seller": "Atlanta Spirit LLC",
        "stakePct": 100,
        "notes": "Agreed April 22, 2015 and approved June 24, 2015, including the arena operating rights. WSJ and Wikipedia report $850M; the Atlanta Business Chronicle reported $730M, so the price may exclude debt or arena items.",
        "isEstimated": true,
        "sources": [
          "http://www.nba.com/2015/news/06/24/sale-of-hawks-unanimously-approved/index.html",
          "https://www.wsj.com/articles/atlanta-hawks-selling-for-850-million-1429732095",
          "http://www.bizjournals.com/atlanta/news/2015/04/22/atlanta-hawks-sold-to-ares-ressler-for-730-million.html"
        ]
      }
    ]
  },
  "boston-celtics": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Walter A. Brown / Boston Garden-Arena Corporation",
      "notes": "BAA charter franchise, owned by the Boston Garden-Arena Corp from June 6, 1946.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1950,
        "price": null,
        "buyer": "Walter A. Brown and Lou Pieri",
        "seller": "Boston Garden-Arena Corporation",
        "stakePct": 100,
        "notes": "Brown bought the team in his own name on July 31, 1950, with Pieri as partner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics",
          "https://en.wikipedia.org/wiki/Walter_A._Brown"
        ]
      },
      {
        "year": 1964,
        "price": null,
        "buyer": "Marjorie Brown and Lou Pieri",
        "seller": "Estate of Walter A. Brown",
        "stakePct": null,
        "notes": "Inheritance: Brown's share passed to his widow on September 7, 1964.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Walter_A._Brown"
        ]
      },
      {
        "year": 1965,
        "price": null,
        "buyer": "Marvin Kratter / National Equities (Knickerbocker Brewing)",
        "seller": "Marjorie Brown and Lou Pieri",
        "stakePct": 100,
        "notes": "June 24, 1965. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 1968,
        "price": null,
        "buyer": "Ballantine Brewery (Investors Funding Corp)",
        "seller": "National Equities",
        "stakePct": 100,
        "notes": "No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 1969,
        "price": null,
        "buyer": "Trans-National Communications",
        "seller": "Ballantine / Investors Funding Corp",
        "stakePct": 100,
        "notes": "Control went back to Ballantine / Investors Funding from 1971 to 1972. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 1972,
        "price": 3950000,
        "buyer": "Robert Schmertz / Leisure Technology",
        "seller": "Investors Funding Corp (after the Irv Levin / Harold Lipton deal fell through)",
        "stakePct": 100,
        "notes": "In April 1972 Levin and Lipton bought the team for $3.7M, but the NBA did not approve the sale. In May 1972 they sold their shares to Schmertz for $3.95M, keeping an option to buy back half.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Irv_Levin",
          "https://www.nytimes.com/2014/05/11/sports/basketball/clippers-for-sale-and-the-owner-who-was-desperate.html"
        ]
      },
      {
        "year": 1975,
        "price": null,
        "buyer": "Irv Levin and Harold Lipton",
        "seller": "Robert Schmertz / Leisure Technology",
        "stakePct": 100,
        "notes": "Levin and Lipton became co-owners in January 1975 and bought the remaining stock ten months later, in November 1975.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Irv_Levin",
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "John Y. Brown Jr. and Harry Mangurian",
        "seller": "Irv Levin",
        "stakePct": 100,
        "notes": "Franchise swap: Levin traded the Celtics for the Buffalo Braves, which later became the Clippers. No cash price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics",
          "https://www.si.com/vault/1978/07/17/822808/will-red-and-brown-harmonize-the-celtics-smoothly-changed-hands-but-the-new-owner-and-old-gm-have-yet-to-shake-on-it"
        ]
      },
      {
        "year": 1979,
        "price": null,
        "buyer": "Harry Mangurian",
        "seller": "John Y. Brown Jr.",
        "stakePct": null,
        "notes": "Brown sold his interest to co-owner Mangurian. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/John_Y._Brown_Jr."
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Don Gaston, Alan Cohen and Paul Dupee",
        "seller": "Harry Mangurian",
        "stakePct": 100,
        "notes": "No verified price found. The team was partly floated as Boston Celtics LP in 1986.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 1993,
        "price": null,
        "buyer": "Paul Gaston",
        "seller": "Alan Cohen and partners",
        "stakePct": null,
        "notes": "Paul Gaston took control and Cohen left (Boston Globe, September 2, 1993). No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Celtics"
        ]
      },
      {
        "year": 2002,
        "price": 360000000,
        "buyer": "Boston Basketball Partners LLC (Wyc Grousbeck, Irving Grousbeck, Steve Pagliuca)",
        "seller": "Paul Gaston",
        "stakePct": 100,
        "notes": "Agreed September 2002, took over December 31, 2002. A record NBA price at the time.",
        "isEstimated": false,
        "sources": [
          "http://sportsillustrated.cnn.com/basketball/news/2002/09/27/celtics_sale_ap/",
          "https://www.espn.com/nba/columns/story?id=3399631"
        ]
      },
      {
        "year": 2025,
        "price": 6100000000,
        "buyer": "William Chisholm group (with Aditya Mittal and Sixth Street)",
        "seller": "Boston Basketball Partners (Wyc Grousbeck group)",
        "stakePct": 51,
        "notes": "Agreed March 20, 2025, NBA-approved mid-August and closed about August 19, 2025. $6.1B is the valuation for the first stage. Chisholm is due to buy out the remaining holders in 2028 at a $7.3B valuation (blended about $6.7B). The 51% first-stage stake is as reported.",
        "isEstimated": false,
        "sources": [
          "https://www.businesswire.com/news/home/20250320304302/en/Boston-Basketball-Partners-Announces-Sale-of-Boston-Celtics-to-Group-Organized-by-William-Chisholm-for-%246.1-Billion",
          "https://www.nba.com/celtics/news/081925-chisholm-group-takes-control-of-the-boston-celtics",
          "https://www.cnn.com/2025/08/14/sport/basketball-nba-boston-celtics-sale-intl",
          "https://www.sportico.com/business/team-sales/2025/boston-celtics-sale-chisholm-closes-billion-1234867472/"
        ]
      }
    ]
  },
  "brooklyn-nets": {
    "formation": {
      "year": 1967,
      "price": null,
      "founder": "Arthur J. Brown",
      "notes": "ABA charter franchise, the New Jersey Americans. On joining the NBA in 1976 the team paid the $3.2M NBA entry fee plus a $4.8M territorial 'invasion fee' to the Knicks.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1969,
        "price": 1100000,
        "buyer": "Roy Boe",
        "seller": "Arthur J. Brown",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brooklyn_Nets",
          "https://www.nytimes.com/1989/12/24/obituaries/arthur-j-brown-78-former-owner-of-nets.html"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "'Secaucus Seven' group (Joe Taub, Alan Cohen and others)",
        "seller": "Roy Boe",
        "stakePct": 100,
        "notes": "No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brooklyn_Nets",
          "https://www.espn.com/nba/news/story?id=4242513"
        ]
      },
      {
        "year": 1998,
        "price": null,
        "buyer": "Raymond Chambers and Lewis Katz group (later YankeeNets, 1999)",
        "seller": "'Secaucus Seven' group",
        "stakePct": 100,
        "notes": "No verified price found. YankeeNets was the holding company formed with George Steinbrenner in 1999.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Brooklyn_Nets",
          "https://en.wikipedia.org/wiki/YankeeNets"
        ]
      },
      {
        "year": 2004,
        "price": 300000000,
        "buyer": "Bruce Ratner (Brooklyn Basketball LLC)",
        "seller": "YankeeNets",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bruce_Ratner",
          "https://www.nytimes.com/2004/01/21/sports/basketball/21CND-NETS.html"
        ]
      },
      {
        "year": 2010,
        "price": 200000000,
        "buyer": "Mikhail Prokhorov (Onexim)",
        "seller": "Bruce Ratner group",
        "stakePct": 80,
        "notes": "$200M paid for an 80% stake; the deal also included a stake in the Barclays Center project and arena financing commitments. Approved May 11, 2010.",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/2009/09/24/sports/basketball/24nets.html",
          "https://www.bloomberg.com/news/2010-05-11/prokhorov-s-200-million-purchase-of-nets-gains-approval-from-nba-owners.html"
        ]
      },
      {
        "year": 2019,
        "price": 2350000000,
        "buyer": "Joseph Tsai",
        "seller": "Mikhail Prokhorov",
        "stakePct": 100,
        "notes": "Tsai bought 49% in 2018 and exercised his option for the remaining 51% in August 2019, closing September 18, 2019. $2.35B is the reported team valuation. Tsai separately bought Barclays Center for nearly $1B.",
        "isEstimated": false,
        "sources": [
          "http://www.nba.com/article/2019/08/14/report-joseph-tsai-buy-nets-23-billion",
          "https://www.nba.com/nets/news/2019/09/18/joe-tsai-completes-acquisition"
        ]
      }
    ]
  },
  "charlotte-hornets": {
    "formation": {
      "year": 2004,
      "price": 300000000,
      "founder": "Robert L. Johnson",
      "notes": "Expansion franchise, awarded December 2002 and approved January 10, 2003; played as the Charlotte Bobcats from 2004. Renamed Hornets in 2014 and took over the records of the 1988-2002 Charlotte Hornets. The legal franchise of the original Hornets is today's New Orleans Pelicans.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2010,
        "price": 275000000,
        "buyer": "Michael Jordan",
        "seller": "Robert L. Johnson",
        "stakePct": null,
        "notes": "Controlling stake; approved March 17, 2010. Jordan also assumed about $150M of debt.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/news/story?id=5003048",
          "http://www.cnn.com/2010/SPORT/02/27/michael.jordan.bobcats/index.html"
        ]
      },
      {
        "year": 2023,
        "price": 3000000000,
        "buyer": "Gabe Plotkin and Rick Schnall group",
        "seller": "Michael Jordan",
        "stakePct": null,
        "notes": "$3B valuation for a majority stake; approved July 23, 2023 and finalized August 2023. Jordan kept a minority stake.",
        "isEstimated": false,
        "sources": [
          "https://www.cbssports.com/nba/news/hornets-sale-approved-michael-jordans-13-year-run-as-nba-team-owner-ends-per-report/",
          "https://www.espn.com/nba/story/_/id/38127251/hornets-sale-michael-jordan-gabe-plotkin-rick-schnall-finalized"
        ]
      }
    ]
  },
  "chicago-bulls": {
    "formation": {
      "year": 1966,
      "price": null,
      "founder": "Dick Klein",
      "notes": "NBA expansion franchise granted January 16, 1966. Expansion fee not verified.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1972,
        "price": null,
        "buyer": "Investor group led by Arthur Wirtz and Lester Crown (with Lamar Hunt, Philip Klutznick and others)",
        "seller": "Dick Klein",
        "stakePct": null,
        "notes": "Controlling stake bought from Klein. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arthur_Wirtz",
          "https://en.wikipedia.org/wiki/Chicago_Bulls"
        ]
      },
      {
        "year": 1985,
        "price": 16000000,
        "buyer": "Jerry Reinsdorf syndicate",
        "seller": "Group including the Wirtz estate, Jonathan Kovler, Lester Crown, Lamar Hunt, George Steinbrenner",
        "stakePct": null,
        "notes": "The syndicate bought the team for $16M; Reinsdorf's own controlling interest was $9.2M. Control acquired March 11, 1985, rising to 63% in 1986.",
        "isEstimated": false,
        "sources": [
          "https://www.chicagotribune.com/1985/02/09/reinsdorf-buys-bulls/",
          "https://en.wikipedia.org/wiki/Jerry_Reinsdorf"
        ]
      }
    ]
  },
  "cleveland-cavaliers": {
    "formation": {
      "year": 1970,
      "price": 3700000,
      "founder": "Nick Mileti",
      "notes": "NBA expansion entry fee of $3.7M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1979,
        "price": null,
        "buyer": "Joe Zingale (via Louis Mitchell)",
        "seller": "Nick Mileti",
        "stakePct": null,
        "notes": "Mileti sold his shares to Louis Mitchell, who sold them to minority owner Joe Zingale. Mileti later said he sold his 20% interest for $1.4M.",
        "isEstimated": false,
        "sources": [
          "https://www.latimes.com/archives/la-xpm-1987-03-08-me-13419-story.html",
          "https://en.wikipedia.org/wiki/Nick_Mileti"
        ]
      },
      {
        "year": 1980,
        "price": null,
        "buyer": "Ted Stepien",
        "seller": "Joe Zingale",
        "stakePct": null,
        "notes": "April 12, 1980. Stepien first bought a 38% interest for $2M, then took control. No verified price for 100%.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ted_Stepien",
          "https://news.google.com/newspapers?id=hklPAAAAIBAJ&sjid=IwMEAAAAIBAJ&pg=7118%2C6256145"
        ]
      },
      {
        "year": 1983,
        "price": 20000000,
        "buyer": "George and Gordon Gund",
        "seller": "Ted Stepien",
        "stakePct": null,
        "notes": "Majority interest bought April 7, 1983.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Gordon_Gund"
        ]
      },
      {
        "year": 2005,
        "price": 375000000,
        "buyer": "Dan Gilbert",
        "seller": "Gordon Gund",
        "stakePct": null,
        "notes": "Agreed January 3, 2005, finalized March 1, 2005; included the arena operating business. Gund kept a minority stake, which Gilbert bought in 2021.",
        "isEstimated": false,
        "sources": [
          "https://www.washingtonpost.com/archive/sports/2005/01/04/cavaliers-their-arena-are-sold-for-375-million/5d94fc46-fbd1-4a4c-b17f-d8b817157d6f/",
          "https://www.cleveland.com/cavs/2021/04/dan-gilbert-acquires-remaining-minority-share-of-cleveland-cavaliers-from-former-owner-gordon-gund.html"
        ]
      }
    ]
  },
  "dallas-mavericks": {
    "formation": {
      "year": 1980,
      "price": 12500000,
      "founder": "Don Carter (with Norm Sonju)",
      "notes": "Expansion fee of $12.5M per the Mavericks Wikipedia article; the Don Carter article says $12M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1996,
        "price": 125000000,
        "buyer": "Ross Perot Jr. group (with David McDavid)",
        "seller": "Don Carter",
        "stakePct": 67,
        "notes": "67% interest bought May 1, 1996; $125M is the implied team valuation.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Dallas_Mavericks",
          "http://www.star-telegram.com/sports/nba/dallas-mavericks/article5394174.html"
        ]
      },
      {
        "year": 2000,
        "price": 285000000,
        "buyer": "Mark Cuban",
        "seller": "Ross Perot Jr. group",
        "stakePct": null,
        "notes": "Majority stake bought January 14, 2000.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Dallas_Mavericks",
          "https://en.wikipedia.org/wiki/Ross_Perot_Jr."
        ]
      },
      {
        "year": 2023,
        "price": 3500000000,
        "buyer": "Miriam Adelson and Sivan and Patrick Dumont",
        "seller": "Mark Cuban",
        "stakePct": 69,
        "notes": "Approved December 27, 2023. NBC reports a valuation of about $3.5B; Wikipedia cites $3.8-3.9B. Reports put the stake at 69% or 73%. Cuban kept about 27%.",
        "isEstimated": true,
        "sources": [
          "https://www.nbcnews.com/news/sports/mark-cuban-explains-sold-majority-stake-dallas-mavericks-rcna131499",
          "https://www.dallasnews.com/sports/mavericks/2024/02/10/dallas-mavericks-sale-nba-governor-patrick-dumont-first-interview-miriam-adelson-mark-cuban/"
        ]
      }
    ]
  },
  "denver-nuggets": {
    "formation": {
      "year": 1967,
      "price": null,
      "founder": "James Trindle",
      "notes": "ABA charter franchise (Denver Larks, then Rockets). On joining the NBA in 1976 the team paid a $2M entry fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1967,
        "price": 350000,
        "buyer": "Bill Ringsby and son",
        "seller": "James Trindle",
        "stakePct": 67,
        "notes": "Two-thirds controlling interest bought for $350,000 before the first season.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denver_Nuggets"
        ]
      },
      {
        "year": 1972,
        "price": null,
        "buyer": "Frank Goldberg and Bud Fischer",
        "seller": "Ringsby family",
        "stakePct": 100,
        "notes": "No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denver_Nuggets"
        ]
      },
      {
        "year": 1974,
        "price": null,
        "buyer": "Nuggets Management Inc. (local investment group)",
        "seller": "Frank Goldberg and Bud Fischer",
        "stakePct": 100,
        "notes": "Sold in stages in 1974 and 1975. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denver_Nuggets"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "Red McCombs",
        "seller": "Nuggets Management Inc.",
        "stakePct": 100,
        "notes": "No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denver_Nuggets"
        ]
      },
      {
        "year": 1985,
        "price": 20000000,
        "buyer": "Sidney Shlenker",
        "seller": "Red McCombs",
        "stakePct": 100,
        "notes": "May 1985.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Sidney_Shlenker"
        ]
      },
      {
        "year": 1989,
        "price": 65000000,
        "buyer": "COMSAT (later Ascent Entertainment)",
        "seller": "Sidney Shlenker",
        "stakePct": 100,
        "notes": "November 1989.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Sidney_Shlenker",
          "https://en.wikipedia.org/wiki/Denver_Nuggets"
        ]
      },
      {
        "year": 2000,
        "price": 450000000,
        "buyer": "Stan Kroenke",
        "seller": "Ascent Entertainment / Liberty Media",
        "stakePct": 100,
        "notes": "July 2000 package of the Nuggets, the Colorado Avalanche (NHL) and the Pepsi Center; this is not a Nuggets-only price. Earlier deals with Bill Laurie ($400M) and Donald Sturm ($461M) fell through.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denver_Nuggets",
          "http://www.allbusiness.com/north-america/united-states-colorado/1181899-1.html"
        ]
      }
    ]
  },
  "detroit-pistons": {
    "formation": {
      "year": 1941,
      "price": null,
      "founder": "Fred Zollner",
      "notes": "Founded in 1937 as the semi-pro Fort Wayne Zollner Pistons; joined the NBL in 1941, then the BAA/NBA in 1948, and moved to Detroit in 1957.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1974,
        "price": 8100000,
        "buyer": "Bill Davidson",
        "seller": "Fred Zollner",
        "stakePct": 100,
        "notes": "Figures conflict: the NYT headline of July 30, 1974 gives $8.1M; Wikipedia's Zollner article says $7M and its Davidson article says $6M. This entry uses the contemporary NYT figure.",
        "isEstimated": true,
        "sources": [
          "https://www.nytimes.com/1974/07/30/archives/pistons-are-sold-for-81million2-pistons-sold-to-detroit-group-by.html",
          "https://en.wikipedia.org/wiki/Fred_Zollner"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Karen Davidson",
        "seller": "Estate of Bill Davidson",
        "stakePct": null,
        "notes": "Inheritance after Davidson's death in March 2009.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Davidson_(businessman)"
        ]
      },
      {
        "year": 2011,
        "price": 325000000,
        "buyer": "Tom Gores / Platinum Equity",
        "seller": "Karen Davidson",
        "stakePct": 100,
        "notes": "Covers all of Palace Sports & Entertainment (the Pistons plus arena and venue assets). Agreed April 2011, approved May 2011.",
        "isEstimated": false,
        "sources": [
          "https://www.nba.com/pistons/news/gores_110408.html",
          "http://www.crainsdetroit.com/article/20110605/FREE/306059954/-shocking-bargain-gores-pays-325-million-for-pistons"
        ]
      }
    ]
  },
  "golden-state-warriors": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Peter A. Tyrrell (Philadelphia Arena)",
      "notes": "BAA charter franchise, the Philadelphia Warriors; moved to San Francisco in 1962.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1952,
        "price": 25000,
        "buyer": "Eddie Gottlieb",
        "seller": "Peter A. Tyrrell / Philadelphia Arena",
        "stakePct": 100,
        "notes": "The Warriors article dates the purchase to 1951; the Gottlieb article says 1952 for $25,000.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Eddie_Gottlieb"
        ]
      },
      {
        "year": 1962,
        "price": 850000,
        "buyer": "Diners Club-led group with Franklin Mieuli",
        "seller": "Eddie Gottlieb",
        "stakePct": 100,
        "notes": "Moved to San Francisco. Mieuli later bought out the other holders and became sole owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Franklin_Mieuli",
          "https://en.wikipedia.org/wiki/Eddie_Gottlieb"
        ]
      },
      {
        "year": 1986,
        "price": null,
        "buyer": "Jim Fitzgerald and Dan Finnane",
        "seller": "Franklin Mieuli",
        "stakePct": 100,
        "notes": "May 23, 1986. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://web.archive.org/web/20121108195044/http://www.nba.com/media/warriors/07MGHistory_A.pdf",
          "https://en.wikipedia.org/wiki/Franklin_Mieuli"
        ]
      },
      {
        "year": 1994,
        "price": null,
        "buyer": "Chris Cohan",
        "seller": "Jim Fitzgerald and Dan Finnane",
        "stakePct": 100,
        "notes": "Cohan bought out Fitzgerald and Finnane ahead of the 1994-95 season. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Golden_State_Warriors",
          "https://en.wikipedia.org/wiki/Jim_Fitzgerald_(businessman)"
        ]
      },
      {
        "year": 2010,
        "price": 450000000,
        "buyer": "Joe Lacob and Peter Guber group",
        "seller": "Chris Cohan",
        "stakePct": 100,
        "notes": "Agreed July 15, 2010; a record price at the time.",
        "isEstimated": false,
        "sources": [
          "http://sportsillustrated.cnn.com/2010/writers/frank_hughes/07/15/warriors.sale/",
          "https://www.espn.com/nba/news/story?id=5383261"
        ]
      }
    ]
  },
  "houston-rockets": {
    "formation": {
      "year": 1967,
      "price": 1750000,
      "founder": "Robert Breitbard",
      "notes": "Expansion franchise, the San Diego Rockets; moved to Houston in 1971.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1971,
        "price": 5600000,
        "buyer": "Texas Sports Investments (Wayne Duddleston, Billy Goldberg)",
        "seller": "Robert Breitbard",
        "stakePct": 100,
        "notes": "Sold June 23, 1971 and moved to Houston.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Rockets",
          "http://www.nba.com/history/uniforms_rockets.html"
        ]
      },
      {
        "year": 1979,
        "price": 9000000,
        "buyer": "George Maloof",
        "seller": "Previous ownership group (not identified in sources checked)",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Rockets"
        ]
      },
      {
        "year": 1982,
        "price": 11000000,
        "buyer": "Charlie Thomas (with Sidney Shlenker)",
        "seller": "Maloof family",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Houston_Rockets",
          "https://en.wikipedia.org/wiki/Maloof_family"
        ]
      },
      {
        "year": 1993,
        "price": 85000000,
        "buyer": "Leslie Alexander",
        "seller": "Charlie Thomas",
        "stakePct": 100,
        "notes": "July 30, 1993.",
        "isEstimated": false,
        "sources": [
          "http://www.chron.com/CDA/archives/archive.mpl?id=1993_1144426",
          "https://en.wikipedia.org/wiki/Houston_Rockets"
        ]
      },
      {
        "year": 2017,
        "price": 2200000000,
        "buyer": "Tilman Fertitta",
        "seller": "Leslie Alexander",
        "stakePct": 100,
        "notes": "Agreed September 5, 2017, closed October 2017. A record price for a US team at the time; included Toyota Center operating rights.",
        "isEstimated": false,
        "sources": [
          "https://www.washingtonpost.com/news/sports/wp/2017/09/05/teams-like-the-rockets-rarely-come-available-thats-why-theyre-being-sold-for-2-2-billion/",
          "http://www.nba.com/rockets/news/tilman-j-fertitta-new-owner-houston-rockets"
        ]
      }
    ]
  },
  "indiana-pacers": {
    "formation": {
      "year": 1967,
      "price": null,
      "founder": "Six investors: Richard Tinkham, John DeVoe, Chuck DeVoe, Lyn Treece, Chuck Barnes, Bob Collins",
      "notes": "ABA charter franchise. On joining the NBA in 1976 the team paid a $3.2M entry fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1979,
        "price": 11000000,
        "buyer": "Sam Nassi (with Frank Mariani)",
        "seller": "Previous local ownership group",
        "stakePct": 100,
        "notes": "The reported $11M deal included assumption of significant team debt.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Indiana_Pacers"
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Melvin and Herb Simon",
        "seller": "Sam Nassi and Frank Mariani",
        "stakePct": 100,
        "notes": "Approved May 9, 1983. No verified price found. Herb Simon became sole principal owner after Mel Simon died in 2009.",
        "isEstimated": false,
        "sources": [
          "https://www.upi.com/Archives/1983/04/16/Indiana-Pacers-owners-Sam-Nassi-and-Frank-Mariani-have/7554419317200/",
          "https://en.wikipedia.org/wiki/History_of_the_Indiana_Pacers"
        ]
      }
    ]
  },
  "los-angeles-clippers": {
    "formation": {
      "year": 1970,
      "price": 3700000,
      "founder": "Paul Snyder",
      "notes": "Expansion franchise, the Buffalo Braves. The 1970 expansion entrance fee was $3.7M. Wikipedia says Snyder had bought the franchise for $4M by opening night.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1977,
        "price": null,
        "buyer": "John Y. Brown Jr.",
        "seller": "Paul Snyder",
        "stakePct": 100,
        "notes": "Brown bought a stake in 1976 and the remaining share in 1977. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/John_Y._Brown_Jr.",
          "https://en.wikipedia.org/wiki/Buffalo_Braves"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "Irv Levin (with Harold Lipton)",
        "seller": "John Y. Brown Jr.",
        "stakePct": 100,
        "notes": "Franchise swap with the Celtics; no cash price. The team moved to San Diego as the Clippers.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Clippers"
        ]
      },
      {
        "year": 1981,
        "price": 12500000,
        "buyer": "Donald Sterling",
        "seller": "Irv Levin",
        "stakePct": 100,
        "notes": "The Clippers and Sterling articles say $12.5M; the Levin article says $13.5M (May 4, 1981).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Clippers",
          "https://en.wikipedia.org/wiki/Irv_Levin"
        ]
      },
      {
        "year": 2014,
        "price": 2000000000,
        "buyer": "Steve Ballmer",
        "seller": "Sterling Family Trust (Shelly Sterling)",
        "stakePct": 100,
        "notes": "Forced sale after the league acted against Donald Sterling. Closed August 12, 2014.",
        "isEstimated": false,
        "sources": [
          "https://www.usatoday.com/story/sports/nba/clippers/2014/05/30/donald-sterling-mental-health-shelly-los-angeles-sale-steve-ballmer/9754549/",
          "http://www.latimes.com/sports/sportsnow/la-sp-sn-nba-steve-ballmer-owner-clippers-20140812-story.html"
        ]
      }
    ]
  },
  "los-angeles-lakers": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Morris Winston and C. King Boring",
      "notes": "Founded as the NBL's Detroit Gems. Became the Minneapolis Lakers in 1947 and moved to Los Angeles in 1960.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1947,
        "price": 15000,
        "buyer": "Ben Berger and Morris Chalfen",
        "seller": "Detroit Gems owners (Morris Winston, C. King Boring)",
        "stakePct": 100,
        "notes": "Moved to Minneapolis and renamed the Lakers.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Lakers",
          "https://web.archive.org/web/20240908165218/https://www.latimes.com/archives/la-xpm-2009-apr-27-sp-crowe-nest27-story.html"
        ]
      },
      {
        "year": 1957,
        "price": 150000,
        "buyer": "Bob Short-led group of 117 Minnesota investors",
        "seller": "Ben Berger",
        "stakePct": 100,
        "notes": "The group raised $200,000 in total: $150,000 for the team and $50,000 for operations. Short moved the team to Los Angeles in 1960.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Lakers",
          "https://from-way-downtown.com/2021/05/25/the-new-lakers/"
        ]
      },
      {
        "year": 1965,
        "price": 5175000,
        "buyer": "Jack Kent Cooke",
        "seller": "Bob Short",
        "stakePct": 100,
        "notes": "A league-record price at the time. Some sources round it to $5M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Lakers",
          "https://en.wikipedia.org/wiki/Jack_Kent_Cooke"
        ]
      },
      {
        "year": 1979,
        "price": 16000000,
        "buyer": "Jerry Buss",
        "seller": "Jack Kent Cooke",
        "stakePct": 100,
        "notes": "$16M is the Lakers' share of a $67.5M package that also included the NHL Kings, The Forum and real estate.",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/1979/05/30/archives/cooke-buss-confirm-sale-of-coast-teams.html",
          "https://www.nytimes.com/2013/02/19/sports/basketball/jerry-buss-longtime-lakers-owner-is-dead-at-80.html"
        ]
      },
      {
        "year": 2013,
        "price": null,
        "buyer": "Jerry Buss family trusts (six children; Jeanie Buss controlling owner)",
        "seller": "Estate of Jerry Buss",
        "stakePct": 66,
        "notes": "Inheritance after Buss's death in February 2013. The family held a 66% controlling stake.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/los-angeles/nba/story/_/id/8960441/family-jerry-buss-maintain-los-angeles-lakers-ownership",
          "https://www.latimes.com/sports/sportsnow/la-sp-jim-jeanie-buss-trust-20170326-story.html"
        ]
      },
      {
        "year": 2025,
        "price": 10000000000,
        "buyer": "Mark Walter",
        "seller": "Buss family trusts",
        "stakePct": null,
        "notes": "Agreed June 2025; NBA approved it unanimously and it closed on October 30, 2025, at a $10B valuation. The Buss family kept a minority stake and Jeanie Buss stayed on as governor. Walter already held about 20% from 2021. The August 2026 resale to Josh Kushner and Bob Iger at $12.5B is left out per coordinator instruction (reported as contested and not approved).",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/story/_/id/46782684/nba-approves-mark-walter-purchase-majority-stake-lakers",
          "https://www.nba.com/news/nba-approves-sale-majority-interest-lakers-mark-walter",
          "https://variety.com/2025/biz/news/nba-approves-mark-walter-la-lakers-deal-1236565890/"
        ]
      }
    ]
  },
  "memphis-grizzlies": {
    "formation": {
      "year": 1995,
      "price": 125000000,
      "founder": "Arthur Griffiths (Northwest Sports Enterprises)",
      "notes": "Expansion franchise, the Vancouver Grizzlies (fee US$125M); moved to Memphis in 2001.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1995,
        "price": null,
        "buyer": "John McCaw Jr. (Orca Bay Sports & Entertainment)",
        "seller": "Arthur Griffiths",
        "stakePct": null,
        "notes": "McCaw bought majority control of the holding company (also owning the Canucks and GM Place) in 1995 and 1996. No team-level price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Vancouver_Grizzlies",
          "http://www.thefreelibrary.com/McCaw+Agrees+to+Purchase+Griffiths%27+Shares+in+Orca+Bay+Sports+%26...-a018852274"
        ]
      },
      {
        "year": 2000,
        "price": 160000000,
        "buyer": "Michael Heisley",
        "seller": "John McCaw Jr. / Orca Bay",
        "stakePct": 100,
        "notes": "Came after a failed $200M sale to Bill Laurie; the team moved to Memphis for 2001-02.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Vancouver_Grizzlies",
          "http://slam.canoe.com/BasketballVancouverArchive/oct20_daniels.html"
        ]
      },
      {
        "year": 2012,
        "price": 350000000,
        "buyer": "Robert Pera",
        "seller": "Michael Heisley",
        "stakePct": null,
        "notes": "Approved October 25, 2012. Wikipedia describes the price as 'in the $350 million range'; other reports differ.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Memphis_Grizzlies",
          "http://www.nba.com/grizzlies/news/grizzlies_sale_to_robert_pera_approved_121025"
        ]
      }
    ]
  },
  "miami-heat": {
    "formation": {
      "year": 1988,
      "price": 32500000,
      "founder": "Ted Arison (majority), with Billy Cunningham and Lewis Schaffel",
      "notes": "1988-89 expansion franchise at the $32.5M fee paid in that expansion.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1995,
        "price": null,
        "buyer": "Micky Arison",
        "seller": "Arison family / founding partners",
        "stakePct": null,
        "notes": "Micky Arison bought a controlling interest on February 13, 1995, putting control within the family. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Miami_Heat"
        ]
      }
    ]
  },
  "milwaukee-bucks": {
    "formation": {
      "year": 1968,
      "price": 2000000,
      "founder": "Wes Pavalon and Marvin Fishman",
      "notes": "Expansion franchise granted January 22, 1968 with Phoenix, at a $2M entry fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1976,
        "price": null,
        "buyer": "Jim Fitzgerald and partners",
        "seller": "Founding ownership group",
        "stakePct": null,
        "notes": "No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Milwaukee_Bucks"
        ]
      },
      {
        "year": 1985,
        "price": 18000000,
        "buyer": "Herb Kohl",
        "seller": "Jim Fitzgerald",
        "stakePct": 100,
        "notes": "Bought to keep the team in Milwaukee.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Herb_Kohl"
        ]
      },
      {
        "year": 2014,
        "price": 550000000,
        "buyer": "Wes Edens and Marc Lasry",
        "seller": "Herb Kohl",
        "stakePct": null,
        "notes": "Majority interest; agreed April 16, 2014 and approved May 16, 2014. Kohl kept a minority stake and contributed $100M toward the new arena. In 2023 the Haslams bought Lasry's ~25% at a reported $3.5B valuation; that was a minority transfer, not a control change.",
        "isEstimated": false,
        "sources": [
          "http://www.jsonline.com/sports/bucks/milwaukee-bucks-sold-by-herb-kohl-for-550-million-to-billionaire-investors-b99249475z1-255535471.html",
          "https://en.wikipedia.org/wiki/Milwaukee_Bucks"
        ]
      }
    ]
  },
  "minnesota-timberwolves": {
    "formation": {
      "year": 1989,
      "price": 32500000,
      "founder": "Harvey Ratner and Marv Wolfenson",
      "notes": "Expansion franchise awarded April 22, 1987, at the $32.5M 1988-89 expansion fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1994,
        "price": 88500000,
        "buyer": "Glen Taylor group",
        "seller": "Harvey Ratner and Marv Wolfenson",
        "stakePct": 100,
        "notes": "Kept the team from moving to New Orleans after the NBA rejected that sale. The price is the $88.5M the investor group raised to buy the team.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Minnesota_Timberwolves"
        ]
      },
      {
        "year": 2025,
        "price": 1500000000,
        "buyer": "Marc Lore and Alex Rodriguez",
        "seller": "Glen Taylor",
        "stakePct": 100,
        "notes": "Agreed in 2021 at a $1.5B valuation, with 20% bought in 2021 and 20% in 2022. Taylor tried to cancel in March 2024; arbitration ruled for Lore and Rodriguez in February 2025 and NBA owners approved in June 2025. Includes the WNBA Lynx. The August 2026 sale of Lore's control stake to Marc Stad at $4.5B is left out because it awaits NBA approval.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/story/_/id/44504541/sources-rodriguez-lore-own-timberwolves-standoff",
          "https://www.cbssports.com/nba/news/sale-of-timberwolves-to-marc-lore-alex-rodriguez-for-1-5b-officially-approved-by-nba-board-of-governors",
          "https://www.sportico.com/business/team-sales/2025/arod-lore-win-timberwolves-lynx-arbitration-taylor-1234825589/"
        ]
      }
    ]
  },
  "new-orleans-pelicans": {
    "formation": {
      "year": 1988,
      "price": 32500000,
      "founder": "George Shinn",
      "notes": "Founded as the Charlotte Hornets (1988-89 expansion, $32.5M). Moved to New Orleans in 2002 and renamed Pelicans in 2013. The 1988-2002 Charlotte records were handed to today's Charlotte Hornets in 2014.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2010,
        "price": 300000000,
        "buyer": "NBA (league-owned)",
        "seller": "George Shinn and Gary Chouest",
        "stakePct": 100,
        "notes": "The league took over the team in December 2010 after Chouest's buyout collapsed. The price is estimated.",
        "isEstimated": true,
        "sources": [
          "http://www.nba.com/2010/news/12/20/hornets-sale.ap/index.html",
          "https://en.wikipedia.org/wiki/George_Shinn"
        ]
      },
      {
        "year": 2012,
        "price": 338000000,
        "buyer": "Tom Benson",
        "seller": "NBA",
        "stakePct": 100,
        "notes": "Bought April 13, 2012.",
        "isEstimated": false,
        "sources": [
          "http://www.nba.com/2012/news/04/13/hornets-sale.ap/index.html",
          "https://en.wikipedia.org/wiki/Tom_Benson"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Gayle Benson",
        "seller": "Estate of Tom Benson",
        "stakePct": 100,
        "notes": "Inheritance after Tom Benson's death in March 2018.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_Orleans_Pelicans",
          "https://en.wikipedia.org/wiki/Tom_Benson"
        ]
      }
    ]
  },
  "new-york-knicks": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Ned Irish / Madison Square Garden Corporation",
      "notes": "BAA charter franchise, owned by Madison Square Garden since founding. Every control change below happened at the parent-company level; no Knicks-only price has ever been reported.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1959,
        "price": null,
        "buyer": "Graham-Paige",
        "seller": "James Norris and Arthur Wirtz",
        "stakePct": null,
        "notes": "Graham-Paige paid $4M for Norris and Wirtz's controlling 40% of Madison Square Garden Corp (which owned the Knicks, arena and Rangers). That is a parent-company price, not a team price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "Gulf and Western Industries (renamed Paramount Communications in 1989)",
        "seller": "Madison Square Garden Corp public shareholders",
        "stakePct": 100,
        "notes": "G&W began buying MSG stock in 1969 and took complete control on August 19, 1977.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports"
        ]
      },
      {
        "year": 1994,
        "price": null,
        "buyer": "Cablevision and ITT Corporation (50/50)",
        "seller": "Viacom (after acquiring Paramount)",
        "stakePct": 100,
        "notes": "Covers all of MSG (arena, Knicks, Rangers, MSG Network). No Knicks-only price.",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/1994/08/28/nyregion/itt-cablevision-deal-reported-to-buy-madison-square-garden.html",
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports"
        ]
      },
      {
        "year": 1997,
        "price": null,
        "buyer": "Cablevision (Dolan family)",
        "seller": "ITT Corporation",
        "stakePct": 50,
        "notes": "ITT sold its half of MSG to Cablevision for $650M, a multi-asset parent-level price. The Dolan family has controlled the team since, through later spin-offs (MSG Company, then Madison Square Garden Sports).",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/1997/03/07/business/itt-sells-cablevision-control-over-madison-square-garden.html"
        ]
      }
    ]
  },
  "oklahoma-city-thunder": {
    "formation": {
      "year": 1967,
      "price": 1750000,
      "founder": "Sam Schulman and Eugene V. Klein",
      "notes": "Expansion franchise, the Seattle SuperSonics ($1.75M entry fee); moved to Oklahoma City in 2008.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1983,
        "price": null,
        "buyer": "Barry Ackerley",
        "seller": "Sam Schulman",
        "stakePct": 100,
        "notes": "October 1983. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barry_Ackerley",
          "http://www.seattlepi.com/basketball/126714_obit14.html"
        ]
      },
      {
        "year": 2001,
        "price": 200000000,
        "buyer": "Howard Schultz (Basketball Club of Seattle)",
        "seller": "Ackerley Group",
        "stakePct": 100,
        "notes": "Included the WNBA Seattle Storm.",
        "isEstimated": false,
        "sources": [
          "https://archive.seattletimes.com/archive/20010112/sale120/sonics-sale-a-dream-deal-for-schultz",
          "https://en.wikipedia.org/wiki/Howard_Schultz"
        ]
      },
      {
        "year": 2006,
        "price": 350000000,
        "buyer": "Clay Bennett (Professional Basketball Club LLC)",
        "seller": "Howard Schultz / Basketball Club of Seattle",
        "stakePct": 100,
        "notes": "Agreed July 18, 2006 and approved October 24, 2006; included the Storm. The team moved to Oklahoma City in 2008 after a $45M settlement with Seattle.",
        "isEstimated": false,
        "sources": [
          "http://www.nba.com/sonics/news/sale_060718.html",
          "http://www.nba.com/sonics/news/pbc061024.html"
        ]
      }
    ]
  },
  "orlando-magic": {
    "formation": {
      "year": 1989,
      "price": 32500000,
      "founder": "Jim Hewitt group (with William duPont III and Pat Williams)",
      "notes": "1988-89 expansion round; the Magic began play in 1989. Fee reported as $32.5M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": 85000000,
        "buyer": "Richard DeVos (DeVos family)",
        "seller": "Founding ownership group",
        "stakePct": 100,
        "notes": "September 19, 1991.",
        "isEstimated": false,
        "sources": [
          "https://www.nytimes.com/1991/09/20/sports/nba-orlando-team-sold.html",
          "https://en.wikipedia.org/wiki/Orlando_Magic"
        ]
      },
      {
        "year": 2007,
        "price": null,
        "buyer": "DeVos children (Bob Vander Weide as owner of record; later Dan DeVos as chairman)",
        "seller": "Richard DeVos",
        "stakePct": null,
        "notes": "Family transfer, no sale; the owner-of-record change took effect November 15, 2007.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Orlando_Magic"
        ]
      }
    ]
  },
  "philadelphia-76ers": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Danny Biasone",
      "notes": "Founded as the Syracuse Nationals (NBL, 1946); moved to Philadelphia in 1963.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1963,
        "price": null,
        "buyer": "Irv Kosloff and Ike Richman",
        "seller": "Danny Biasone",
        "stakePct": 100,
        "notes": "Moved to Philadelphia. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Irv_Kosloff"
        ]
      },
      {
        "year": 1976,
        "price": 8000000,
        "buyer": "Fitz Eugene Dixon Jr.",
        "seller": "Irv Kosloff",
        "stakePct": 90,
        "notes": "May 28, 1976. Kosloff kept 10%.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Irv_Kosloff",
          "https://web.archive.org/web/20220301212428/https://www.nytimes.com/1976/05/29/archives/motta-to-coach-bullets-76ers-sold-motta-hired-by-bullets-76ers-sold.html"
        ]
      },
      {
        "year": 1981,
        "price": null,
        "buyer": "Harold Katz",
        "seller": "Fitz Eugene Dixon Jr.",
        "stakePct": 100,
        "notes": "July 1981. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Harold_Katz"
        ]
      },
      {
        "year": 1996,
        "price": null,
        "buyer": "Comcast Spectacor (Ed Snider / Comcast)",
        "seller": "Harold Katz",
        "stakePct": 100,
        "notes": "April 1996. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Harold_Katz",
          "https://en.wikipedia.org/wiki/Comcast_Spectacor"
        ]
      },
      {
        "year": 2011,
        "price": 280000000,
        "buyer": "Josh Harris-led group (with David Blitzer)",
        "seller": "Comcast Spectacor",
        "stakePct": 100,
        "notes": "Agreed July 13, 2011.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/story/_/id/6767259/sale-philadelphia-76ers-joshua-harris-group"
        ]
      }
    ]
  },
  "phoenix-suns": {
    "formation": {
      "year": 1968,
      "price": 2000000,
      "founder": "Group led by Karl Eller and Richard Bloch (with Donald Pitt, Don Diamond and others)",
      "notes": "Expansion franchise granted January 22, 1968, at a $2M entry fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1987,
        "price": 44000000,
        "buyer": "Jerry Colangelo group",
        "seller": "Founding ownership group",
        "stakePct": 100,
        "notes": "A record price at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Phoenix_Suns",
          "https://en.wikipedia.org/wiki/Jerry_Colangelo"
        ]
      },
      {
        "year": 2004,
        "price": 401000000,
        "buyer": "Robert Sarver group",
        "seller": "Jerry Colangelo group",
        "stakePct": 100,
        "notes": "Included the WNBA Mercury and the Arena Football League Rattlers. A then-record price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jerry_Colangelo",
          "https://cronkitenews.azpbs.org/2020/04/27/sarver-purchased-phoenix-suns/"
        ]
      },
      {
        "year": 2023,
        "price": 4000000000,
        "buyer": "Mat and Justin Ishbia",
        "seller": "Robert Sarver",
        "stakePct": null,
        "notes": "Agreed December 20, 2022, official February 7, 2023; included the Mercury. Sarver sold after a league workplace investigation.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/story/_/id/35523911/mat-ishbia-purchase-suns-mercury-official-soon",
          "https://en.wikipedia.org/wiki/Phoenix_Suns"
        ]
      }
    ]
  },
  "portland-trail-blazers": {
    "formation": {
      "year": 1970,
      "price": 3700000,
      "founder": "Harry Glickman, Herman Sarkowsky, Robert Schmertz, Larry Weinberg",
      "notes": "Expansion franchise at the $3.7M 1970 entrance fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1975,
        "price": null,
        "buyer": "Larry Weinberg",
        "seller": "Herman Sarkowsky and Robert Schmertz",
        "stakePct": null,
        "notes": "Weinberg bought out his partners and became managing partner and majority owner. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Herman_Sarkowsky",
          "https://en.wikipedia.org/wiki/Harry_Glickman"
        ]
      },
      {
        "year": 1988,
        "price": 70000000,
        "buyer": "Paul Allen",
        "seller": "Larry Weinberg",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://www.forbes.com/forbes/2008/1222/083.html",
          "https://en.wikipedia.org/wiki/Paul_Allen"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Estate of Paul Allen (Jody Allen, trustee)",
        "seller": "Paul Allen",
        "stakePct": 100,
        "notes": "Inheritance/estate transfer after Allen's death in October 2018.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Paul_Allen"
        ]
      },
      {
        "year": 2026,
        "price": 4000000000,
        "buyer": "Tom Dundon group ('Rip City Rising': Marc Zahr, Sheel Tyle, Cherng Family Trust)",
        "seller": "Estate of Paul Allen",
        "stakePct": 80.1,
        "notes": "First tranche: 80.1% at a $4.0B valuation. Per data/transactions.js (the authoritative deal record): agreed September 13, 2025; approved by the NBA March 30, 2026; closed March 31, 2026. The remaining 19.9% is to be bought at $4.5B by September 1, 2028 (the $4.25B headline is the blended figure).",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nba/story/_/id/48350814/nba-board-governors-approves-portland-trail-blazers-sale-group-led-tom-dundon",
          "https://www.nba.com/news/blazers-sale-tom-dundon-ok-nba-board-governors",
          "https://www.sportico.com/business/team-sales/2025/trail-blazers-sale-signed-dundon-group-billion-1234870717/"
        ]
      }
    ]
  },
  "sacramento-kings": {
    "formation": {
      "year": 1945,
      "price": 25000,
      "founder": "Les and Jack Harrison",
      "notes": "The Rochester Royals entered the NBL in 1945 for a $25,000 entry fee. The team later moved to Cincinnati (1957), Kansas City-Omaha (1972) and Sacramento (1985).",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1958,
        "price": null,
        "buyer": "Local Cincinnati group headed by Thomas Woods (with Cincinnati Gardens management)",
        "seller": "Les and Jack Harrison",
        "stakePct": 100,
        "notes": "The year is approximate: the sale followed the move to Cincinnati. No verified price found. Louis Jacobs became owner by early 1963.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Sacramento_Kings"
        ]
      },
      {
        "year": 1983,
        "price": 10500000,
        "buyer": "Sacramento group led by Joseph Benvenuti and Gregg Lukenbill",
        "seller": "Kansas City Kings ownership",
        "stakePct": 100,
        "notes": "June 8, 1983; the team moved to Sacramento in 1985.",
        "isEstimated": false,
        "sources": [
          "https://web.archive.org/web/20220227110939/https://www.upi.com/Archives/1983/06/08/The-Kansas-City-Kings-of-the-National-Basketball-Association/9348423892800/",
          "https://en.wikipedia.org/wiki/Sacramento_Kings"
        ]
      },
      {
        "year": 1999,
        "price": null,
        "buyer": "Maloof family (Joe and Gavin Maloof)",
        "seller": "Previous majority owners",
        "stakePct": null,
        "notes": "The Maloofs bought a minority stake in 1998 and majority control in 1999. The intermediate 1992 change (Jim Thomas) is not itemized because it could not be verified in the sources checked. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maloof_family"
        ]
      },
      {
        "year": 2013,
        "price": 534000000,
        "buyer": "Vivek Ranadivé group",
        "seller": "Maloof family (and Bob Hernreich)",
        "stakePct": 65,
        "notes": "Record $534M team valuation; the 65% stake cost about $347M. Escrow closed May 31, 2013. This deal replaced the Hansen/Ballmer plan to move the team to Seattle.",
        "isEstimated": false,
        "sources": [
          "http://www.sacbee.com/2013/05/16/5427622/kings.html",
          "http://probasketballtalk.nbcsports.com/2013/05/31/kings-sale-closes-escrow-final-price-is-record-534-million/"
        ]
      }
    ]
  },
  "san-antonio-spurs": {
    "formation": {
      "year": 1967,
      "price": null,
      "founder": "Dallas Chaparrals ownership group",
      "notes": "ABA charter franchise, the Dallas Chaparrals; moved to San Antonio in 1973. On joining the NBA in 1976 the team paid a $3.2M entry fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1973,
        "price": null,
        "buyer": "Group of 35 San Antonio investors led by Angelo Drossos, John Schaefer and Red McCombs",
        "seller": "Dallas Chaparrals ownership group",
        "stakePct": 100,
        "notes": "A three-year lease with an option to buy, which the group exercised. No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/San_Antonio_Spurs"
        ]
      },
      {
        "year": 1988,
        "price": null,
        "buyer": "Red McCombs",
        "seller": "Angelo Drossos-led ownership group",
        "stakePct": 100,
        "notes": "McCombs took full ownership around 1988-89 (his article says 1989). No verified price found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/San_Antonio_Spurs",
          "https://en.wikipedia.org/wiki/Red_McCombs"
        ]
      },
      {
        "year": 1993,
        "price": 75000000,
        "buyer": "Peter Holt and 22 investors",
        "seller": "Red McCombs",
        "stakePct": 100,
        "notes": "The Holt family has controlled the team since; Peter J. Holt is now chairman.",
        "isEstimated": false,
        "sources": [
          "https://www.newspapers.com/image/1279056605/",
          "https://en.wikipedia.org/wiki/San_Antonio_Spurs"
        ]
      }
    ]
  },
  "toronto-raptors": {
    "formation": {
      "year": 1993,
      "price": 125000000,
      "founder": "John Bitove (with Allan Slaight)",
      "notes": "Expansion franchise awarded November 4, 1993 at a then-record US$125M fee; began play in 1995.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1996,
        "price": null,
        "buyer": "Allan Slaight",
        "seller": "John Bitove",
        "stakePct": 79,
        "notes": "Slaight triggered a shotgun clause and bought Bitove's interest for $65M (for his stake, not the whole team), taking 79% control.",
        "isEstimated": false,
        "sources": [
          "http://www.sportsbusinessdaily.com/Daily/Issues/1996/10/21/Franchises/RAPTORS-UP-FOR-GRABS-AS-SLAIGHT-ENACTS-BUYOUT-CLAUSE.aspx",
          "https://en.wikipedia.org/wiki/Toronto_Raptors"
        ]
      },
      {
        "year": 1998,
        "price": 125000000,
        "buyer": "Maple Leaf Gardens Ltd. (became MLSE; majority held by Ontario Teachers' Pension Plan)",
        "seller": "Allan Slaight and Bank of Nova Scotia",
        "stakePct": 100,
        "notes": "February 12, 1998; included the unfinished Air Canada Centre. Wikipedia gives US$125M for the franchise.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Toronto_Raptors"
        ]
      },
      {
        "year": 2012,
        "price": null,
        "buyer": "Rogers Communications and BCE (joint venture, with Larry Tanenbaum)",
        "seller": "Ontario Teachers' Pension Plan",
        "stakePct": null,
        "notes": "OTPP sold its majority of MLSE (Raptors, Maple Leafs, TFC and other assets). This is a parent-company deal with no Raptors-only price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Rogers Communications",
        "seller": "BCE (Bell)",
        "stakePct": 37.5,
        "notes": "Rogers bought BCE's 37.5% of MLSE for CA$4.7B (agreed September 2024, closed July 2025), giving it 75% control; Tanenbaum keeps 25%. This is a parent-company deal (MLSE also owns the Leafs, TFC and Argonauts), so no team-level price in USD is given.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "utah-jazz": {
    "formation": {
      "year": 1974,
      "price": null,
      "founder": "Sam Battistone-led group",
      "notes": "Expansion franchise, the New Orleans Jazz; moved to Utah in 1979. Expansion fee not verified.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1985,
        "price": 8000000,
        "buyer": "Larry H. Miller",
        "seller": "Sam Battistone",
        "stakePct": 50,
        "notes": "$8M paid for 50%, implying a team value of about $16M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Utah_Jazz",
          "https://en.wikipedia.org/wiki/Larry_H._Miller"
        ]
      },
      {
        "year": 1986,
        "price": 14000000,
        "buyer": "Larry H. Miller",
        "seller": "Sam Battistone",
        "stakePct": 50,
        "notes": "June 16, 1986: $14M for the remaining 50%, giving Miller 100%. Outside offers of up to $28M would have moved the team to Minnesota.",
        "isEstimated": false,
        "sources": [
          "https://www.deseret.com/2010/5/6/20113011/late-jazz-owner-larry-miller-spurned-huge-payday-to-keep-team-in-utah",
          "https://en.wikipedia.org/wiki/Larry_H._Miller"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Gail Miller / Miller family",
        "seller": "Estate of Larry H. Miller",
        "stakePct": 100,
        "notes": "Inheritance after Larry Miller's death in 2009.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Utah_Jazz"
        ]
      },
      {
        "year": 2020,
        "price": 1660000000,
        "buyer": "Ryan Smith (Smith Entertainment Group)",
        "seller": "Miller family",
        "stakePct": 100,
        "notes": "Announced October 28, 2020. $1.66B covers the Jazz plus Vivint Arena and related assets.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Larry_H._Miller",
          "https://en.wikipedia.org/wiki/Utah_Jazz"
        ]
      }
    ]
  },
  "washington-wizards": {
    "formation": {
      "year": 1961,
      "price": null,
      "founder": "Dave Trager group",
      "notes": "Expansion franchise, the Chicago Packers (renamed Zephyrs, then the Baltimore Bullets in 1963, Washington in the 1970s, Wizards in 1997). Expansion fee not verified.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1964,
        "price": 1100000,
        "buyer": "Abe Pollin, Earl Foreman and Arnold Heft",
        "seller": "Dave Trager",
        "stakePct": 100,
        "notes": "November 23, 1964. Pollin later became majority owner.",
        "isEstimated": false,
        "sources": [
          "https://web.archive.org/web/20230306002631/https://news.google.com/newspapers?id=OCEiAAAAIBAJ&sjid=BnQFAAAAIBAJ&pg=926,3632741",
          "https://en.wikipedia.org/wiki/Abe_Pollin"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Irene Pollin",
        "seller": "Estate of Abe Pollin",
        "stakePct": null,
        "notes": "Inheritance after Pollin's death in November 2009.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Washington_Wizards"
        ]
      },
      {
        "year": 2010,
        "price": null,
        "buyer": "Ted Leonsis (Lincoln Holdings, now Monumental Sports & Entertainment)",
        "seller": "Pollin family",
        "stakePct": null,
        "notes": "Leonsis bought the remaining interests (Wizards and Verizon Center) in June 2010. He had bought a minority stake in 1999 as part of an ~$200M deal that also included the Capitals. No verified 2010 price found.",
        "isEstimated": false,
        "sources": [
          "https://www.nba.com/wizards/news/leonsis_acquisition_100610.html",
          "https://en.wikipedia.org/wiki/Abe_Pollin"
        ]
      }
    ]
  },
  "buffalo-bills": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Ralph Wilson",
      "notes": "AFL charter franchise; each original AFL owner paid a $25,000 franchise fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2014,
        "price": null,
        "buyer": "Ralph C. Wilson Jr. estate/trust",
        "seller": "Ralph Wilson",
        "stakePct": 100,
        "notes": "inheritance. Wilson died March 25, 2014; his estate held the team in trust until the sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ralph_Wilson"
        ]
      },
      {
        "year": 2014,
        "price": 1400000000,
        "buyer": "Terry & Kim Pegula",
        "seller": "Ralph C. Wilson Jr. estate/trust",
        "stakePct": 100,
        "notes": "Unanimously approved and closed October 8, 2014. The 2024 sale of 20.6% to Arctos and others at a $5.6B valuation was a minority deal, so it is not listed here.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nfl/story/_/id/11663100/buffalo-bills-sale-unanimously-approved-owners",
          "https://en.wikipedia.org/wiki/Buffalo_Bills"
        ]
      }
    ]
  },
  "miami-dolphins": {
    "formation": {
      "year": 1965,
      "price": 7500000,
      "founder": "Joe Robbie and Danny Thomas",
      "notes": "AFL expansion franchise fee. Thomas later sold his stake to Robbie.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1990,
        "price": null,
        "buyer": "Robbie family",
        "seller": "Joe Robbie",
        "stakePct": null,
        "notes": "inheritance. Joe Robbie died in January 1990. Later in 1990 Wayne Huizenga bought 15% of the team and 50% of the stadium (a minority deal).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Wayne_Huizenga"
        ]
      },
      {
        "year": 1994,
        "price": 138000000,
        "buyer": "Wayne Huizenga",
        "seller": "Robbie family",
        "stakePct": 85,
        "notes": "The NFL approved the transfer of majority interest on March 23, 1994. Price reports conflict: $138M is the most-cited figure (it may include stadium interests), Huizenga's Wikipedia page says $115M for the remaining team shares, and $168M has also been reported.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/1994_Miami_Dolphins_season",
          "https://en.wikipedia.org/wiki/Wayne_Huizenga"
        ]
      },
      {
        "year": 2009,
        "price": 1100000000,
        "buyer": "Stephen M. Ross",
        "seller": "Wayne Huizenga",
        "stakePct": 95,
        "notes": "Bought in two phases. In February 2008 Ross paid $550M for 50% of the team, Dolphin Stadium and the surrounding land. On January 20, 2009 he closed on another 45%, taking control. The $1.1B total covers 95% of the team plus the stadium.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nfl/news/story?id=3847012",
          "https://en.wikipedia.org/wiki/Stephen_M._Ross"
        ]
      }
    ]
  },
  "new-england-patriots": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Billy Sullivan",
      "notes": "Eighth and final AFL charter franchise (Boston Patriots), awarded November 16, 1959. Each founder put in $25,000.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1988,
        "price": 84000000,
        "buyer": "Victor Kiam (with Fran Murray)",
        "seller": "Billy Sullivan / Sullivan family",
        "stakePct": null,
        "notes": "$84M is the most-cited figure; the Wikipedia history page says $90M. Robert Kraft separately bought Foxboro Stadium out of bankruptcy in 1988 for $22M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Victor_Kiam",
          "https://en.wikipedia.org/wiki/History_of_the_New_England_Patriots"
        ]
      },
      {
        "year": 1992,
        "price": 106000000,
        "buyer": "James Orthwein",
        "seller": "Victor Kiam",
        "stakePct": 51,
        "notes": "Orthwein bought Kiam's 51% majority interest in May 1992. The $106M figure comes from Orthwein's Wikipedia page (single source).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/James_Orthwein"
        ]
      },
      {
        "year": 1994,
        "price": 172000000,
        "buyer": "Robert Kraft",
        "seller": "James Orthwein",
        "stakePct": 100,
        "notes": "Announced January 21, 1994; a then-NFL record. Figures vary ($160M, $172M, $175M). $172M is Kraft's reported offer and the most-cited figure.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Robert_Kraft",
          "https://en.wikipedia.org/wiki/1994_New_England_Patriots_season"
        ]
      }
    ]
  },
  "new-york-jets": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Harry Wismer",
      "notes": "AFL charter franchise, the Titans of New York.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1963,
        "price": 1000000,
        "buyer": "Sonny Werblin, Leon Hess, Townsend Martin, Donald Lillis, Philip Iselin",
        "seller": "Harry Wismer (bankrupt Titans)",
        "stakePct": 100,
        "notes": "Bought out of bankruptcy in February 1963 and renamed the Jets.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Jets",
          "https://en.wikipedia.org/wiki/Sonny_Werblin"
        ]
      },
      {
        "year": 1968,
        "price": null,
        "buyer": "Remaining partners (Lillis, Iselin, Hess, Martin)",
        "seller": "Sonny Werblin",
        "stakePct": null,
        "notes": "Werblin's partners bought him out. He reportedly made about $1.4M profit on his $250,000 1963 investment. Hess became majority owner in the 1970s.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Sonny_Werblin",
          "https://en.wikipedia.org/wiki/Leon_Hess"
        ]
      },
      {
        "year": 1984,
        "price": 5000000,
        "buyer": "Leon Hess",
        "seller": "Helen Dillon",
        "stakePct": 25,
        "notes": "The purchase of Dillon's 25% made Hess sole owner. He had bought Townsend Martin's 25% for $5M in 1981. The price is for the 25% stake only.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Jets",
          "https://en.wikipedia.org/wiki/Leon_Hess"
        ]
      },
      {
        "year": 2000,
        "price": 635000000,
        "buyer": "Woody Johnson",
        "seller": "Leon Hess estate",
        "stakePct": 100,
        "notes": "Bought in January 2000; an NFL record at the time. Hess died in 1999.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Woody_Johnson"
        ]
      }
    ]
  },
  "baltimore-ravens": {
    "formation": {
      "year": 1996,
      "price": null,
      "founder": "Art Modell",
      "notes": "Modell moved the Cleveland Browns franchise to Baltimore. Under the 1996 settlement the Browns' name and history stayed in Cleveland, so the Ravens count as a new franchise from 1996. No fee was paid.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2004,
        "price": 600000000,
        "buyer": "Steve Bisciotti",
        "seller": "Art Modell",
        "stakePct": 99,
        "notes": "Bought in two stages. On March 27, 2000 Bisciotti paid $275M for 49% with an option on more. On April 9, 2004 he paid $325M for another 50% and took control. Modell kept 1%.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Baltimore_Ravens",
          "https://en.wikipedia.org/wiki/Steve_Bisciotti"
        ]
      }
    ]
  },
  "cincinnati-bengals": {
    "formation": {
      "year": 1967,
      "price": null,
      "founder": "Paul Brown (with Austin Knowlton, John Sawyer and others)",
      "notes": "AFL expansion franchise, awarded September 1967. Reported fees conflict ($7.7M, 'an $8 million franchise', and $10M in the Wikipedia history), so price is null. Brown held about 10% but had operating control.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": null,
        "buyer": "Mike Brown / Brown family",
        "seller": "Paul Brown",
        "stakePct": null,
        "notes": "inheritance. Paul Brown died in August 1991.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mike_Brown_(American_football_executive)",
          "https://www.espn.com/blog/cincinnati-bengals/post/_/id/16125/cincinnati-bengals-ownership-at-a-glance"
        ]
      }
    ]
  },
  "cleveland-browns": {
    "formation": {
      "year": 1946,
      "price": null,
      "founder": "Arthur B. 'Mickey' McBride",
      "notes": "All-America Football Conference charter team (first season 1946); joined the NFL in 1950. Founding fee unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1953,
        "price": 600000,
        "buyer": "Group led by David R. Jones (with Ellis Ryan, Homer Marshman, Saul Silberman)",
        "seller": "Mickey McBride and partners",
        "stakePct": 100,
        "notes": "Sold June 9, 1953 for a then-unheard-of $600,000.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Cleveland_Browns",
          "https://case.edu/ech/articles/c/cleveland-browns"
        ]
      },
      {
        "year": 1961,
        "price": 3925000,
        "buyer": "Art Modell group",
        "seller": "David Jones group",
        "stakePct": null,
        "notes": "Completed March 1961. Reported as $3.925M, 'roughly $4 million' (Art Modell Wikipedia) and $4.3M (Homer Marshman Wikipedia).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Art_Modell",
          "https://en.wikipedia.org/wiki/History_of_the_Cleveland_Browns"
        ]
      },
      {
        "year": 1998,
        "price": 530000000,
        "buyer": "Al Lerner",
        "seller": "NFL (reactivated franchise)",
        "stakePct": 100,
        "notes": "The franchise was inactive in 1996-98 after Modell moved his team to Baltimore; the Browns' name and history stayed in Cleveland. Lerner paid a then-record $530M for the rights, and play resumed in 1999.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Al_Lerner"
        ]
      },
      {
        "year": 2002,
        "price": null,
        "buyer": "Randy Lerner",
        "seller": "Al Lerner estate",
        "stakePct": null,
        "notes": "inheritance. Al Lerner died in October 2002.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Al_Lerner"
        ]
      },
      {
        "year": 2012,
        "price": 1050000000,
        "buyer": "Jimmy & Dee Haslam",
        "seller": "Randy Lerner",
        "stakePct": 100,
        "notes": "Agreed in 2012, approved October 2012 (sale finalized August 2, 2012 per Wikipedia). Reported as '$1 billion', 'in excess of $1 billion' and about $1.05B.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Jimmy_Haslam",
          "https://en.wikipedia.org/wiki/History_of_the_Cleveland_Browns"
        ]
      }
    ]
  },
  "pittsburgh-steelers": {
    "formation": {
      "year": 1933,
      "price": 2500,
      "founder": "Art Rooney",
      "notes": "NFL franchise fee (Pittsburgh Pirates, renamed Steelers in 1940).",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1940,
        "price": 160000,
        "buyer": "Alexis Thompson",
        "seller": "Art Rooney",
        "stakePct": 100,
        "notes": "Sold in December 1940. Rooney used half the proceeds to buy a half-interest in the Eagles. This was the first step of the 'Pennsylvania Polka'.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Pennsylvania_Polka_(American_football)",
          "https://www.nfl.com/news/steelers-founder-had-his-own-ownership-struggles-09000d5d8094af62"
        ]
      },
      {
        "year": 1941,
        "price": null,
        "buyer": "Art Rooney & Bert Bell",
        "seller": "Alexis Thompson",
        "stakePct": 100,
        "notes": "Franchise swap: Thompson took the Eagles, and Rooney and Bell took the Pittsburgh franchise. The Rooneys have controlled it ever since.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Pennsylvania_Polka_(American_football)"
        ]
      },
      {
        "year": 1988,
        "price": null,
        "buyer": "Dan Rooney / Rooney family",
        "seller": "Art Rooney Sr. estate",
        "stakePct": null,
        "notes": "inheritance. Art Rooney died August 25, 1988, and Dan Rooney took control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Art_Rooney",
          "https://en.wikipedia.org/wiki/Pittsburgh_Steelers"
        ]
      },
      {
        "year": 2017,
        "price": null,
        "buyer": "Art Rooney II",
        "seller": "Dan Rooney estate",
        "stakePct": null,
        "notes": "inheritance. Dan Rooney died in 2017 and control passed to his son. A 2008 restructuring bought out other Rooney brothers' stakes but kept family control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Pittsburgh_Steelers"
        ]
      }
    ]
  },
  "houston-texans": {
    "formation": {
      "year": 1999,
      "price": 700000000,
      "founder": "Bob McNair",
      "notes": "NFL expansion fee; owners voted 29-0 on October 6, 1999.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2018,
        "price": null,
        "buyer": "Janice McNair (with Cal McNair as chairman/CEO)",
        "seller": "Bob McNair estate",
        "stakePct": null,
        "notes": "inheritance. Bob McNair died in November 2018.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bob_McNair"
        ]
      }
    ]
  },
  "indianapolis-colts": {
    "formation": {
      "year": 1953,
      "price": null,
      "founder": "Carroll Rosenbloom",
      "notes": "Baltimore franchise, granted January 1953 using the assets of the defunct 1952 Dallas Texans. A secondary source says Rosenbloom's personal share cost $13,000, but the total franchise price is unverified.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1972,
        "price": null,
        "buyer": "Robert Irsay",
        "seller": "Carroll Rosenbloom",
        "stakePct": 100,
        "notes": "Franchise swap completed July 1972. Irsay bought the Rams from the Dan Reeves estate (reported $19M; some sources say $12M) and traded them to Rosenbloom for the Colts plus cash. No separate Colts price. The team moved to Indianapolis in 1984.",
        "isEstimated": false,
        "sources": [
          "https://www.nfl.com/news/digging-into-the-colts-and-rams-1972-franchise-swap-was-the-greatest-biggest-tra",
          "https://www.colts.com/team/history/ownership/robert-irsay"
        ]
      },
      {
        "year": 1997,
        "price": null,
        "buyer": "Jim Irsay",
        "seller": "Robert Irsay estate",
        "stakePct": 100,
        "notes": "inheritance. Robert Irsay died in January 1997.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Indianapolis_Colts"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Carlie Irsay-Gordon, Casey Foyt, Kalen Jackson",
        "seller": "Jim Irsay estate",
        "stakePct": null,
        "notes": "inheritance. Jim Irsay died May 21, 2025. Carlie Irsay-Gordon is now the listed principal owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jim_Irsay",
          "https://en.wikipedia.org/wiki/Indianapolis_Colts"
        ]
      }
    ]
  },
  "jacksonville-jaguars": {
    "formation": {
      "year": 1993,
      "price": null,
      "founder": "Wayne Weaver (Touchdown Jacksonville! group)",
      "notes": "NFL expansion franchise, awarded November 30, 1993. No reliable fee figure found: one aggregator cites $206M (the figure Wikipedia gives for Carolina), and the often-quoted $140M league fee could not be confirmed.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2012,
        "price": 770000000,
        "buyer": "Shahid (Shad) Khan",
        "seller": "Wayne Weaver ownership group",
        "stakePct": 100,
        "notes": "Announced November 29, 2011, approved by NFL owners December 14, 2011, closed January 4, 2012. All-cash deal. Weaver's Wikipedia page says $760M for the majority share.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Shahid_Khan",
          "https://en.wikipedia.org/wiki/Jacksonville_Jaguars"
        ]
      }
    ]
  },
  "tennessee-titans": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "K.S. 'Bud' Adams",
      "notes": "AFL charter franchise (Houston Oilers). Relocated to Tennessee in 1997 and renamed the Titans in 1999.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2013,
        "price": null,
        "buyer": "Adams heirs (Susie Adams Smith as controlling owner; Amy Adams Strunk; family of Kenneth Adams III)",
        "seller": "Bud Adams estate",
        "stakePct": null,
        "notes": "inheritance. Bud Adams died October 21, 2013.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bud_Adams",
          "https://en.wikipedia.org/wiki/Amy_Adams_Strunk"
        ]
      },
      {
        "year": 2015,
        "price": null,
        "buyer": "Amy Adams Strunk",
        "seller": "Susie Adams Smith (intra-family)",
        "stakePct": 50,
        "notes": "Controlling-owner role moved within the family; Strunk holds half of the franchise. No sale price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Amy_Adams_Strunk"
        ]
      }
    ]
  },
  "denver-broncos": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Bob Howsam",
      "notes": "AFL charter franchise.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1961,
        "price": null,
        "buyer": "Rocky Mountain Empire Sports group (incl. Gerald Phipps, Cal Kunz)",
        "seller": "Bob Howsam",
        "stakePct": null,
        "notes": "Howsam sold after the first season. Price not confirmed (the Gerald Phipps Wikipedia page says 'less than $1 million').",
        "isEstimated": false,
        "sources": [
          "https://www.denverbroncos.com/news/sacco-sez-the-history-of-broncos-owners",
          "https://en.wikipedia.org/wiki/Gerald_Phipps"
        ]
      },
      {
        "year": 1965,
        "price": 1500000,
        "buyer": "Gerald & Allan Phipps",
        "seller": "Other Rocky Mountain Empire Sports shareholders",
        "stakePct": null,
        "notes": "Buyout on February 14, 1965 blocked a sale to Atlanta interests. Price derived from a $250,000 down payment plus $1.25M due June 1.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Gerald_Phipps",
          "https://www.denverbroncos.com/news/sacco-sez-the-history-of-broncos-owners"
        ]
      },
      {
        "year": 1981,
        "price": null,
        "buyer": "Edgar Kaiser Jr.",
        "seller": "Phipps family",
        "stakePct": null,
        "notes": "Sold February 1981. Wikipedia pages conflict ($29M on Edgar Kaiser Jr.'s page, $40M on Gerald Phipps' page), so price is null.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Edgar_Kaiser_Jr.",
          "https://en.wikipedia.org/wiki/Gerald_Phipps"
        ]
      },
      {
        "year": 1984,
        "price": 78000000,
        "buyer": "Pat Bowlen (with siblings)",
        "seller": "Edgar Kaiser Jr.",
        "stakePct": 60.8,
        "notes": "Bowlen bought Kaiser's 60.8% in March 1984. His own Wikipedia page says about $70M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Edgar_Kaiser_Jr.",
          "https://en.wikipedia.org/wiki/Pat_Bowlen"
        ]
      },
      {
        "year": 2019,
        "price": null,
        "buyer": "Pat Bowlen Trust",
        "seller": "Pat Bowlen estate",
        "stakePct": null,
        "notes": "inheritance. Bowlen stepped away in 2014 and died in June 2019; trustees ran the team until the sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Pat_Bowlen"
        ]
      },
      {
        "year": 2022,
        "price": 4650000000,
        "buyer": "Walton-Penner family ownership group (led by Rob Walton)",
        "seller": "Pat Bowlen Trust",
        "stakePct": 100,
        "notes": "Agreement June 2022; NFL approval August 9-10, 2022. At the time, a record price for a sports team.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Denver_Broncos",
          "https://en.wikipedia.org/wiki/Denver_Broncos"
        ]
      }
    ]
  },
  "kansas-city-chiefs": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Lamar Hunt",
      "notes": "AFL charter franchise (Dallas Texans); moved to Kansas City in 1963.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2006,
        "price": null,
        "buyer": "Hunt family (Norma Hunt and children; Clark Hunt chairman/CEO)",
        "seller": "Lamar Hunt estate",
        "stakePct": 100,
        "notes": "inheritance. Lamar Hunt died in 2006. After Norma Hunt died in 2023, her stake passed to the Hunt children.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Kansas_City_Chiefs"
        ]
      }
    ]
  },
  "las-vegas-raiders": {
    "formation": {
      "year": 1960,
      "price": 25000,
      "founder": "Limited partnership led by Y. Charles 'Chet' Soda (with Wayne Valley, Ed McGah and others)",
      "notes": "Eighth AFL charter franchise, awarded January 30, 1960.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1972,
        "price": null,
        "buyer": "Al Davis",
        "seller": "Wayne Valley (displaced as managing general partner)",
        "stakePct": null,
        "notes": "No sale: Davis took control through a revised partnership agreement. He had bought 10% for $18,000 in 1966, and Valley sold his stake in 1976. The team moved to Los Angeles (1982), back to Oakland (1995) and to Las Vegas (2020).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Al_Davis",
          "https://en.wikipedia.org/wiki/F._Wayne_Valley"
        ]
      },
      {
        "year": 2011,
        "price": null,
        "buyer": "Mark Davis & Carol Davis",
        "seller": "Al Davis estate",
        "stakePct": null,
        "notes": "inheritance. Al Davis died October 2011. The 2024 minority sales (Brady/Wagner and others at about a $6.5B valuation) are not control changes.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mark_Davis_(American_football)"
        ]
      }
    ]
  },
  "los-angeles-chargers": {
    "formation": {
      "year": 1959,
      "price": 25000,
      "founder": "Barron Hilton",
      "notes": "AFL charter franchise (Los Angeles Chargers); moved to San Diego in 1961 and back to Los Angeles in 2017.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1966,
        "price": 10000000,
        "buyer": "Gene Klein & Sam Schulman group",
        "seller": "Barron Hilton",
        "stakePct": null,
        "notes": "Hilton sold his majority interest for $10M, a record for a pro sports franchise at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Barron_Hilton",
          "https://en.wikipedia.org/wiki/Gene_Klein"
        ]
      },
      {
        "year": 1984,
        "price": 70000000,
        "buyer": "Alex Spanos",
        "seller": "Gene Klein",
        "stakePct": 60,
        "notes": "August 1984. ESPN reports $70M for 60%; Alex Spanos' Wikipedia page says $48.3M. The family later built up to about 97%.",
        "isEstimated": true,
        "sources": [
          "https://www.espn.com/blog/los-angeles-chargers/post/_/id/10178/san-diego-chargers-ownership-at-a-glance",
          "https://en.wikipedia.org/wiki/Alex_Spanos"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Dean Spanos / Spanos family",
        "seller": "Alex Spanos estate",
        "stakePct": null,
        "notes": "inheritance. Alex Spanos died October 2018. Dean had run the team since the 1990s. The 2024 sale of Dea Berberian's stake to Tom Gores was a minority deal.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nfl/story/_/id/24941255/los-angeles-chargers-owner-alex-spanos-dies-95",
          "https://en.wikipedia.org/wiki/Dean_Spanos"
        ]
      }
    ]
  },
  "dallas-cowboys": {
    "formation": {
      "year": 1960,
      "price": 600000,
      "founder": "Clint Murchison Jr. and Bedford Wynne",
      "notes": "NFL expansion franchise. The $600,000 is commonly reported as a $50,000 franchise fee plus $550,000 for expansion-draft players. Aggregator source only.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1984,
        "price": 85000000,
        "buyer": "H.R. 'Bum' Bright (limited partnership)",
        "seller": "Clint Murchison Jr.",
        "stakePct": 100,
        "notes": "Reported as $83M or $85M; some reports include the Texas Stadium lease.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Bum_Bright",
          "https://en.wikipedia.org/wiki/Clint_Murchison_Jr."
        ]
      },
      {
        "year": 1989,
        "price": 140000000,
        "buyer": "Jerry Jones",
        "seller": "H.R. 'Bum' Bright",
        "stakePct": 100,
        "notes": "February 25, 1989. The deal included the Texas Stadium lease; it is sometimes quoted as $150M with the stadium.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jerry_Jones",
          "https://www.cbs19.tv/article/news/on-this-day-jerry-jones-buys-dallas-cowboys-in-1989-for-140m/501-102f1d71-5152-4174-91db-2ee72f4e0f7b"
        ]
      }
    ]
  },
  "new-york-giants": {
    "formation": {
      "year": 1925,
      "price": 500,
      "founder": "Tim Mara",
      "notes": "NFL franchise fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1930,
        "price": null,
        "buyer": "Jack Mara & Wellington Mara",
        "seller": "Tim Mara",
        "stakePct": 100,
        "notes": "Transfer without sale: Tim Mara handed ownership to his sons.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mara_family"
        ]
      },
      {
        "year": 1965,
        "price": null,
        "buyer": "Tim J. Mara (Jack's son)",
        "seller": "Jack Mara estate",
        "stakePct": 50,
        "notes": "inheritance. Jack Mara's half passed to his son; Wellington kept the other half.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mara_family"
        ]
      },
      {
        "year": 1991,
        "price": 75000000,
        "buyer": "Preston Robert (Bob) Tisch",
        "seller": "Tim J. Mara",
        "stakePct": 50,
        "notes": "Announced February 1991, creating 50/50 co-control with Wellington Mara. Also reported as $80M (Wikipedia) and $70M.",
        "isEstimated": true,
        "sources": [
          "https://www.forbes.com/2003/08/29/cz_mb_0829giants.html",
          "https://www.espn.com/blog/nflnation/post/_/id/164371/new-york-giants-ownership-at-a-glance"
        ]
      },
      {
        "year": 2005,
        "price": null,
        "buyer": "John Mara (Mara family) & Steve Tisch (Tisch family)",
        "seller": "Wellington Mara estate & Bob Tisch estate",
        "stakePct": 100,
        "notes": "inheritance. Both co-owners died in 2005. The 2025 Koch family minority stake at a valuation above $10B is not a control change.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Giants",
          "https://en.wikipedia.org/wiki/Mara_family"
        ]
      }
    ]
  },
  "philadelphia-eagles": {
    "formation": {
      "year": 1933,
      "price": 2500,
      "founder": "Bert Bell and Lud Wray",
      "notes": "Entry fee for the assets of the defunct Frankford Yellow Jackets. The Eagles Wikipedia page gives $3,500 plus $11,000 of assumed debts.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1936,
        "price": null,
        "buyer": "Bert Bell",
        "seller": "Lud Wray",
        "stakePct": null,
        "notes": "Bell bought out Wray at auction and became sole owner. Price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Eagles"
        ]
      },
      {
        "year": 1941,
        "price": null,
        "buyer": "Alexis Thompson",
        "seller": "Bert Bell & Art Rooney",
        "stakePct": 100,
        "notes": "'Pennsylvania Polka' franchise swap: Thompson traded the Pittsburgh franchise for the Eagles.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Pennsylvania_Polka_(American_football)"
        ]
      },
      {
        "year": 1949,
        "price": 250000,
        "buyer": "'Happy Hundred' syndicate (led by James P. Clark)",
        "seller": "Alexis Thompson",
        "stakePct": 100,
        "notes": "100 investors each paid $3,000 per share, which implies $300,000. $250,000 is also commonly cited as the price.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Happy_Hundred",
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Eagles"
        ]
      },
      {
        "year": 1963,
        "price": 5505000,
        "buyer": "Jerry Wolman",
        "seller": "Happy Hundred syndicate",
        "stakePct": 100,
        "notes": "December 1963; described as 'unprecedented' for control of the club.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Eagles",
          "https://en.wikipedia.org/wiki/Jerry_Wolman"
        ]
      },
      {
        "year": 1969,
        "price": 16155000,
        "buyer": "Leonard Tose",
        "seller": "Jerry Wolman",
        "stakePct": 100,
        "notes": "Distressed sale during Wolman's bankruptcy; a pro sports record at the time. Also reported as $16.1M or $16.115M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Leonard_Tose",
          "https://en.wikipedia.org/wiki/Jerry_Wolman"
        ]
      },
      {
        "year": 1985,
        "price": 65000000,
        "buyer": "Norman Braman & Ed Leibowitz",
        "seller": "Leonard Tose",
        "stakePct": 100,
        "notes": "Reported $65M; Tose sold to pay off gambling debts.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Philadelphia_Eagles",
          "https://en.wikipedia.org/wiki/Norman_Braman"
        ]
      },
      {
        "year": 1994,
        "price": 185000000,
        "buyer": "Jeffrey Lurie",
        "seller": "Norman Braman",
        "stakePct": 100,
        "notes": "May 6, 1994; partly financed with a $190M Bank of Boston loan. Lurie's Wikipedia page says $195M; $185M is the most-cited figure.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Norman_Braman",
          "https://en.wikipedia.org/wiki/Jeffrey_Lurie"
        ]
      }
    ]
  },
  "washington-commanders": {
    "formation": {
      "year": 1932,
      "price": null,
      "founder": "George Preston Marshall (with three partners)",
      "notes": "NFL franchise for Boston (Braves, renamed Redskins in 1933); moved to Washington in 1937. Fee unknown; one aggregator claims $100, unverified.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1933,
        "price": null,
        "buyer": "George Preston Marshall",
        "seller": "Marshall's three partners",
        "stakePct": null,
        "notes": "After a $46,000 first-season loss, the partners sold their interests to Marshall. Price unknown.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/George_Preston_Marshall"
        ]
      },
      {
        "year": 1974,
        "price": null,
        "buyer": "Jack Kent Cooke",
        "seller": "Edward Bennett Williams / Marshall estate shareholders",
        "stakePct": null,
        "notes": "Cooke had bought 25% in 1960-61 for $300,000-$350,000. He bought majority interest in 1974 (price unknown), became operating owner in 1979, and became sole owner in 1985 by buying Williams' remaining shares for about $9M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jack_Kent_Cooke",
          "https://en.wikipedia.org/wiki/History_of_the_Washington_Commanders"
        ]
      },
      {
        "year": 1997,
        "price": null,
        "buyer": "Jack Kent Cooke estate (John Kent Cooke, president)",
        "seller": "Jack Kent Cooke",
        "stakePct": 100,
        "notes": "inheritance. Cooke died April 1997.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jack_Kent_Cooke"
        ]
      },
      {
        "year": 1999,
        "price": 800000000,
        "buyer": "Daniel Snyder",
        "seller": "Jack Kent Cooke estate",
        "stakePct": 100,
        "notes": "May 1999; included Jack Kent Cooke Stadium (FedExField). A record for a sports franchise at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Daniel_Snyder",
          "https://sports.yahoo.com/24-years-ago-daniel-snyder-094006436.html"
        ]
      },
      {
        "year": 2023,
        "price": 6050000000,
        "buyer": "Josh Harris group (with Mitchell Rales, Magic Johnson, Mark Ein and others)",
        "seller": "Daniel Snyder",
        "stakePct": 100,
        "notes": "Unanimously approved July 20, 2023 and closed July 21; a record sports team sale at the time.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Daniel_Snyder",
          "https://en.wikipedia.org/wiki/Josh_Harris_(businessman)"
        ]
      }
    ]
  },
  "chicago-bears": {
    "formation": {
      "year": 1920,
      "price": 100,
      "founder": "A.E. Staley (A.E. Staley Manufacturing Co.)",
      "notes": "Decatur Staleys, a charter APFA member. $100 was the 1920 APFA franchise fee (per the Chicago Cardinals Wikipedia page); unclear whether it was actually collected.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1921,
        "price": null,
        "buyer": "George Halas & Edward 'Dutch' Sternaman",
        "seller": "A.E. Staley",
        "stakePct": 100,
        "notes": "Staley handed the team to Halas and Sternaman and paid them $5,000 to keep the Staleys name for one more season. Moved to Chicago; became the Bears in 1922.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Bears"
        ]
      },
      {
        "year": 1932,
        "price": 38000,
        "buyer": "George Halas",
        "seller": "Dutch Sternaman",
        "stakePct": 50,
        "notes": "Sternaman offered his stake for $38,000 in 1931; Halas completed the buyout in 1932-33 with investor help, including Charles Bidwill.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Bears"
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Virginia Halas McCaskey / McCaskey family",
        "seller": "George Halas estate",
        "stakePct": null,
        "notes": "inheritance. Halas died October 1983.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/George_Halas"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "McCaskey family (George McCaskey, chairman)",
        "seller": "Virginia Halas McCaskey estate",
        "stakePct": null,
        "notes": "inheritance. Virginia McCaskey died February 2025. The September 2025 sale of the McKenna family's 2.35% at an $8.9B valuation is a minority deal.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Bears"
        ]
      }
    ]
  },
  "detroit-lions": {
    "formation": {
      "year": 1929,
      "price": null,
      "founder": "Portsmouth, Ohio community ownership (Portsmouth Spartans)",
      "notes": "Independent team founded in Portsmouth, Ohio; joined the NFL in 1930. Fee unknown.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1934,
        "price": 8000,
        "buyer": "George A. Richards",
        "seller": "Portsmouth Spartans shareholders",
        "stakePct": 100,
        "notes": "Moved to Detroit and renamed the Lions. Some sources give $7,952.08 plus assumed debts.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Detroit_Lions"
        ]
      },
      {
        "year": 1940,
        "price": 225000,
        "buyer": "Fred L. Mandel Jr.",
        "seller": "George A. Richards",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Detroit_Lions",
          "https://www.fundinguniverse.com/company-histories/the-detroit-lions-inc-history/"
        ]
      },
      {
        "year": 1948,
        "price": 165000,
        "buyer": "Detroit Football Company (syndicate led by D. Lyle Fife and Edwin J. Anderson)",
        "seller": "Fred L. Mandel Jr.",
        "stakePct": 100,
        "notes": "Approved January 15, 1948.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Detroit_Football_Company",
          "https://www.fundinguniverse.com/company-histories/the-detroit-lions-inc-history/"
        ]
      },
      {
        "year": 1964,
        "price": 4500000,
        "buyer": "William Clay Ford Sr.",
        "seller": "Detroit Football Company shareholders",
        "stakePct": null,
        "notes": "Agreed November 22, 1963, closed January 10, 1964. $4.5M is the most-cited figure; the Wikipedia history pages say $6M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Detroit_Football_Company",
          "https://en.wikipedia.org/wiki/History_of_the_Detroit_Lions"
        ]
      },
      {
        "year": 2014,
        "price": null,
        "buyer": "Martha Firestone Ford",
        "seller": "William Clay Ford Sr. estate",
        "stakePct": null,
        "notes": "inheritance. Ford died March 2014.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nfl/story/_/id/10582662/family-william-clay-ford-sr-retain-controlling-interest-detroit-lions",
          "https://en.wikipedia.org/wiki/Martha_Firestone_Ford"
        ]
      },
      {
        "year": 2020,
        "price": null,
        "buyer": "Sheila Ford Hamp",
        "seller": "Martha Firestone Ford (intra-family)",
        "stakePct": null,
        "notes": "Martha Ford stepped down June 23, 2020 and her daughter took control. No sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Detroit_Lions"
        ]
      }
    ]
  },
  "green-bay-packers": {
    "formation": {
      "year": 1919,
      "price": null,
      "founder": "Curly Lambeau and George Calhoun (sponsored by Indian Packing Co.)",
      "notes": "Town team founded August 11, 1919.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1921,
        "price": null,
        "buyer": "Clair brothers (Acme Packing)",
        "seller": "Lambeau/Calhoun town team",
        "stakePct": null,
        "notes": "The Clair brothers bought the team and joined the APFA on August 27, 1921. Price unknown.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Green_Bay_Packers"
        ]
      },
      {
        "year": 1922,
        "price": 50,
        "buyer": "Curly Lambeau",
        "seller": "NFL (franchise re-granted)",
        "stakePct": 100,
        "notes": "The franchise was revoked after the 1921 season. Lambeau paid a $50 league entry fee for a technically new franchise.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Green_Bay_Packers"
        ]
      },
      {
        "year": 1923,
        "price": null,
        "buyer": "Green Bay Football Corporation (publicly owned non-profit; 'Hungry Five')",
        "seller": "Curly Lambeau",
        "stakePct": 100,
        "notes": "Community ownership formed to avoid bankruptcy. The team has never been sold since; later stock sales (for example 1997-98 at $200/share) raised capital without changing control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Green_Bay_Packers"
        ]
      }
    ]
  },
  "minnesota-vikings": {
    "formation": {
      "year": 1960,
      "price": 600000,
      "founder": "Max Winter, Bill Boyer, H.P. Skoglund, Ole Haugsrud, Bernard Ridder Jr.",
      "notes": "NFL expansion franchise, awarded January 28, 1960; began play in 1961.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1991,
        "price": 50000000,
        "buyer": "Mike Lynn, Wheelock Whitney, Jaye Dyer group",
        "seller": "Carl Pohlad & Irwin Jacobs",
        "stakePct": null,
        "notes": "December 16, 1991. Settled a control fight: Pohlad and Jacobs had bought majority (non-controlling) interest in 1986. Ownership then went to a 10-member consortium in early 1992.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ownership_of_the_Minnesota_Vikings"
        ]
      },
      {
        "year": 1998,
        "price": 250000000,
        "buyer": "Red McCombs",
        "seller": "10-member ownership group",
        "stakePct": 100,
        "notes": "Agreed July 2, 1998, after Tom Clancy's $200M deal collapsed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ownership_of_the_Minnesota_Vikings",
          "https://en.wikipedia.org/wiki/Red_McCombs"
        ]
      },
      {
        "year": 2005,
        "price": 600000000,
        "buyer": "Zygi Wilf group (Wilf family)",
        "seller": "Red McCombs",
        "stakePct": 100,
        "notes": "Unanimously approved May 25, 2005; closed June 13, 2005.",
        "isEstimated": false,
        "sources": [
          "https://www.deseret.com/2005/5/26/19894328/nfl-approves-sale-of-vikings/",
          "https://www.upi.com/Sports_News/2005/05/25/NFL-owners-approve-sale-of-Vikings/34661117043118/"
        ]
      }
    ]
  },
  "atlanta-falcons": {
    "formation": {
      "year": 1965,
      "price": 8500000,
      "founder": "Rankin M. Smith Sr.",
      "notes": "NFL expansion franchise, granted June 30, 1965; the highest franchise price in NFL history at the time.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1997,
        "price": null,
        "buyer": "Taylor Smith / Smith family",
        "seller": "Rankin Smith Sr. estate",
        "stakePct": null,
        "notes": "inheritance. Rankin Smith died in 1997.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Falcons"
        ]
      },
      {
        "year": 2002,
        "price": 545000000,
        "buyer": "Arthur Blank",
        "seller": "Taylor Smith / Smith family",
        "stakePct": 100,
        "notes": "Preliminary agreement December 2001; approved and closed February 2002. Reported price.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Falcons",
          "https://en.wikipedia.org/wiki/Arthur_Blank"
        ]
      }
    ]
  },
  "carolina-panthers": {
    "formation": {
      "year": 1993,
      "price": 206000000,
      "founder": "Jerry Richardson",
      "notes": "NFL expansion franchise, awarded October 26, 1993. Wikipedia says Richardson and investors paid $206M for the rights. A $140M league fee is also often quoted but was not verified here.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 2018,
        "price": 2275000000,
        "buyer": "David Tepper",
        "seller": "Jerry Richardson",
        "stakePct": 100,
        "notes": "Agreed May 2018, approved May 22, 2018, closed July 9, 2018; an NFL record at the time. Reported as about $2.2B-$2.3B; $2.275B is the most-cited figure.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Carolina_Panthers",
          "https://en.wikipedia.org/wiki/Jerry_Richardson"
        ]
      }
    ]
  },
  "new-orleans-saints": {
    "formation": {
      "year": 1966,
      "price": 8500000,
      "founder": "John W. Mecom Jr.",
      "notes": "NFL expansion franchise; Mecom's winning bid on December 15, 1966.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1985,
        "price": 70204000,
        "buyer": "Tom Benson",
        "seller": "John W. Mecom Jr.",
        "stakePct": 100,
        "notes": "Ownership transferred May 31, 1985.",
        "isEstimated": false,
        "sources": [
          "https://www.neworleanssaints.com/news/this-day-in-new-orleans-saints-history-may-31-17143001",
          "https://en.wikipedia.org/wiki/Tom_Benson"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Gayle Benson",
        "seller": "Tom Benson estate",
        "stakePct": 100,
        "notes": "inheritance. Tom Benson died March 2018.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Gayle_Benson"
        ]
      }
    ]
  },
  "tampa-bay-buccaneers": {
    "formation": {
      "year": 1974,
      "price": 16000000,
      "founder": "Hugh Culverhouse",
      "notes": "NFL expansion franchise, first awarded October 30, 1974 to Tom McCloskey, who backed out; it then went to Culverhouse.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1994,
        "price": null,
        "buyer": "Culverhouse estate trust",
        "seller": "Hugh Culverhouse",
        "stakePct": 100,
        "notes": "inheritance. Culverhouse died August 1994; trustees ran the team until the sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Hugh_Culverhouse"
        ]
      },
      {
        "year": 1995,
        "price": 192000000,
        "buyer": "Malcolm Glazer",
        "seller": "Culverhouse estate trust",
        "stakePct": 100,
        "notes": "Then the highest price ever paid for a pro sports franchise. (The earlier note calling this an expansion award was wrong.)",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Hugh_Culverhouse",
          "https://en.wikipedia.org/wiki/Malcolm_Glazer"
        ]
      },
      {
        "year": 2014,
        "price": null,
        "buyer": "Glazer family (Bryan, Joel, Edward Glazer et al.)",
        "seller": "Malcolm Glazer estate",
        "stakePct": 100,
        "notes": "inheritance. Malcolm Glazer died May 2014.",
        "isEstimated": false,
        "sources": [
          "https://www.nfl.com/news/malcolm-glazer-left-winning-stamp-on-tampa-bay-buccaneers-0ap2000000354139"
        ]
      }
    ]
  },
  "arizona-cardinals": {
    "formation": {
      "year": 1898,
      "price": null,
      "founder": "Chris O'Brien (Morgan Athletic Club, Chicago)",
      "notes": "Charter APFA member in 1920 for a $100 franchise fee. Moved to St. Louis in 1960 and to Arizona in 1988.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1929,
        "price": 25000,
        "buyer": "Dr. David Jones",
        "seller": "Chris O'Brien",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/David_Jones_(Cardinals_owner)",
          "https://en.wikipedia.org/wiki/Chris_O'Brien_(American_football)"
        ]
      },
      {
        "year": 1932,
        "price": 50000,
        "buyer": "Charles Bidwill",
        "seller": "Dr. David Jones",
        "stakePct": 100,
        "notes": "Agreed in 1932 but announced in 1933, which gave Bidwill time to sell his Bears stock.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Charles_Bidwill",
          "https://en.wikipedia.org/wiki/Bill_Bidwill"
        ]
      },
      {
        "year": 1947,
        "price": null,
        "buyer": "Violet Bidwill (later Wolfner)",
        "seller": "Charles Bidwill estate",
        "stakePct": 100,
        "notes": "inheritance. Charles Bidwill died April 1947.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arizona_Cardinals"
        ]
      },
      {
        "year": 1962,
        "price": null,
        "buyer": "Charles 'Stormy' Bidwill Jr. & Bill Bidwill",
        "seller": "Violet Bidwill Wolfner estate",
        "stakePct": 100,
        "notes": "inheritance. Violet died January 1962.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Bidwill"
        ]
      },
      {
        "year": 1972,
        "price": null,
        "buyer": "Bill Bidwill",
        "seller": "Charles Bidwill Jr.",
        "stakePct": 50,
        "notes": "Bill bought out his brother and became sole owner in September 1972. Price not found.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Bidwill"
        ]
      },
      {
        "year": 2019,
        "price": null,
        "buyer": "Michael Bidwill / Bidwill family",
        "seller": "Bill Bidwill estate",
        "stakePct": null,
        "notes": "inheritance. Bill Bidwill died October 2, 2019.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Bidwill",
          "https://en.wikipedia.org/wiki/Arizona_Cardinals"
        ]
      }
    ]
  },
  "los-angeles-rams": {
    "formation": {
      "year": 1936,
      "price": 10000,
      "founder": "Homer Marshman (Cleveland Rams)",
      "notes": "Founded in the second AFL (1936); joined the NFL in 1937 for a $10,000 franchise fee, plus $55,000 of capital. Moved to Los Angeles in 1946, St. Louis in 1995, and back to Los Angeles in 2016.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1941,
        "price": 100000,
        "buyer": "Dan Reeves & Fred Levy Jr.",
        "seller": "Homer Marshman and partners",
        "stakePct": 100,
        "notes": "June 1941. Reported as about $100,000 (Marshman Wikipedia) and $135,000 (Rams history).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Homer_Marshman",
          "https://en.wikipedia.org/wiki/History_of_the_Los_Angeles_Rams"
        ]
      },
      {
        "year": 1962,
        "price": 7100000,
        "buyer": "Dan Reeves",
        "seller": "Rams partners (incl. Edwin Pauley, Fred Levy)",
        "stakePct": null,
        "notes": "A league-run closed auction settled a partnership dispute. Reeves' bid valued the team at about $7.1M, and he secured majority control. Stake and cash paid are reported inconsistently.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Dan_Reeves_(American_football_executive)"
        ]
      },
      {
        "year": 1972,
        "price": 19000000,
        "buyer": "Robert Irsay",
        "seller": "Dan Reeves estate",
        "stakePct": 100,
        "notes": "Reeves died in 1971. Irsay bought the Rams (reported $19M; some sources say $12M) and immediately traded them for the Colts.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Los_Angeles_Rams",
          "https://en.wikipedia.org/wiki/Robert_Irsay"
        ]
      },
      {
        "year": 1972,
        "price": null,
        "buyer": "Carroll Rosenbloom",
        "seller": "Robert Irsay",
        "stakePct": 100,
        "notes": "Franchise swap: Rosenbloom traded the Baltimore Colts (plus cash) for the Rams.",
        "isEstimated": false,
        "sources": [
          "https://www.nfl.com/news/digging-into-the-colts-and-rams-1972-franchise-swap-was-the-greatest-biggest-tra"
        ]
      },
      {
        "year": 1979,
        "price": null,
        "buyer": "Georgia Frontiere",
        "seller": "Carroll Rosenbloom estate",
        "stakePct": 70,
        "notes": "inheritance. Rosenbloom drowned April 1979; his widow inherited 70%. Stan Kroenke bought a 40% minority stake in 1995.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Los_Angeles_Rams",
          "https://en.wikipedia.org/wiki/Georgia_Frontiere"
        ]
      },
      {
        "year": 2008,
        "price": null,
        "buyer": "Chip Rosenbloom & Lucia Rodriguez",
        "seller": "Georgia Frontiere estate",
        "stakePct": 60,
        "notes": "inheritance. Frontiere died January 2008.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Georgia_Frontiere"
        ]
      },
      {
        "year": 2010,
        "price": 450000000,
        "buyer": "Stan Kroenke",
        "seller": "Chip Rosenbloom & Lucia Rodriguez",
        "stakePct": 60,
        "notes": "Kroenke used his right of first refusal to match Shahid Khan's agreed deal. Values 100% at $750M; approved August 2010.",
        "isEstimated": false,
        "sources": [
          "https://www.espn.com/nfl/news/story?id=5496516",
          "https://www.sportspro.com/news/arsenals_stan_kroenke_completes_lucrative_sale_of_sports_franchise/"
        ]
      }
    ]
  },
  "san-francisco-49ers": {
    "formation": {
      "year": 1946,
      "price": 25000,
      "founder": "Tony Morabito (with brother Vic Morabito and lumber-business partners)",
      "notes": "AAFC charter team (first season 1946); joined the NFL in 1950. The $25,000 founding figure comes from secondary sources.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1957,
        "price": null,
        "buyer": "Josephine Morabito & Vic Morabito",
        "seller": "Tony Morabito estate",
        "stakePct": null,
        "notes": "inheritance. Tony Morabito died October 27, 1957.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tony_Morabito"
        ]
      },
      {
        "year": 1964,
        "price": null,
        "buyer": "Josephine & Jane Morabito (widows)",
        "seller": "Vic Morabito estate",
        "stakePct": null,
        "notes": "inheritance. Vic Morabito died in 1964; the widows kept majority ownership until 1977.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tony_Morabito"
        ]
      },
      {
        "year": 1977,
        "price": 17500000,
        "buyer": "Edward J. DeBartolo Jr. (DeBartolo family)",
        "seller": "Morabito widows",
        "stakePct": 85,
        "notes": "$17.5M for 85% (often rounded to $17M).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Edward_J._DeBartolo_Jr.",
          "https://www.washingtonpost.com/archive/sports/1977/03/01/purchaser-found-to-buy-49ers/4ba74531-8e6c-48d1-9ca2-23ad3a4c2bda/"
        ]
      },
      {
        "year": 2000,
        "price": null,
        "buyer": "Denise DeBartolo York & John York",
        "seller": "Edward J. DeBartolo Jr.",
        "stakePct": null,
        "notes": "Control moved to his sister through a family asset settlement, not a cash sale; Eddie received other family holdings.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Denise_DeBartolo_York",
          "https://www.sfgate.com/sports/article/DeBartolo-is-officially-out-of-the-49ers-family-2565257.php"
        ]
      },
      {
        "year": 2024,
        "price": null,
        "buyer": "Jed York",
        "seller": "Denise DeBartolo York (intra-family)",
        "stakePct": null,
        "notes": "Jed York bought equity from his mother to become principal owner (approval expected at the March 2024 league meeting); terms undisclosed. The 2025 sales of 9.2% at an $8.5B valuation were minority deals.",
        "isEstimated": false,
        "sources": [
          "https://www.nbcsportsbayarea.com/nfl/san-francisco-49ers/source-jed-york-principal-owner/1716767/",
          "https://www.nbcsportsbayarea.com/nfl/san-francisco-49ers/jed-york-49ers-ownership-decision-reason/1717527/"
        ]
      }
    ]
  },
  "seattle-seahawks": {
    "formation": {
      "year": 1974,
      "price": 16000000,
      "founder": "Nordstrom family (Lloyd W. Nordstrom) with Herman Sarkowsky and partners",
      "notes": "NFL expansion franchise, awarded June 1974; began play in 1976.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1988,
        "price": 80000000,
        "buyer": "Ken Behring & Ken Hofmann",
        "seller": "Nordstrom family / Sarkowsky group",
        "stakePct": 100,
        "notes": "Reported $80M; $79M and $99M have also been reported.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Ken_Behring",
          "https://en.wikipedia.org/wiki/Seattle_Seahawks"
        ]
      },
      {
        "year": 1997,
        "price": 200000000,
        "buyer": "Paul Allen",
        "seller": "Ken Behring & Ken Hofmann",
        "stakePct": 100,
        "notes": "Allen took an option in 1996 and completed the purchase in 1997 after the stadium referendum. Reported as $200M (some sources say about $194M).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Seattle_Seahawks",
          "https://en.wikipedia.org/wiki/Paul_Allen"
        ]
      },
      {
        "year": 2018,
        "price": null,
        "buyer": "Paul G. Allen estate (Jody Allen, trustee/chair)",
        "seller": "Paul Allen",
        "stakePct": 100,
        "notes": "inheritance. Allen died October 2018; the estate held the team until the 2026 sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jody_Allen",
          "https://en.wikipedia.org/wiki/Seattle_Seahawks"
        ]
      },
      {
        "year": 2026,
        "price": 9612000000,
        "buyer": "Khosla family group (Vinod Khosla chair; Neeru Khosla controlling owner; Neal Khosla vice chair)",
        "seller": "Paul G. Allen estate",
        "stakePct": 100,
        "notes": "Agreement announced July 11, 2026; unanimously approved by NFL owners August 26, 2026; closed September 3, 2026. An NFL record price. Co-investors include Carlyle, Sixth Street, Dynasty Equity and Penny Pritzker. The Khoslas had to give up their San Francisco 49ers stake.",
        "isEstimated": false,
        "sources": [
          "https://www.seahawks.com/news/estate-of-paul-g-allen-reaches-agreement-to-sell-seattle-seahawks",
          "https://www.nfl.com/news/nfl-owners-approve-sale-seattle-seahawks-khosla-family",
          "https://www.nfl.com/news/khosla-family-closes-purchase-seahawks",
          "https://www.espn.com/nfl/story/_/id/49733969/nfl-owners-approve-seahawks-sale-khosla-group"
        ]
      }
    ]
  },
  "boston-bruins": {
    "formation": {
      "year": 1924,
      "price": 15000,
      "founder": "Charles Adams",
      "notes": "NHL expansion fee for the 1924 teams (Bruins, Maroons) was about C$15,000; CAD near par with USD in 1924, so USD figure is approximate.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 1936,
        "price": null,
        "buyer": "Weston Adams (with Art Ross, Ralph Burkard)",
        "seller": "Charles Adams",
        "stakePct": null,
        "notes": "Inheritance/transfer: Charles Adams transferred his stock to his son, who became majority owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Weston_Adams_(ice_hockey,_born_1904)"
        ]
      },
      {
        "year": 1951,
        "price": null,
        "buyer": "Boston Garden-Arena Corporation (Walter A. Brown)",
        "seller": "Weston Adams",
        "stakePct": null,
        "notes": "Garden-Arena Corp bought controlling interest; Walter Brown ran the team until 1964. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Bruins",
          "https://en.wikipedia.org/wiki/Weston_Adams_(ice_hockey,_born_1904)"
        ]
      },
      {
        "year": 1973,
        "price": 16500000,
        "buyer": "Storer Broadcasting",
        "seller": "Boston Garden-Arena Corporation shareholders",
        "stakePct": 100,
        "notes": "Storer merged with Garden-Arena Corp (owner of the Bruins and the Boston Garden) for $16-17 million in stock; agreed Dec 1972, completed Dec 1973. Midpoint used; includes the arena.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Storer_Communications",
          "https://en.wikipedia.org/wiki/Boston_Bruins"
        ]
      },
      {
        "year": 1975,
        "price": 10000000,
        "buyer": "Sportsystem Corp. (Jeremy Jacobs and brothers; Delaware North)",
        "seller": "Storer Broadcasting",
        "stakePct": 100,
        "notes": "Widely cited as about $10 million; Wikipedia confirms the Aug 1975 sale but not the price.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Boston_Bruins",
          "https://www.davemanuel.com/nhl-team-ownership-purchase-prices.php"
        ]
      }
    ]
  },
  "buffalo-sabres": {
    "formation": {
      "year": 1970,
      "price": 6000000,
      "founder": "Seymour H. Knox III and Northrup R. Knox",
      "notes": "1970 NHL expansion; 1970s expansion franchises paid $6 million.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1998,
        "price": null,
        "buyer": "John Rigas (Adelphia Communications)",
        "seller": "Northrup Knox / Knox group",
        "stakePct": null,
        "notes": "Sold during 1997-98 season after $32M in losses over three seasons; price not disclosed. NHL took control after Rigas's 2002 indictment.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Buffalo_Sabres",
          "https://en.wikipedia.org/wiki/John_Rigas"
        ]
      },
      {
        "year": 2003,
        "price": 92000000,
        "buyer": "Tom Golisano / Larry Quinn consortium",
        "seller": "NHL-controlled Rigas estate (bankruptcy)",
        "stakePct": 100,
        "notes": "Bought out of bankruptcy; $92M is from an aggregator, not confirmed by a primary source.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Tom_Golisano",
          "https://www.davemanuel.com/nhl-team-ownership-purchase-prices.php"
        ]
      },
      {
        "year": 2011,
        "price": 189000000,
        "buyer": "Terry and Kim Pegula",
        "seller": "Tom Golisano, Larry Quinn, Dan DiPofi",
        "stakePct": 100,
        "notes": "$175M plus $14M in assumed debt; included the NLL Buffalo Bandits. NHL approved Feb 18, 2011.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Buffalo_Sabres",
          "https://en.wikipedia.org/wiki/Terry_Pegula"
        ]
      }
    ]
  },
  "detroit-red-wings": {
    "formation": {
      "year": 1926,
      "price": null,
      "founder": "Townsend-Seyburn group (Charles A. Hughes, governor)",
      "notes": "Expansion Detroit Cougars. The NHL fee is not documented; the group separately paid $100,000 for the Victoria Cougars' players.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1932,
        "price": 100000,
        "buyer": "James E. Norris (with Arthur Wirtz)",
        "seller": "Receiver of Detroit Falcons / Olympia",
        "stakePct": 100,
        "notes": "Bought out of receivership with Olympia Stadium for $100,000 (Wirtz bio dates this 1933); renamed Red Wings.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arthur_Wirtz",
          "https://en.wikipedia.org/wiki/James_E._Norris"
        ]
      },
      {
        "year": 1952,
        "price": null,
        "buyer": "Marguerite Norris",
        "seller": "James E. Norris estate",
        "stakePct": null,
        "notes": "Inheritance: daughter took over as president after his death.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Detroit_Red_Wings"
        ]
      },
      {
        "year": 1955,
        "price": null,
        "buyer": "Bruce Norris",
        "seller": "Marguerite Norris",
        "stakePct": null,
        "notes": "Intra-family transfer; Bruce later bought out his sister's shares to become sole owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bruce_Norris_(ice_hockey)"
        ]
      },
      {
        "year": 1982,
        "price": 8000000,
        "buyer": "Mike Ilitch (Little Caesars)",
        "seller": "Bruce Norris",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mike_Ilitch",
          "https://en.wikipedia.org/wiki/Detroit_Red_Wings"
        ]
      },
      {
        "year": 2017,
        "price": null,
        "buyer": "Christopher Ilitch (Ilitch Holdings)",
        "seller": "Mike Ilitch estate",
        "stakePct": null,
        "notes": "Inheritance after Mike Ilitch's death in Feb 2017.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Detroit_Red_Wings"
        ]
      }
    ]
  },
  "florida-panthers": {
    "formation": {
      "year": 1992,
      "price": 50000000,
      "founder": "Wayne Huizenga",
      "notes": "Awarded Dec 10, 1992; $50M entry fee. Began play in 1993-94.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2001,
        "price": 100000000,
        "buyer": "Alan Cohen group (with Bernie Kosar)",
        "seller": "Wayne Huizenga",
        "stakePct": null,
        "notes": "Reported as about $100 million.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Wayne_Huizenga"
        ]
      },
      {
        "year": 2009,
        "price": null,
        "buyer": "Cliff Viner and Stu Siegel",
        "seller": "Alan Cohen group",
        "stakePct": null,
        "notes": "Became majority owners in Nov 2009; price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Florida_Panthers"
        ]
      },
      {
        "year": 2013,
        "price": 250000000,
        "buyer": "Vincent Viola (with Doug Cifu)",
        "seller": "Sunrise Sports & Entertainment (Viner/Siegel group)",
        "stakePct": null,
        "notes": "Purchased Sept 2013.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Vincent_Viola"
        ]
      }
    ]
  },
  "montreal-canadiens": {
    "formation": {
      "year": 1909,
      "price": null,
      "founder": "J. Ambrose O'Brien",
      "notes": "Founded as an NHA club in 1909; NHL founding member in 1917. No franchise fee recorded.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1911,
        "price": 7500,
        "buyer": "George Kennedy",
        "seller": "J. Ambrose O'Brien",
        "stakePct": 100,
        "notes": "$7,500 in Canadian dollars, which were near par with USD in 1911.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Montreal_Canadiens"
        ]
      },
      {
        "year": 1921,
        "price": null,
        "buyer": "Leo Dandurand, Joseph Cattarinich, Louis Letourneau",
        "seller": "Estate of George Kennedy",
        "stakePct": 100,
        "notes": "Kennedy's widow sold the team.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Montreal_Canadiens"
        ]
      },
      {
        "year": 1935,
        "price": 165000,
        "buyer": "Ernest Savard, Maurice Forget, Louis Gelinas syndicate (Canadian Arena Company interests)",
        "seller": "Leo Dandurand, Joseph Cattarinich",
        "stakePct": 100,
        "notes": "C$165,000 (CAD near par with USD in 1935). Ownership passed formally to the Canadian Arena Company in 1940.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Montreal_Maroons",
          "https://en.wikipedia.org/wiki/History_of_the_Montreal_Canadiens"
        ]
      },
      {
        "year": 1957,
        "price": null,
        "buyer": "Hartland Molson and Thomas H. P. Molson",
        "seller": "Canadian Arena Company (Donat Raymond)",
        "stakePct": null,
        "notes": "The Molson brothers bought the Canadian Arena Company (Forum and Canadiens); they owned it 1957-1964. Transfers between 1964 and 1971 are not documented in the sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Hartland_Molson",
          "https://en.wikipedia.org/wiki/Molson_family"
        ]
      },
      {
        "year": 1971,
        "price": null,
        "buyer": "Edward and Peter Bronfman",
        "seller": "Molson family",
        "stakePct": null,
        "notes": "The Bronfmans owned the club 1971-1978; price not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Edward_Bronfman"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "Molson Breweries",
        "seller": "Edward and Peter Bronfman",
        "stakePct": null,
        "notes": "Molson owned the Canadiens from 1978 to 2001.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Montreal_Canadiens"
        ]
      },
      {
        "year": 2001,
        "price": 185000000,
        "buyer": "George N. Gillett Jr.",
        "seller": "Molson Inc.",
        "stakePct": 80.1,
        "notes": "US$185M (reported as C$275M) for 80.1% of the team plus 100% of the Molson Centre.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/George_N._Gillett_Jr.",
          "https://en.wikipedia.org/wiki/History_of_the_Montreal_Canadiens"
        ]
      },
      {
        "year": 2009,
        "price": 505000000,
        "buyer": "Geoff, Andrew and Justin Molson consortium (with Woodbridge, BCE, FTQ, Andlauer and others)",
        "seller": "George N. Gillett Jr.",
        "stakePct": 100,
        "notes": "C$575M per the team page (C$550M per the Gillett bio) for the team, Bell Centre and Gillett Entertainment Group. Converted at about 0.88 USD/CAD (June 2009).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Montreal_Canadiens",
          "https://en.wikipedia.org/wiki/George_N._Gillett_Jr."
        ]
      }
    ]
  },
  "ottawa-senators": {
    "formation": {
      "year": 1990,
      "price": 50000000,
      "founder": "Bruce Firestone (Terrace Corporation)",
      "notes": "Awarded Dec 1990; US$50M franchise fee; began play in 1992-93.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1993,
        "price": null,
        "buyer": "Rod Bryden",
        "seller": "Bruce Firestone",
        "stakePct": null,
        "notes": "Bryden bought 50% of Terrace, then bought out Firestone in Aug 1993 to become majority owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Ottawa_Senators",
          "https://en.wikipedia.org/wiki/History_of_the_Ottawa_Senators_(since_1992)"
        ]
      },
      {
        "year": 2003,
        "price": 92000000,
        "buyer": "Eugene Melnyk",
        "seller": "Terrace / Rod Bryden (bankruptcy creditors)",
        "stakePct": 100,
        "notes": "US$92M (reported as C$130M), including the arena, bought out of bankruptcy.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Eugene_Melnyk",
          "https://en.wikipedia.org/wiki/Ottawa_Senators"
        ]
      },
      {
        "year": 2022,
        "price": null,
        "buyer": "Anna and Olivia Melnyk",
        "seller": "Eugene Melnyk estate",
        "stakePct": null,
        "notes": "Inheritance after Melnyk's death in March 2022; team then put up for sale.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Michael_Andlauer"
        ]
      },
      {
        "year": 2023,
        "price": 950000000,
        "buyer": "Michael Andlauer and investor group",
        "seller": "Melnyk estate (Anna and Olivia Melnyk)",
        "stakePct": 90,
        "notes": "Reported US$950M valuation; the Melnyk daughters kept 10%. Closed Sept 21, 2023.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Michael_Andlauer",
          "https://www.sportico.com/business/team-sales/2023/ottawa-senators-sale-michael-andlauer-1234724226/"
        ]
      }
    ]
  },
  "tampa-bay-lightning": {
    "formation": {
      "year": 1990,
      "price": 50000000,
      "founder": "Phil Esposito group (backed by Kokusai Green)",
      "notes": "Awarded Dec 6, 1990; $50M expansion fee paid up front; began play in 1992-93.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1998,
        "price": 117000000,
        "buyer": "Art Williams",
        "seller": "Kokusai Green",
        "stakePct": 100,
        "notes": "Team was $102M in debt at closing.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arthur_L._Williams_Jr.",
          "https://en.wikipedia.org/wiki/Tampa_Bay_Lightning"
        ]
      },
      {
        "year": 1999,
        "price": 115000000,
        "buyer": "Bill Davidson (Palace Sports & Entertainment)",
        "seller": "Art Williams",
        "stakePct": 100,
        "notes": "$115M per the team page; the Davidson bio says $100M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Tampa_Bay_Lightning",
          "https://en.wikipedia.org/wiki/Bill_Davidson_(businessman)"
        ]
      },
      {
        "year": 2008,
        "price": 206000000,
        "buyer": "OK Hockey LLC (Oren Koules and Len Barrie)",
        "seller": "Palace Sports & Entertainment",
        "stakePct": 100,
        "notes": "Agreement signed Feb 2008.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Oren_Koules",
          "https://en.wikipedia.org/wiki/Tampa_Bay_Lightning"
        ]
      },
      {
        "year": 2010,
        "price": 170000000,
        "buyer": "Jeffrey Vinik",
        "seller": "OK Hockey LLC (Koules/Barrie)",
        "stakePct": 100,
        "notes": "$170M per the Vinik bio; the Koules bio says $160M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Jeffrey_Vinik",
          "https://en.wikipedia.org/wiki/Oren_Koules"
        ]
      },
      {
        "year": 2024,
        "price": 1800000000,
        "buyer": "Doug Ostrover and Marc Lipschultz (Blue Owl co-founders) group",
        "seller": "Jeffrey Vinik / Vinik Sports Group",
        "stakePct": null,
        "notes": "Majority stake finalized Oct 24, 2024. The price is the reported 100% valuation; the exact stake was not disclosed. Vinik stays chairman/governor for a transition period.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jeffrey_Vinik",
          "https://www.sportico.com/business/team-sales/2026/nhl-approves-penguins-sale-hoffmann-family-1234936872/"
        ]
      }
    ]
  },
  "toronto-maple-leafs": {
    "formation": {
      "year": 1917,
      "price": null,
      "founder": "Toronto Arena Company",
      "notes": "Temporary NHL franchise at the league's founding in 1917. In 1919 the St. Patricks group bought the franchise and paid the NHL $5,000.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1919,
        "price": 5000,
        "buyer": "St. Patricks Hockey Club group",
        "seller": "Toronto Arena Company",
        "stakePct": 100,
        "notes": "The group paid $5,000 (CAD) to the NHL for the franchise; NHL approved Dec 13, 1919.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Toronto_Maple_Leafs"
        ]
      },
      {
        "year": 1927,
        "price": 160000,
        "buyer": "Conn Smythe syndicate",
        "seller": "Toronto St. Patricks owners",
        "stakePct": 100,
        "notes": "$75,000 up front plus $75,000 thirty days later, plus Smythe's own $10,000; about C$160,000 total (CAD near par). Smythe got majority control of Maple Leaf Gardens Ltd only in 1947.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Toronto_Maple_Leafs",
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 1961,
        "price": 2300000,
        "buyer": "Stafford Smythe, Harold Ballard, John Bassett",
        "seller": "Conn Smythe",
        "stakePct": null,
        "notes": "C$2.3M for 45,000 of Conn Smythe's 50,000 MLGL shares (control). CAD about 0.97-1.0 USD.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment",
          "https://en.wikipedia.org/wiki/Toronto_Maple_Leafs"
        ]
      },
      {
        "year": 1972,
        "price": 7500000,
        "buyer": "Harold Ballard",
        "seller": "Stafford Smythe estate",
        "stakePct": null,
        "notes": "Ballard bought Stafford's 251,545 shares for C$7.5M in Feb 1972, valuing MLGL at C$22M (CAD about par). Bassett had sold out in 1971 for C$5.4M.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 1994,
        "price": 91000000,
        "buyer": "MLG Ventures (Steve Stavro with TD Bank and Ontario Teachers' Pension Plan)",
        "seller": "Harold Ballard estate (60.3%) and Molson (19.9%)",
        "stakePct": 80.2,
        "notes": "C$75M for the estate's 60.3% (C$34/share, valuing MLGL at C$125M) plus C$25M for Molson's 19.9%. About US$73M total at ~0.73 USD/CAD; the price shown is the ~US$91M implied 100% valuation. Taken private in 1998.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2003,
        "price": null,
        "buyer": "Ontario Teachers' Pension Plan (58.4% controlling owner)",
        "seller": "Steve Stavro (stake sold to Bell Globemedia)",
        "stakePct": 58.4,
        "notes": "Restructuring: Stavro sold his stake to Bell Globemedia for a reported C$120-150M and Teachers' became controlling owner of MLSE.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2012,
        "price": 1320000000,
        "buyer": "Rogers Communications and BCE Inc. (joint 75%)",
        "seller": "Ontario Teachers' Pension Plan",
        "stakePct": 75,
        "notes": "C$1.32B for OTPP's stake (equity value C$1.66B; EV C$2B). CAD about parity with USD (Dec 2011-2012). Price is for all of MLSE (Leafs, Raptors, TFC, arena), not the Leafs alone. NHL approved June 19, 2012.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2025,
        "price": 3430000000,
        "buyer": "Rogers Communications (to 75%)",
        "seller": "BCE Inc. (37.5%)",
        "stakePct": 37.5,
        "notes": "C$4.7B for BCE's 37.5%, valuing MLSE at C$12.5B; about US$3.43B at ~0.73 USD/CAD. Rogers moved from joint control to sole majority control; closed July 2025. Multi-team MLSE entity. A separate 2026 Rogers purchase of Kilmer/Tanenbaum's 25% is a minority deal, not a control change.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Maple_Leaf_Sports_%26_Entertainment",
          "https://en.wikipedia.org/wiki/Toronto_Maple_Leafs"
        ]
      }
    ]
  },
  "carolina-hurricanes": {
    "formation": {
      "year": 1972,
      "price": null,
      "founder": "Howard Baldwin, W. Godfrey Wood, John Coburn, William Barnes (New England Whalers, WHA)",
      "notes": "WHA franchise awarded Nov 1971. It joined the NHL in 1979 as the Hartford Whalers with a $6M franchise fee, and moved to Carolina in 1997.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1988,
        "price": null,
        "buyer": "Local Hartford ownership",
        "seller": "Howard Baldwin group",
        "stakePct": null,
        "notes": "Baldwin was managing general partner until the team was sold to local ownership in 1988 (later Richard Gordon). Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Howard_Baldwin"
        ]
      },
      {
        "year": 1994,
        "price": 47500000,
        "buyer": "Peter Karmanos Jr., Thomas Thewes, Jim Rutherford",
        "seller": "Hartford Whalers owners (deal brokered by Connecticut Development Authority)",
        "stakePct": 100,
        "notes": "Relocated to North Carolina in 1997.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Peter_Karmanos_Jr.",
          "https://en.wikipedia.org/wiki/Hartford_Whalers"
        ]
      },
      {
        "year": 2018,
        "price": 420000000,
        "buyer": "Tom Dundon",
        "seller": "Peter Karmanos Jr.",
        "stakePct": 52,
        "notes": "$420M for 52% plus PNC Arena operating rights per the Dundon bio (the team page says 61%). Closed Jan 11, 2018. Dundon bought the remaining minority shares on June 30, 2021 (price undisclosed). A 2026 sale of 12.5% at a $2.66B valuation was a minority deal.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Thomas_Dundon",
          "https://en.wikipedia.org/wiki/Carolina_Hurricanes"
        ]
      }
    ]
  },
  "columbus-blue-jackets": {
    "formation": {
      "year": 1997,
      "price": 80000000,
      "founder": "John H. McConnell (Columbus Hockey Limited, with Nationwide)",
      "notes": "Awarded 1997, began play 2000-01. The $80M fee comes from an aggregator and matches the $80M paid in the same expansion round (Nashville).",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 2008,
        "price": null,
        "buyer": "John P. McConnell",
        "seller": "John H. McConnell estate",
        "stakePct": null,
        "notes": "Inheritance after the founder's death in 2008. Nationwide's later stake changes were minority moves, not control changes.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Columbus_Blue_Jackets"
        ]
      }
    ]
  },
  "new-jersey-devils": {
    "formation": {
      "year": 1974,
      "price": 6000000,
      "founder": "Kansas City Scouts ownership group",
      "notes": "Kansas City Scouts, 1974 expansion ($6M 1970s fee plus territorial fees); became the Colorado Rockies in 1976 and moved to New Jersey in 1982.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1976,
        "price": null,
        "buyer": "Jack Vickers group (Denver)",
        "seller": "Kansas City owners",
        "stakePct": null,
        "notes": "Relocated to Denver as the Colorado Rockies.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_New_Jersey_Devils",
          "https://en.wikipedia.org/wiki/Kansas_City_Scouts"
        ]
      },
      {
        "year": 1978,
        "price": null,
        "buyer": "Arthur Imperatore",
        "seller": "Jack Vickers",
        "stakePct": null,
        "notes": "Purchased July 12, 1978.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arthur_Imperatore_Sr."
        ]
      },
      {
        "year": 1981,
        "price": null,
        "buyer": "Peter Gilbert",
        "seller": "Arthur Imperatore",
        "stakePct": null,
        "notes": "NHL approved Feb 10, 1981.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Arthur_Imperatore_Sr."
        ]
      },
      {
        "year": 1982,
        "price": null,
        "buyer": "John McMullen group",
        "seller": "Peter Gilbert",
        "stakePct": null,
        "notes": "May 27, 1982; moved to New Jersey as the Devils. Price not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_New_Jersey_Devils"
        ]
      },
      {
        "year": 2000,
        "price": 175000000,
        "buyer": "Puck Holdings (YankeeNets affiliate)",
        "seller": "John McMullen",
        "stakePct": 100,
        "notes": "$175M ($176M per the main team page).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_New_Jersey_Devils",
          "https://en.wikipedia.org/wiki/New_Jersey_Devils"
        ]
      },
      {
        "year": 2004,
        "price": null,
        "buyer": "Jeff Vanderbeek",
        "seller": "Puck Holdings (YankeeNets)",
        "stakePct": null,
        "notes": "Minority owner Vanderbeek took control; price not documented in the sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jeffrey_Vanderbeek",
          "https://en.wikipedia.org/wiki/History_of_the_New_Jersey_Devils"
        ]
      },
      {
        "year": 2013,
        "price": 320000000,
        "buyer": "Josh Harris and David Blitzer (HBSE)",
        "seller": "Jeff Vanderbeek",
        "stakePct": 100,
        "notes": "Included Prudential Center operating rights; 'over $320 million'. Aug 15, 2013.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Josh_Harris_(businessman)",
          "https://en.wikipedia.org/wiki/New_Jersey_Devils"
        ]
      }
    ]
  },
  "new-york-islanders": {
    "formation": {
      "year": 1972,
      "price": 6000000,
      "founder": "Roy Boe",
      "notes": "$6M franchise fee plus a territorial fee to the Rangers ($5M per the Islanders page, about $4M per the Rangers page). Awarded Nov 8, 1971.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1978,
        "price": null,
        "buyer": "John O. Pickett",
        "seller": "Roy Boe",
        "stakePct": null,
        "notes": "Limited partner Pickett took over the financially distressed club.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/John_Pickett_(businessman)",
          "https://en.wikipedia.org/wiki/Roy_Boe"
        ]
      },
      {
        "year": 1998,
        "price": null,
        "buyer": "Howard Milstein and Steven Gluckstern group",
        "seller": "John Pickett",
        "stakePct": null,
        "notes": "Followed the collapsed 1996-97 John Spano purchase ($165M agreed; voided for fraud). Price not documented.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_New_York_Islanders",
          "https://en.wikipedia.org/wiki/John_Spano"
        ]
      },
      {
        "year": 2000,
        "price": 187500000,
        "buyer": "Charles Wang and Sanjay Kumar",
        "seller": "Milstein and Gluckstern",
        "stakePct": 100,
        "notes": "Wang later bought Kumar's share (2004).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/New_York_Islanders",
          "https://en.wikipedia.org/wiki/Charles_Wang"
        ]
      },
      {
        "year": 2016,
        "price": 485000000,
        "buyer": "Jon Ledecky and Scott D. Malkin",
        "seller": "Charles Wang",
        "stakePct": null,
        "notes": "Deal approved Oct 2014 at a reported ~$485M valuation. The buyers were minority owners during a two-year transition and took majority control in 2016.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Scott_D._Malkin",
          "https://en.wikipedia.org/wiki/Jon_Ledecky",
          "https://www.espn.com/new-york/nhl/story/_/id/11621147/new-york-islanders-sale-jonathan-ledecky-scott-malkin-approved"
        ]
      }
    ]
  },
  "new-york-rangers": {
    "formation": {
      "year": 1926,
      "price": null,
      "founder": "Tex Rickard / Madison Square Garden Corporation",
      "notes": "NHL franchise granted to Madison Square Garden in 1926; fee not documented.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1959,
        "price": 4000000,
        "buyer": "Graham-Paige Corporation",
        "seller": "James D. Norris and Arthur Wirtz",
        "stakePct": 40,
        "notes": "Bought the controlling 40% block of Madison Square Garden Corp (owner of the Rangers) for $4M.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports",
          "https://en.wikipedia.org/wiki/James_D._Norris"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "Gulf+Western (renamed Paramount Communications 1989)",
        "seller": "Madison Square Garden Corp shareholders",
        "stakePct": null,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_New_York_Rangers"
        ]
      },
      {
        "year": 1994,
        "price": null,
        "buyer": "Viacom (via acquisition of Paramount)",
        "seller": "Paramount Communications",
        "stakePct": null,
        "notes": "Corporate acquisition of the parent company.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports"
        ]
      },
      {
        "year": 1995,
        "price": null,
        "buyer": "ITT Corporation and Cablevision (50/50)",
        "seller": "Viacom",
        "stakePct": 100,
        "notes": "MSG (arena, Knicks, Rangers) sold; price not confirmed in the sources reviewed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports",
          "https://en.wikipedia.org/wiki/History_of_the_New_York_Rangers"
        ]
      },
      {
        "year": 1997,
        "price": 650000000,
        "buyer": "Cablevision (Dolan family)",
        "seller": "ITT Corporation",
        "stakePct": 50,
        "notes": "ITT's 50% of MSG for $650M. Later spin-offs (MSG 2010, MSG Sports 2015/2020) kept Dolan control.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Madison_Square_Garden_Sports"
        ]
      }
    ]
  },
  "philadelphia-flyers": {
    "formation": {
      "year": 1966,
      "price": 2000000,
      "founder": "Ed Snider, Jerry Wolman, Bill Putnam, Jerome Schiff",
      "notes": "1967 expansion; $2M fee. Conditional franchise awarded Feb 8, 1966.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1967,
        "price": null,
        "buyer": "Ed Snider (with Bill Putnam and Joe Scott)",
        "seller": "Jerry Wolman",
        "stakePct": null,
        "notes": "Wolman sold his Flyers interest; Snider became majority owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jerry_Wolman",
          "https://en.wikipedia.org/wiki/Ed_Snider"
        ]
      },
      {
        "year": 1996,
        "price": null,
        "buyer": "Comcast (Comcast Spectacor)",
        "seller": "Ed Snider / Spectacor",
        "stakePct": 66,
        "notes": "66% of Snider's businesses (63% per the Comcast Spectacor page). Comcast bought the remaining 24% in Sept 2016 after Snider's death.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Comcast_Spectacor",
          "https://en.wikipedia.org/wiki/Ed_Snider"
        ]
      }
    ]
  },
  "pittsburgh-penguins": {
    "formation": {
      "year": 1966,
      "price": 2000000,
      "founder": "Jack McGregor and Peter Block group",
      "notes": "1967 expansion; $2M fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1971,
        "price": null,
        "buyer": "Tad Potter partnership (with Peter Block)",
        "seller": "Prior owners",
        "stakePct": null,
        "notes": "Bought to keep the team in Pittsburgh.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tad_Potter"
        ]
      },
      {
        "year": 1975,
        "price": 3800000,
        "buyer": "Al Savill, Wren Blair, Otto Frenzel",
        "seller": "Potter/Block group (bankruptcy)",
        "stakePct": 100,
        "notes": "Bought out of bankruptcy (Wren Blair bio dates it 1973).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tad_Potter",
          "https://en.wikipedia.org/wiki/Wren_Blair"
        ]
      },
      {
        "year": 1977,
        "price": null,
        "buyer": "Edward J. DeBartolo Sr. family",
        "seller": "Savill/Blair/Frenzel",
        "stakePct": null,
        "notes": "Owned Feb 1977 - Nov 1991.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Edward_J._DeBartolo_Sr."
        ]
      },
      {
        "year": 1991,
        "price": null,
        "buyer": "Howard Baldwin, Morris Belzberg, Tom Ruta group",
        "seller": "DeBartolo family",
        "stakePct": null,
        "notes": "Nov 1991, after the first Stanley Cup.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Edward_J._DeBartolo_Sr.",
          "https://en.wikipedia.org/wiki/Morris_Belzberg"
        ]
      },
      {
        "year": 1997,
        "price": 40000000,
        "buyer": "Roger Marino",
        "seller": "Morris Belzberg (interest)",
        "stakePct": null,
        "notes": "Wikipedia says Marino bought a '100% stake' for $40M, but Baldwin remained a co-owner. Treat the stake and price as uncertain.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Roger_Marino",
          "https://en.wikipedia.org/wiki/Morris_Belzberg"
        ]
      },
      {
        "year": 1999,
        "price": null,
        "buyer": "Mario Lemieux group (with Ron Burkle)",
        "seller": "Baldwin/Marino (bankruptcy estate)",
        "stakePct": null,
        "notes": "Out of bankruptcy: Lemieux converted $20M of deferred salary to equity plus $5M cash for control. Total deal value not confirmed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mario_Lemieux"
        ]
      },
      {
        "year": 2021,
        "price": 900000000,
        "buyer": "Fenway Sports Group",
        "seller": "Mario Lemieux and Ron Burkle",
        "stakePct": null,
        "notes": "Controlling stake; took over Dec 31, 2021. Lemieux and Burkle kept minority stakes.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Fenway_Sports_Group",
          "https://www.nhl.com/news/pittsburgh-penguins-sale-unanimously-approved-nhl-commissioner-gary-bettman-says"
        ]
      },
      {
        "year": 2026,
        "price": 1700000000,
        "buyer": "Hoffmann Family of Companies (Geoff Hoffmann, governor)",
        "seller": "Fenway Sports Group",
        "stakePct": null,
        "notes": "Agreed Dec 2025; NHL Board of Governors approved unanimously in June 2026. $1.7B enterprise value (Bettman: total transaction cost about $1.75B); expected to close before the 2026 draft.",
        "isEstimated": false,
        "sources": [
          "https://www.nhl.com/news/pittsburgh-penguins-sale-unanimously-approved-nhl-commissioner-gary-bettman-says",
          "https://www.sportico.com/business/team-sales/2026/nhl-approves-penguins-sale-hoffmann-family-1234936872/",
          "https://www.cbsnews.com/pittsburgh/news/nhl-approves-sale-of-penguins-to-hoffmann-family/"
        ]
      }
    ]
  },
  "washington-capitals": {
    "formation": {
      "year": 1972,
      "price": 6000000,
      "founder": "Abe Pollin",
      "notes": "Awarded June 8, 1972; began play 1974-75; 1970s expansion fee was $6M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1999,
        "price": 200000000,
        "buyer": "Ted Leonsis (Lincoln Holdings)",
        "seller": "Abe Pollin",
        "stakePct": 100,
        "notes": "About $200M for the Capitals plus minority stakes in the Wizards and arena. Leonsis later added the Wizards/arena (2010) under Monumental.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Abe_Pollin",
          "https://en.wikipedia.org/wiki/Ted_Leonsis"
        ]
      }
    ]
  },
  "utah-hockey-club": {
    "formation": {
      "year": 2024,
      "price": 1200000000,
      "founder": "Ryan Smith / Smith Entertainment Group",
      "notes": "Treated by the NHL as a new franchise: Smith paid a $1.2B expansion fee, and the NHL paid Alex Meruelo $1B for the deactivated Arizona Coyotes. The $200M difference is effectively a relocation fee. Hockey assets came from the Coyotes. Renamed Utah Mammoth in 2025.",
      "isEstimated": false
    },
    "saleHistory": []
  },
  "chicago-blackhawks": {
    "formation": {
      "year": 1926,
      "price": null,
      "founder": "Frederic McLaughlin",
      "notes": "Franchise awarded May 1926 to a Huntington Hardwick syndicate, which resold it to McLaughlin on June 1, 1926. Fee not documented; $100,000 was paid for the Portland Rosebuds' players.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1946,
        "price": null,
        "buyer": "Bill Tobin syndicate (fronted for James E. Norris)",
        "seller": "Frederic McLaughlin estate",
        "stakePct": null,
        "notes": "McLaughlin died Dec 1944.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Blackhawks",
          "https://en.wikipedia.org/wiki/James_E._Norris"
        ]
      },
      {
        "year": 1950,
        "price": null,
        "buyer": "James D. Norris and Arthur Wirtz",
        "seller": "Tobin/Norris syndicate",
        "stakePct": null,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Chicago_Blackhawks",
          "https://en.wikipedia.org/wiki/James_D._Norris"
        ]
      },
      {
        "year": 1966,
        "price": null,
        "buyer": "Arthur Wirtz and Bill Wirtz",
        "seller": "James D. Norris estate",
        "stakePct": null,
        "notes": "Wirtz gained outright ownership after Norris's death.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Rocky_Wirtz",
          "https://en.wikipedia.org/wiki/Chicago_Blackhawks"
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Bill Wirtz",
        "seller": "Arthur Wirtz estate",
        "stakePct": null,
        "notes": "Inheritance.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Rocky_Wirtz"
        ]
      },
      {
        "year": 2007,
        "price": null,
        "buyer": "Rocky Wirtz",
        "seller": "Bill Wirtz estate",
        "stakePct": null,
        "notes": "Inheritance (Bill died Sept 2007).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Wirtz"
        ]
      },
      {
        "year": 2023,
        "price": null,
        "buyer": "Danny Wirtz",
        "seller": "Rocky Wirtz estate",
        "stakePct": null,
        "notes": "Inheritance.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Wirtz",
          "https://en.wikipedia.org/wiki/Danny_Wirtz"
        ]
      }
    ]
  },
  "colorado-avalanche": {
    "formation": {
      "year": 1972,
      "price": null,
      "founder": "Quebec Nordiques founders (WHA)",
      "notes": "WHA Quebec Nordiques; joined the NHL in 1979 with a $6M franchise fee. Owned by Carling O'Keefe in the late 1970s/1980s (Marcel Aubut, president).",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1995,
        "price": 75000000,
        "buyer": "COMSAT Entertainment Group (later Ascent Entertainment)",
        "seller": "Nordiques ownership (Marcel Aubut group)",
        "stakePct": 100,
        "notes": "Relocated to Denver. The $75M figure is from an aggregator.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Colorado_Avalanche",
          "https://www.davemanuel.com/nhl-team-ownership-purchase-prices.php"
        ]
      },
      {
        "year": 2000,
        "price": null,
        "buyer": "Liberty Media",
        "seller": "COMSAT / Ascent shareholders",
        "stakePct": null,
        "notes": "Liberty bought all of Ascent but kept the teams on the market.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Colorado_Avalanche"
        ]
      },
      {
        "year": 2000,
        "price": 450000000,
        "buyer": "Stan Kroenke (Kroenke Sports & Entertainment)",
        "seller": "Liberty Media / Ascent",
        "stakePct": 93.5,
        "notes": "July 2000 package: Avalanche, Nuggets and Pepsi Center for $450M; Liberty kept 6.5%. Ownership was transferred to Ann Walton Kroenke in 2015 (NFL cross-ownership rule).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Colorado_Avalanche",
          "https://en.wikipedia.org/wiki/Kroenke_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "dallas-stars": {
    "formation": {
      "year": 1966,
      "price": 2000000,
      "founder": "Walter Bush group (Minnesota North Stars)",
      "notes": "1967 expansion; $2M fee. Moved to Dallas in 1993.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1978,
        "price": null,
        "buyer": "George Gund III and Gordon Gund",
        "seller": "North Stars owners",
        "stakePct": null,
        "notes": "North Stars merged with the Gunds' Cleveland Barons; the Gunds became majority owners.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Minnesota_North_Stars",
          "https://en.wikipedia.org/wiki/Gordon_Gund"
        ]
      },
      {
        "year": 1990,
        "price": 38100000,
        "buyer": "Howard Baldwin and Morris Belzberg",
        "seller": "George and Gordon Gund",
        "stakePct": 100,
        "notes": "About $38.1M including liabilities and the Gunds' share of future expansion fees. The Gunds received the San Jose expansion team.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Minnesota_North_Stars"
        ]
      },
      {
        "year": 1990,
        "price": null,
        "buyer": "Norman Green",
        "seller": "Baldwin and Belzberg",
        "stakePct": 51,
        "notes": "Green bought 51% control, then Baldwin's share, and became sole owner by Oct 1990.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Minnesota_North_Stars",
          "https://en.wikipedia.org/wiki/Norman_Green"
        ]
      },
      {
        "year": 1995,
        "price": 82000000,
        "buyer": "Tom Hicks",
        "seller": "Norman Green",
        "stakePct": 100,
        "notes": "Dec 1995, closed early 1996. $82M per the Hicks bio (the aggregator says $84M).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Tom_Hicks",
          "https://en.wikipedia.org/wiki/Norman_Green"
        ]
      },
      {
        "year": 2011,
        "price": 240000000,
        "buyer": "Tom Gaglardi (Northland Properties)",
        "seller": "Hicks Sports Group creditors (bankruptcy auction)",
        "stakePct": 100,
        "notes": "Enterprise value approved by the bankruptcy court; NHL approved Nov 18, 2011.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Dallas_Stars"
        ]
      }
    ]
  },
  "minnesota-wild": {
    "formation": {
      "year": 1997,
      "price": 80000000,
      "founder": "Bob Naegele Jr.",
      "notes": "Awarded 1997, began play 2000-01. $80M fee per an aggregator; consistent with the 1997 expansion round.",
      "isEstimated": true
    },
    "saleHistory": [
      {
        "year": 2008,
        "price": 260000000,
        "buyer": "Craig Leipold (Minnesota Sports & Entertainment)",
        "seller": "Bob Naegele Jr. group",
        "stakePct": null,
        "notes": "Announced Jan 10, 2008. The price is from an aggregator.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Minnesota_Wild",
          "https://www.davemanuel.com/nhl-team-ownership-purchase-prices.php"
        ]
      }
    ]
  },
  "nashville-predators": {
    "formation": {
      "year": 1997,
      "price": 80000000,
      "founder": "Craig Leipold",
      "notes": "Awarded 1997, began play 1998-99; $80M fee (city paid 31.5%).",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2007,
        "price": 193000000,
        "buyer": "Predators Holdings LLC (local investor group incl. David Freeman, Boots Del Biaggio)",
        "seller": "Craig Leipold",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Nashville_Predators",
          "https://en.wikipedia.org/wiki/Craig_Leipold"
        ]
      },
      {
        "year": 2025,
        "price": null,
        "buyer": "Bill Haslam",
        "seller": "Predators Holdings LLC partners",
        "stakePct": null,
        "notes": "Four-tranche purchase agreed 2022 at climbing enterprise values from under $775M to over $900M. Haslam became chairman July 2024 and majority owner July 3, 2025. Price per tranche not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://www.sportico.com/leagues/hockey/2022/nashville-predators-valued-775-million-sale-haslam-1234692987/",
          "https://www.sportspro.com/news/nashville-predators-nhl-bill-haslam-majority-stake-acquisition-deal/"
        ]
      }
    ]
  },
  "st-louis-blues": {
    "formation": {
      "year": 1966,
      "price": 2000000,
      "founder": "Sid Salomon Jr., Sid Salomon III, Robert Wolfson",
      "notes": "1967 expansion; $2M fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1977,
        "price": null,
        "buyer": "Ralston Purina",
        "seller": "Salomon family",
        "stakePct": 100,
        "notes": "Ralston took the team, arena and $8.8M of debt (July 27, 1977).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/St._Louis_Blues"
        ]
      },
      {
        "year": 1983,
        "price": null,
        "buyer": "Harry Ornest group",
        "seller": "Ralston Purina",
        "stakePct": 100,
        "notes": "After the NHL rejected a C$12M sale to Bill Hunter (Saskatoon).",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/St._Louis_Blues",
          "https://en.wikipedia.org/wiki/Harry_Ornest"
        ]
      },
      {
        "year": 1986,
        "price": null,
        "buyer": "Michael Shanahan group",
        "seller": "Harry Ornest",
        "stakePct": null,
        "notes": "Dec 1986.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Mike_Shanahan_(ice_hockey)"
        ]
      },
      {
        "year": 1999,
        "price": 153000000,
        "buyer": "Bill and Nancy Walton Laurie",
        "seller": "Kiel Center Partners / Shanahan group",
        "stakePct": null,
        "notes": "US$153M per the Bill Laurie bio.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bill_Laurie",
          "https://en.wikipedia.org/wiki/St._Louis_Blues"
        ]
      },
      {
        "year": 2006,
        "price": null,
        "buyer": "SCP Worldwide (Dave Checketts) and TowerBrook Capital",
        "seller": "Bill and Nancy Laurie",
        "stakePct": null,
        "notes": "Completed Mar 24, 2006; included the arena lease.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/St._Louis_Blues"
        ]
      },
      {
        "year": 2012,
        "price": 130000000,
        "buyer": "SLB Acquisition Holdings LLC (Tom Stillman, chairman)",
        "seller": "SCP Worldwide",
        "stakePct": null,
        "notes": "Included the Peoria Rivermen, arena lease and a Stifel Theatre stake.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/SLB_Acquisition_Holdings_LLC"
        ]
      }
    ]
  },
  "winnipeg-jets": {
    "formation": {
      "year": 1997,
      "price": null,
      "founder": "Ted Turner / Turner Broadcasting (Time Warner) - Atlanta Thrashers",
      "notes": "Atlanta Thrashers expansion (awarded 1997, began play 1999). The fee is not confirmed in the sources reviewed. The original Winnipeg Jets (1972-96) are a different franchise, now defunct as the Arizona Coyotes.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2004,
        "price": null,
        "buyer": "Atlanta Spirit LLC",
        "seller": "Time Warner (Turner Broadcasting)",
        "stakePct": 100,
        "notes": "Package with the Hawks and arena operating rights.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Thrashers",
          "https://en.wikipedia.org/wiki/Atlanta_Hawks,_LLC"
        ]
      },
      {
        "year": 2011,
        "price": 170000000,
        "buyer": "True North Sports & Entertainment (Mark Chipman, David Thomson)",
        "seller": "Atlanta Spirit LLC",
        "stakePct": 100,
        "notes": "$170M including a $60M relocation fee to the NHL; moved to Winnipeg. NHL approved June 21, 2011.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Winnipeg_Jets",
          "https://en.wikipedia.org/wiki/True_North_Sports_%26_Entertainment"
        ]
      }
    ]
  },
  "anaheim-ducks": {
    "formation": {
      "year": 1993,
      "price": 50000000,
      "founder": "The Walt Disney Company",
      "notes": "Awarded Dec 1992; $50M entrance fee, half paid to the LA Kings.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2005,
        "price": 75000000,
        "buyer": "Henry and Susan Samueli",
        "seller": "The Walt Disney Company",
        "stakePct": 100,
        "notes": "",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Anaheim_Ducks",
          "https://en.wikipedia.org/wiki/Henry_Samueli"
        ]
      }
    ]
  },
  "calgary-flames": {
    "formation": {
      "year": 1972,
      "price": 6000000,
      "founder": "Tom Cousins (Atlanta Flames)",
      "notes": "1972 expansion; the 1970s fee was $6M.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1980,
        "price": 16000000,
        "buyer": "Nelson Skalbania-led Calgary group (Seamans, Hotchkiss, Scurfield, Green, Kwong)",
        "seller": "Tom Cousins",
        "stakePct": 100,
        "notes": "A record NHL price at the time; relocated to Calgary. Skalbania later sold his interest. Controlling-shareholder changes within the Calgary group (e.g., N. Murray Edwards) are not documented with prices.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Atlanta_Flames",
          "https://en.wikipedia.org/wiki/Daryl_Seaman",
          "https://en.wikipedia.org/wiki/Tom_Cousins"
        ]
      }
    ]
  },
  "edmonton-oilers": {
    "formation": {
      "year": 1972,
      "price": null,
      "founder": "Bill Hunter (with Charles Allard) - Alberta Oilers (WHA)",
      "notes": "WHA charter team; joined the NHL in 1979 with a $6M franchise fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1976,
        "price": null,
        "buyer": "Nelson Skalbania, then Peter Pocklington",
        "seller": "Bill Hunter and Charles Allard",
        "stakePct": null,
        "notes": "Skalbania bought in 1976 and quickly brought in Pocklington, who became sole owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/History_of_the_Edmonton_Oilers",
          "https://en.wikipedia.org/wiki/Peter_Pocklington"
        ]
      },
      {
        "year": 1998,
        "price": 75000000,
        "buyer": "Edmonton Investors Group",
        "seller": "Peter Pocklington",
        "stakePct": 100,
        "notes": "C$107M per the EIG page (the team page says $70M); converted at about 0.70 USD/CAD (1998).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Edmonton_Investors_Group",
          "https://en.wikipedia.org/wiki/Edmonton_Oilers"
        ]
      },
      {
        "year": 2008,
        "price": 195000000,
        "buyer": "Daryl Katz (Katz Group)",
        "seller": "Edmonton Investors Group",
        "stakePct": 100,
        "notes": "Reported C$200M; converted at about 0.98 USD/CAD (June 2008). NHL approved June 18, 2008.",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Edmonton_Investors_Group",
          "https://en.wikipedia.org/wiki/Daryl_Katz"
        ]
      }
    ]
  },
  "los-angeles-kings": {
    "formation": {
      "year": 1966,
      "price": 2000000,
      "founder": "Jack Kent Cooke",
      "notes": "1967 expansion; $2M fee plus a $1M territorial indemnity to the Blades.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1979,
        "price": 67500000,
        "buyer": "Jerry Buss",
        "seller": "Jack Kent Cooke",
        "stakePct": 100,
        "notes": "Package: Lakers, Kings, Forum and a ranch; half cash, half real estate.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Jack_Kent_Cooke",
          "https://en.wikipedia.org/wiki/Jerry_Buss"
        ]
      },
      {
        "year": 1988,
        "price": null,
        "buyer": "Bruce McNall",
        "seller": "Jerry Buss",
        "stakePct": null,
        "notes": "McNall bought 25% (1986) and 24% (1987), then controlling interest in 1988.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bruce_McNall",
          "https://en.wikipedia.org/wiki/Jerry_Buss"
        ]
      },
      {
        "year": 1994,
        "price": null,
        "buyer": "New investor group",
        "seller": "Bruce McNall",
        "stakePct": null,
        "notes": "McNall sold controlling interest in May 1994 after defaulting on a $90M loan; the team entered bankruptcy in 1995.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Bruce_McNall"
        ]
      },
      {
        "year": 1995,
        "price": 113500000,
        "buyer": "Philip Anschutz and Edward P. Roski",
        "seller": "Kings (bankruptcy estate)",
        "stakePct": 100,
        "notes": "Bankruptcy court approved Oct 6, 1995; AEG/Anschutz later principal owner.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Los_Angeles_Kings"
        ]
      }
    ]
  },
  "san-jose-sharks": {
    "formation": {
      "year": 1990,
      "price": 45000000,
      "founder": "George Gund III and Gordon Gund",
      "notes": "Expansion fee of US$45M; approved May 1990 alongside the Gunds' sale of the North Stars; began play 1991-92.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2002,
        "price": null,
        "buyer": "San Jose Sports & Entertainment Enterprises (local investors led by Greg Jamison; incl. Hasso Plattner)",
        "seller": "Gund brothers",
        "stakePct": null,
        "notes": "Feb 2002.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/San_Jose_Sharks",
          "https://en.wikipedia.org/wiki/Gordon_Gund"
        ]
      },
      {
        "year": 2013,
        "price": null,
        "buyer": "Hasso Plattner",
        "seller": "Two SJS&E partners",
        "stakePct": null,
        "notes": "Plattner bought out two partners and became the controlling owner/governor.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Hasso_Plattner"
        ]
      }
    ]
  },
  "seattle-kraken": {
    "formation": {
      "year": 2018,
      "price": 650000000,
      "founder": "Seattle Hockey Partners (David Bonderman, Jerry Bruckheimer, Tod Leiweke)",
      "notes": "Approved Dec 2018; $650M fee, final installment paid Apr 30, 2021; began play 2021-22.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 2024,
        "price": null,
        "buyer": "Samantha Holloway (principal owner, governor)",
        "seller": "David Bonderman estate",
        "stakePct": null,
        "notes": "Inheritance/transfer after Bonderman's death on Dec 11, 2024; Holloway had been co-owner since 2022.",
        "isEstimated": false,
        "sources": [
          "https://www.seattletimes.com/sports/kraken/seattle-kraken-owner-david-bonderman-dies-at-82/",
          "https://www.nhl.com/news/david-bonderman-dead-at-age-82"
        ]
      }
    ]
  },
  "vancouver-canucks": {
    "formation": {
      "year": 1970,
      "price": 6000000,
      "founder": "Tom Scallen / Medicor (Minnesota)",
      "notes": "1970 expansion; $6M fee.",
      "isEstimated": false
    },
    "saleHistory": [
      {
        "year": 1974,
        "price": 9000000,
        "buyer": "Frank Griffiths (Northwest Sports)",
        "seller": "Tom Scallen / Medicor",
        "stakePct": 100,
        "notes": "$9M (currency not specified; CAD was near par with USD in 1974).",
        "isEstimated": true,
        "sources": [
          "https://en.wikipedia.org/wiki/Vancouver_Canucks",
          "https://en.wikipedia.org/wiki/History_of_the_Vancouver_Canucks"
        ]
      },
      {
        "year": 1996,
        "price": null,
        "buyer": "John McCaw Jr. (Orca Bay)",
        "seller": "Arthur Griffiths",
        "stakePct": null,
        "notes": "McCaw partnered in 1995 and took a majority share by about 1996-97.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Vancouver_Canucks",
          "https://en.wikipedia.org/wiki/Canucks_Sports_%26_Entertainment"
        ]
      },
      {
        "year": 2006,
        "price": null,
        "buyer": "Francesco Aquilini (Aquilini Investment Group)",
        "seller": "John McCaw Jr.",
        "stakePct": 100,
        "notes": "Aquilini bought 50% (Nov 17, 2004) then the remaining 50% (Nov 8, 2006); prices not disclosed.",
        "isEstimated": false,
        "sources": [
          "https://en.wikipedia.org/wiki/Francesco_Aquilini",
          "https://en.wikipedia.org/wiki/Vancouver_Canucks"
        ]
      }
    ]
  },
  "vegas-golden-knights": {
    "formation": {
      "year": 2016,
      "price": 500000000,
      "founder": "Bill Foley (Black Knight Sports & Entertainment)",
      "notes": "Approved June 22, 2016; $500M fee; began play 2017-18.",
      "isEstimated": false
    },
    "saleHistory": []
  }
}
